// -- (function(scope){
// -- 'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.aY.an === region.bn.an)
	{
		return 'on line ' + region.aY.an;
	}
	return 'on lines ' + region.aY.an + ' through ' + region.bn.an;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cS,
		impl.dG,
		impl.dA,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


/*
function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/


/*
function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		cZ: func(record.cZ),
		aZ: record.aZ,
		aT: record.aT
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.cZ;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.aZ;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.aT) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cS,
		impl.dG,
		impl.dA,
		function(sendToApp, initialModel) {
			var view = impl.dJ;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cS,
		impl.dG,
		impl.dA,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.aW && impl.aW(sendToApp)
			var view = impl.dJ;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.cs);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.dE) && (_VirtualDom_doc.title = title = doc.dE);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.df;
	var onUrlRequest = impl.dg;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		aW: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.bV === next.bV
							&& curr.bx === next.bx
							&& curr.bS.a === next.bS.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		cS: function(flags)
		{
			return A3(impl.cS, flags, _Browser_getUrl(), key);
		},
		dJ: impl.dJ,
		dG: impl.dG,
		dA: impl.dA
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { cO: 'hidden', cv: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { cO: 'mozHidden', cv: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { cO: 'msHidden', cv: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { cO: 'webkitHidden', cv: 'webkitvisibilitychange' }
		: { cO: 'hidden', cv: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		b$: _Browser_getScene(),
		ci: {
			h: _Browser_window.pageXOffset,
			i: _Browser_window.pageYOffset,
			cm: _Browser_doc.documentElement.clientWidth,
			bw: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		cm: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bw: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			b$: {
				cm: node.scrollWidth,
				bw: node.scrollHeight
			},
			ci: {
				h: node.scrollLeft,
				i: node.scrollTop,
				cm: node.clientWidth,
				bw: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			b$: _Browser_getScene(),
			ci: {
				h: x,
				i: y,
				cm: _Browser_doc.documentElement.clientWidth,
				bw: _Browser_doc.documentElement.clientHeight
			},
			bl: {
				h: x + rect.left,
				i: y + rect.top,
				cm: rect.width,
				bw: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $author$project$Model$LinkClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$UrlChanged = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.m) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.p),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.p);
		} else {
			var treeLen = builder.m * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.q) : builder.q;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.m);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.p) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.p);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{q: nodeList, m: (len / $elm$core$Array$branchFactor) | 0, p: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {bs: fragment, bx: host, bO: path, bS: port_, bV: protocol, bW: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Service$Entitlement$Free = {$: 0};
var $author$project$Service$Entitlement$NotStarted = {$: 0};
var $author$project$Model$SessionUnknown = {$: 0};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Model$defaultProgress = {bq: $elm$core$Set$empty, bD: $elm$core$Maybe$Nothing, bE: 0, b1: _List_Nil, b6: 0, cd: 0, ce: 0};
var $author$project$Model$defaultSoundtrack = {bm: true, bF: 1.0, cj: 0.02};
var $author$project$Model$FormReady = {$: 0};
var $author$project$Model$emptyLoginForm = {aa: '', ay: '', N: $author$project$Model$FormReady};
var $author$project$Model$ResetHidden = 0;
var $author$project$Model$emptyResetForm = {bd: '', aa: '', bI: '', aC: 0, N: $author$project$Model$FormReady};
var $author$project$Model$AwaitingCredentials = 0;
var $author$project$Model$emptySignupForm = {aa: '', br: '', ay: '', aC: 0, N: $author$project$Model$FormReady, ch: ''};
var $author$project$Routing$NotFound = {$: 10};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {S: frag, U: params, O: unvisited, I: value, Y: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.O;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.I);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.I);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.bO),
					$elm$url$Url$Parser$prepareQuery(url.bW),
					url.bs,
					$elm$core$Basics$identity)));
	});
var $author$project$Routing$About = {$: 1};
var $author$project$Routing$Compass = {$: 5};
var $author$project$Routing$Landing = {$: 0};
var $author$project$Routing$Login = {$: 3};
var $author$project$Routing$Onboarding = {$: 2};
var $author$project$Routing$PaywallLab = {$: 9};
var $author$project$Routing$Player = function (a) {
	return {$: 6, a: a};
};
var $author$project$Routing$Progress = {$: 7};
var $author$project$Routing$Settings = {$: 8};
var $author$project$Routing$Signup = {$: 4};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.Y;
		var unvisited = _v0.O;
		var params = _v0.U;
		var frag = _v0.S;
		var value = _v0.I;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.Y;
			var unvisited = _v1.O;
			var params = _v1.U;
			var frag = _v1.S;
			var value = _v1.I;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.Y;
		var unvisited = _v0.O;
		var params = _v0.U;
		var frag = _v0.S;
		var value = _v0.I;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.Y;
			var unvisited = _v0.O;
			var params = _v0.U;
			var frag = _v0.S;
			var value = _v0.I;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Routing$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Routing$Landing, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$About,
			$elm$url$Url$Parser$s('about')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Onboarding,
			$elm$url$Url$Parser$s('onboarding')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Login,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Signup,
			$elm$url$Url$Parser$s('signup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Compass,
			$elm$url$Url$Parser$s('app')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Progress,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('app'),
				$elm$url$Url$Parser$s('progress'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('app'),
				$elm$url$Url$Parser$s('settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$PaywallLab,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('app'),
				$elm$url$Url$Parser$s('paywall-lab'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Player,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('app'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('play'),
					$elm$url$Url$Parser$string)))
		]));
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Routing$fromUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Routing$NotFound,
		A2($elm$url$Url$Parser$parse, $author$project$Routing$parser, url));
};
var $author$project$Model$NotDragging = {$: 0};
var $author$project$Model$initialCompass = {a6: true, a9: 0, ba: 0, bk: $author$project$Model$NotDragging, bZ: 0};
var $author$project$Model$GuideUnknown = 0;
var $author$project$Model$initialGuide = {N: 0, b5: 0};
var $author$project$Model$initialOnboarding = {b3: 0};
var $author$project$Model$AudioLoading = {$: 1};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Service$MeditationData$Air = 1;
var $author$project$Service$MeditationData$AllChakras = 7;
var $author$project$Service$MeditationData$Crown = 6;
var $author$project$Service$MeditationData$Earth = 3;
var $author$project$Service$MeditationData$Ether = 4;
var $author$project$Service$MeditationData$Fire = 2;
var $author$project$Service$MeditationData$Heart = 3;
var $author$project$Service$MeditationData$Root = 0;
var $author$project$Service$MeditationData$Sacral = 1;
var $author$project$Service$MeditationData$SolarPlexus = 2;
var $author$project$Service$MeditationData$ThirdEye = 5;
var $author$project$Service$MeditationData$Throat = 4;
var $author$project$Service$MeditationData$Water = 0;
var $author$project$Service$MeditationData$MeditationId = $elm$core$Basics$identity;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Service$MeditationData$isFreeId = function (_v0) {
	var raw = _v0;
	return A2(
		$elm$core$List$member,
		raw,
		_List_fromArray(
			['1', '2', '3', '4']));
};
var $author$project$Service$MeditationData$pad = function (raw) {
	return ($elm$core$String$length(raw) === 1) ? ('0' + raw) : raw;
};
var $author$project$Service$MeditationData$med = F8(
	function (rawId, name, description, color, angle, element, chakra, slug) {
		return {
			a3: angle,
			aG: 'audio/' + ($author$project$Service$MeditationData$pad(rawId) + ('-' + (slug + '.mp3'))),
			bb: chakra,
			be: color,
			bi: description,
			bl: element,
			cP: rawId,
			bz: $author$project$Service$MeditationData$isFreeId(rawId),
			bG: name
		};
	});
var $author$project$Service$MeditationData$all = _List_fromArray(
	[
		A8($author$project$Service$MeditationData$med, '1', 'Love', 'Open your heart to unconditional love', '#FB7185', 0, 0, 3, 'love'),
		A8($author$project$Service$MeditationData$med, '2', 'Peace', 'Find deep inner tranquility', '#60A5FA', 90, 1, 6, 'peace'),
		A8($author$project$Service$MeditationData$med, '3', 'Breathe', 'Connect with your life force', '#4ADE80', 180, 1, 4, 'breathe'),
		A8($author$project$Service$MeditationData$med, '4', 'Calm', 'Release tension and find stillness', '#86EFAC', 270, 0, 5, 'calm'),
		A8($author$project$Service$MeditationData$med, '5', 'Happiness', 'Cultivate joy and positivity', '#FCD34D', 45, 2, 2, 'happiness'),
		A8($author$project$Service$MeditationData$med, '6', 'Health', 'Nurture your body and vitality', '#34D399', 135, 3, 0, 'health'),
		A8($author$project$Service$MeditationData$med, '7', 'Hope', 'Embrace optimism and possibility', '#FDE047', 225, 2, 3, 'hope'),
		A8($author$project$Service$MeditationData$med, '8', 'Healing', 'Restore and regenerate your energy', '#A78BFA', 315, 0, 1, 'healing'),
		A8($author$project$Service$MeditationData$med, '9', 'Success', 'Manifest achievement and abundance', '#FFD700', 15, 2, 2, 'success'),
		A8($author$project$Service$MeditationData$med, '10', 'Wealth', 'Attract prosperity and abundance', '#F59E0B', 60, 3, 0, 'wealth'),
		A8($author$project$Service$MeditationData$med, '11', 'Relaxation', 'Deep rest and restoration', '#7C3AED', 105, 0, 5, 'relaxation'),
		A8($author$project$Service$MeditationData$med, '12', 'Relief', 'Release stress and find comfort', '#4ADE80', 150, 1, 3, 'relief'),
		A8($author$project$Service$MeditationData$med, '13', 'New Beginnings', 'Embrace fresh starts and renewal', '#C084FC', 195, 2, 6, 'new-beginnings'),
		A8($author$project$Service$MeditationData$med, '14', 'Inspiration', 'Connect with creative energy', '#F472B6', 240, 2, 1, 'inspiration'),
		A8($author$project$Service$MeditationData$med, '15', 'Chakras', 'Balance your energy centers', '#8B5CF6', 285, 4, 7, 'chakras'),
		A8($author$project$Service$MeditationData$med, '16', 'Balance', 'Harmonize mind, body, and spirit', '#6366F1', 330, 3, 0, 'balance'),
		A8($author$project$Service$MeditationData$med, '17', 'Self Esteem', 'Build confidence and self-worth', '#EC4899', 30, 2, 2, 'self-esteem'),
		A8($author$project$Service$MeditationData$med, '18', 'Courage', 'Find strength and bravery within', '#EF4444', 75, 2, 2, 'courage'),
		A8($author$project$Service$MeditationData$med, '19', 'Purpose', 'Discover your life mission', '#3B82F6', 120, 4, 5, 'purpose'),
		A8($author$project$Service$MeditationData$med, '20', 'Transformation', 'Embrace change and growth', '#10B981', 165, 2, 6, 'transformation'),
		A8($author$project$Service$MeditationData$med, '21', 'Creativity', 'Unlock your creative potential', '#F97316', 210, 0, 1, 'creativity'),
		A8($author$project$Service$MeditationData$med, '22', 'Power', 'Connect with your inner strength', '#DC2626', 255, 2, 2, 'power'),
		A8($author$project$Service$MeditationData$med, '23', 'Pathways', 'Navigate your life journey', '#0EA5E9', 300, 1, 5, 'pathways'),
		A8($author$project$Service$MeditationData$med, '24', 'Relationships', 'Deepen connections with others', '#E11D48', 345, 0, 3, 'relationships')
	]);
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Service$MeditationData$byId = function (id) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (m) {
			return _Utils_eq(m.cP, id);
		},
		$author$project$Service$MeditationData$all);
};
var $author$project$Service$MeditationData$validIds = A2(
	$elm$core$List$map,
	$elm$core$String$fromInt,
	A2($elm$core$List$range, 1, 24));
var $author$project$Service$MeditationData$idFromString = function (raw) {
	return A2($elm$core$List$member, raw, $author$project$Service$MeditationData$validIds) ? $elm$core$Maybe$Just(raw) : $elm$core$Maybe$Nothing;
};
var $author$project$Service$MeditationData$byIdString = function (raw) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Service$MeditationData$byId,
		$author$project$Service$MeditationData$idFromString(raw));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Model$initialPlayerFor = function (route) {
	if (route.$ === 6) {
		var rawId = route.a;
		return A2(
			$elm$core$Maybe$map,
			function (_v1) {
				return {a5: $author$project$Model$AudioLoading, cG: 0, cX: rawId, dm: 0, dr: false, dw: $elm$core$Maybe$Nothing};
			},
			$author$project$Service$MeditationData$byIdString(rawId));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Model$init = F3(
	function (flags, url, key) {
		var route = $author$project$Routing$fromUrl(url);
		return _Utils_Tuple2(
			{
				a8: $elm$core$Maybe$Nothing,
				aH: $author$project$Service$Entitlement$NotStarted,
				bf: $author$project$Model$initialCompass,
				bo: $author$project$Service$Entitlement$Free,
				am: flags,
				aO: $author$project$Model$initialGuide,
				aw: $elm$core$Maybe$Nothing,
				bA: key,
				cW: $author$project$Model$emptyLoginForm,
				dh: $author$project$Model$initialOnboarding,
				bP: $elm$core$Maybe$Nothing,
				bR: $author$project$Model$initialPlayerFor(route),
				dn: $author$project$Model$defaultProgress,
				$7: $elm$core$Maybe$Nothing,
				ds: $author$project$Model$emptyResetForm,
				aU: route,
				aV: $author$project$Model$SessionUnknown,
				dx: $author$project$Model$emptySignupForm,
				ap: $author$project$Model$defaultSoundtrack,
				aD: $elm$core$Maybe$Nothing,
				cf: $elm$core$Maybe$Nothing,
				cg: url
			},
			$elm$core$Platform$Cmd$none);
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Model$CheckoutCompletedFromBridge = function (a) {
	return {$: 55, a: a};
};
var $author$project$Model$ClerkEventReceived = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$ClerkSnapshotReceived = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$EntitlementLoadedFromDisk = function (a) {
	return {$: 49, a: a};
};
var $author$project$Model$GuideLoadedFromDisk = function (a) {
	return {$: 26, a: a};
};
var $author$project$Model$PlayerTick = function (a) {
	return {$: 44, a: a};
};
var $author$project$Model$ReferralCaptured = function (a) {
	return {$: 58, a: a};
};
var $author$project$Model$SessionsLoadedFromDisk = function (a) {
	return {$: 48, a: a};
};
var $author$project$Model$SoundtrackLoadedFromDisk = function (a) {
	return {$: 63, a: a};
};
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Ports$audioTick = _Platform_incomingPort(
	'audioTick',
	A2(
		$elm$json$Json$Decode$andThen,
		function (position) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return $elm$json$Json$Decode$succeed(
						{cP: id, dm: position});
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'position', $elm$json$Json$Decode$float)));
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Ports$checkoutCompletedFromBridge = _Platform_incomingPort('checkoutCompletedFromBridge', $elm$json$Json$Decode$value);
var $author$project$Ports$clerkEvent = _Platform_incomingPort('clerkEvent', $elm$json$Json$Decode$value);
var $author$project$Ports$clerkSub = _Platform_incomingPort('clerkSub', $elm$json$Json$Decode$value);
var $author$project$Ports$entitlementLoaded = _Platform_incomingPort('entitlementLoaded', $elm$json$Json$Decode$value);
var $author$project$Ports$guideLoaded = _Platform_incomingPort('guideLoaded', $elm$json$Json$Decode$value);
var $author$project$Ports$referralLoaded = _Platform_incomingPort('referralLoaded', $elm$json$Json$Decode$value);
var $author$project$Ports$sessionsLoaded = _Platform_incomingPort('sessionsLoaded', $elm$json$Json$Decode$value);
var $author$project$Ports$soundtrackLoaded = _Platform_incomingPort('soundtrackLoaded', $elm$json$Json$Decode$value);
var $author$project$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$clerkSub($author$project$Model$ClerkSnapshotReceived),
				$author$project$Ports$clerkEvent($author$project$Model$ClerkEventReceived),
				$author$project$Ports$audioTick($author$project$Model$PlayerTick),
				$author$project$Ports$sessionsLoaded($author$project$Model$SessionsLoadedFromDisk),
				$author$project$Ports$entitlementLoaded($author$project$Model$EntitlementLoadedFromDisk),
				$author$project$Ports$checkoutCompletedFromBridge($author$project$Model$CheckoutCompletedFromBridge),
				$author$project$Ports$referralLoaded($author$project$Model$ReferralCaptured),
				$author$project$Ports$soundtrackLoaded($author$project$Model$SoundtrackLoadedFromDisk),
				$author$project$Ports$guideLoaded($author$project$Model$GuideLoadedFromDisk)
			]));
};
var $author$project$Model$AudioErrored = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$AudioPaused = {$: 3};
var $author$project$Model$AudioPlaying = {$: 2};
var $author$project$Model$AwaitingCode = 1;
var $author$project$Model$CelebrationDismissed = {$: 51};
var $author$project$Model$ChargeFinalPulse = {$: 34};
var $author$project$Model$ChargeMidPulse = {$: 33};
var $author$project$Model$CheckoutCompleted = F2(
	function (a, b) {
		return {$: 56, a: a, b: b};
	});
var $author$project$Model$FormError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$FormSubmitting = {$: 1};
var $author$project$Model$GuideDone = 2;
var $author$project$Model$GuideOpen = 1;
var $author$project$Util$Juice$HapticSelect = 1;
var $author$project$Util$Juice$HapticTap = 0;
var $author$project$Model$JustFromCleared = {$: 36};
var $author$project$Model$MeditationPressConfirmed = function (a) {
	return {$: 32, a: a};
};
var $author$project$Model$PlayerEndTimeReceived = function (a) {
	return {$: 46, a: a};
};
var $author$project$Model$PlayerStartTimeReceived = function (a) {
	return {$: 45, a: a};
};
var $author$project$Util$Juice$PluckSelect = 1;
var $author$project$Service$Entitlement$Premium = function (a) {
	return {$: 1, a: a};
};
var $author$project$Service$Entitlement$Processing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$ResetAwaitingCode = 2;
var $author$project$Model$ResetAwaitingEmail = 1;
var $author$project$Model$SessionLoggedIn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$SessionLoggedOut = {$: 1};
var $author$project$Service$Entitlement$Succeeded = function (a) {
	return {$: 2, a: a};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Service$Entitlement$isPremium = function (e) {
	if (e.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Service$Entitlement$canPlay = F2(
	function (e, id) {
		return $author$project$Service$MeditationData$isFreeId(id) || $author$project$Service$Entitlement$isPremium(e);
	});
var $author$project$Ports$checkoutCmd = _Platform_outgoingPort('checkoutCmd', $elm$core$Basics$identity);
var $author$project$Update$clamp01 = function (v) {
	return (v < 0) ? 0 : ((v > 1) ? 1 : v);
};
var $author$project$Util$Juice$HapticCompletion = 4;
var $author$project$Util$Juice$PluckChime = 4;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$haptic = _Platform_outgoingPort('haptic', $elm$json$Json$Encode$string);
var $author$project$Util$Juice$hapticToString = function (h) {
	switch (h) {
		case 0:
			return 'tap';
		case 1:
			return 'select';
		case 2:
			return 'success';
		case 3:
			return 'error';
		default:
			return 'completion';
	}
};
var $author$project$Util$Juice$haptic = function (h) {
	return $author$project$Ports$haptic(
		$author$project$Util$Juice$hapticToString(h));
};
var $author$project$Ports$pluck = _Platform_outgoingPort('pluck', $elm$json$Json$Encode$string);
var $author$project$Util$Juice$pluckToString = function (p) {
	switch (p) {
		case 0:
			return 'tap';
		case 1:
			return 'select';
		case 2:
			return 'success';
		case 3:
			return 'error';
		default:
			return 'chime';
	}
};
var $author$project$Util$Juice$pluck = function (p) {
	return $author$project$Ports$pluck(
		$author$project$Util$Juice$pluckToString(p));
};
var $author$project$Util$Juice$completionFeedback = $elm$core$Platform$Cmd$batch(
	_List_fromArray(
		[
			$author$project$Util$Juice$haptic(4),
			$author$project$Util$Juice$pluck(4)
		]));
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Service$Entitlement$Annual = 1;
var $author$project$Service$Entitlement$Lifetime = 2;
var $author$project$Service$Entitlement$Monthly = 0;
var $author$project$Service$Entitlement$tierFromString = function (s) {
	switch (s) {
		case 'monthly':
			return $elm$core$Maybe$Just(0);
		case 'annual':
			return $elm$core$Maybe$Just(1);
		case 'lifetime':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Service$Entitlement$tierDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Service$Entitlement$tierFromString(s);
		if (!_v0.$) {
			var t = _v0.a;
			return $elm$json$Json$Decode$succeed(t);
		} else {
			return $elm$json$Json$Decode$fail('unknown tier: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Service$Entitlement$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (kind) {
		switch (kind) {
			case 'free':
				return $elm$json$Json$Decode$succeed($author$project$Service$Entitlement$Free);
			case 'premium':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sinceMs',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tier',
						$author$project$Service$Entitlement$tierDecoder,
						$elm$json$Json$Decode$succeed(
							F2(
								function (t, ms) {
									return $author$project$Service$Entitlement$Premium(
										{b2: ms, cb: t});
								}))));
			default:
				return $elm$json$Json$Decode$succeed($author$project$Service$Entitlement$Free);
		}
	},
	A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string));
var $author$project$Service$Referral$Referral = $elm$core$Basics$identity;
var $author$project$Service$Referral$FromStorage = 1;
var $author$project$Service$Referral$FromUrl = 0;
var $author$project$Service$Referral$sourceFromString = function (s) {
	if (s === 'url') {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Service$Referral$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'source',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed(
			F2(
				function (c, s) {
					return {
						bd: c,
						aX: $author$project$Service$Referral$sourceFromString(s)
					};
				}))));
var $author$project$Update$decodeBridgeTier = A2(
	$elm$json$Json$Decode$andThen,
	function (raw) {
		switch (raw) {
			case 'monthly':
				return $elm$json$Json$Decode$succeed(0);
			case 'annual':
				return $elm$json$Json$Decode$succeed(1);
			case 'lifetime':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var other = raw;
				return $elm$json$Json$Decode$fail('unknown tier from bridge: ' + other);
		}
	},
	A2($elm$json$Json$Decode$field, 'tier', $elm$json$Json$Decode$string));
var $author$project$Service$ClerkService$ClerkError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Service$ClerkService$ResetComplete = {$: 3};
var $author$project$Service$ClerkService$ResetPrepared = {$: 2};
var $author$project$Service$ClerkService$SignupComplete = {$: 1};
var $author$project$Service$ClerkService$SignupPrepared = {$: 0};
var $author$project$Service$ClerkService$decodeEvent = A2(
	$elm$json$Json$Decode$andThen,
	function (kind) {
		switch (kind) {
			case 'signupPrepared':
				return $elm$json$Json$Decode$succeed($author$project$Service$ClerkService$SignupPrepared);
			case 'signupComplete':
				return $elm$json$Json$Decode$succeed($author$project$Service$ClerkService$SignupComplete);
			case 'resetPrepared':
				return $elm$json$Json$Decode$succeed($author$project$Service$ClerkService$ResetPrepared);
			case 'resetComplete':
				return $elm$json$Json$Decode$succeed($author$project$Service$ClerkService$ResetComplete);
			case 'error':
				return A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (c, m) {
							return $author$project$Service$ClerkService$ClerkError(
								{cy: c, cZ: m});
						}),
					A2($elm$json$Json$Decode$field, 'cmd', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
			default:
				var other = kind;
				return $elm$json$Json$Decode$fail('unknown clerk event: ' + other);
		}
	},
	A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string));
var $author$project$Model$Session = F6(
	function (meditationId, meditationName, startTime, endTime, durationSeconds, completed) {
		return {cz: completed, cH: durationSeconds, cI: endTime, cX: meditationId, cY: meditationName, dz: startTime};
	});
var $author$project$Service$ProgressService$decodeSession = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'completed',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'durationSeconds',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'endTime',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'startTime',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'meditationName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'meditationId',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$Session)))))));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Service$ProgressService$decodeSessionList = function (value) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		$elm$json$Json$Decode$list($author$project$Service$ProgressService$decodeSession),
		value);
	if (!_v0.$) {
		var sessions = _v0.a;
		return sessions;
	} else {
		return _List_Nil;
	}
};
var $author$project$Service$ClerkService$SessionSnapshot = F2(
	function (user, session) {
		return {aV: session, dH: user};
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Service$ClerkService$decodeUser = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'firstName',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed(
				F3(
					function (id, email, firstName) {
						return {aa: email, br: firstName, dI: id};
					})))));
var $author$project$Service$ClerkService$decodeSnapshot = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Service$ClerkService$SessionSnapshot,
	A2(
		$elm$json$Json$Decode$field,
		'user',
		$elm$json$Json$Decode$nullable($author$project$Service$ClerkService$decodeUser)),
	A2($elm$json$Json$Decode$field, 'session', $elm$json$Json$Decode$bool));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Update$decodeSoundtrack = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (e, v, m) {
			return {bm: e, bF: m, cj: v};
		}),
	A2($elm$json$Json$Decode$field, 'enabled', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'volume', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'meditationVolume', $elm$json$Json$Decode$float));
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Service$Entitlement$tierString = function (t) {
	switch (t) {
		case 0:
			return 'monthly';
		case 1:
			return 'annual';
		default:
			return 'lifetime';
	}
};
var $author$project$Service$Entitlement$encode = function (e) {
	if (!e.$) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string('free'))
				]));
	} else {
		var tier = e.a.cb;
		var sinceMs = e.a.b2;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string('premium')),
					_Utils_Tuple2(
					'tier',
					$elm$json$Json$Encode$string(
						$author$project$Service$Entitlement$tierString(tier))),
					_Utils_Tuple2(
					'sinceMs',
					$elm$json$Json$Encode$int(sinceMs))
				]));
	}
};
var $author$project$Service$Referral$code = function (_v0) {
	var r = _v0;
	return r.bd;
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Update$tierString = function (t) {
	switch (t) {
		case 0:
			return 'monthly';
		case 1:
			return 'annual';
		default:
			return 'lifetime';
	}
};
var $author$project$Update$encodeCheckout = F2(
	function (tier, model) {
		var userIdValue = function () {
			var _v1 = model.aV;
			if (_v1.$ === 2) {
				var user = _v1.a;
				return $elm$json$Json$Encode$string(user.dI);
			} else {
				return $elm$json$Json$Encode$null;
			}
		}();
		var referrerValue = function () {
			var _v0 = model.$7;
			if (!_v0.$) {
				var ref = _v0.a;
				return $elm$json$Json$Encode$string(
					$author$project$Service$Referral$code(ref));
			} else {
				return $elm$json$Json$Encode$null;
			}
		}();
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tier',
					$elm$json$Json$Encode$string(
						$author$project$Update$tierString(tier))),
					_Utils_Tuple2('referrer', referrerValue),
					_Utils_Tuple2('userId', userIdValue)
				]));
	});
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Update$encodeSoundtrack = function (s) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'enabled',
				$elm$json$Json$Encode$bool(s.bm)),
				_Utils_Tuple2(
				'volume',
				$elm$json$Json$Encode$float(s.cj)),
				_Utils_Tuple2(
				'meditationVolume',
				$elm$json$Json$Encode$float(s.bF))
			]));
};
var $author$project$Routing$isAuthRequired = function (route) {
	switch (route.$) {
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		default:
			return false;
	}
};
var $author$project$Update$isLoggedIn = function (s) {
	if (s.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Routing$toString = function (route) {
	switch (route.$) {
		case 0:
			return '/';
		case 1:
			return '/about';
		case 2:
			return '/onboarding';
		case 3:
			return '/login';
		case 4:
			return '/signup';
		case 5:
			return '/app';
		case 6:
			var id = route.a;
			return '/app/play/' + id;
		case 7:
			return '/app/progress';
		case 8:
			return '/app/settings';
		case 9:
			return '/app/paywall-lab';
		default:
			return '/404';
	}
};
var $author$project$Update$enforceAuthGuard = F2(
	function (session, model) {
		return ($author$project$Routing$isAuthRequired(model.aU) && _Utils_eq(session, $author$project$Model$SessionLoggedOut)) ? _Utils_Tuple2(
			model,
			A2(
				$elm$browser$Browser$Navigation$pushUrl,
				model.bA,
				$author$project$Routing$toString($author$project$Routing$Login))) : (((_Utils_eq(model.aU, $author$project$Routing$Login) || _Utils_eq(model.aU, $author$project$Routing$Signup)) && $author$project$Update$isLoggedIn(session)) ? _Utils_Tuple2(
			model,
			A2(
				$elm$browser$Browser$Navigation$pushUrl,
				model.bA,
				$author$project$Routing$toString($author$project$Routing$Compass))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	});
var $author$project$Model$guideStepCount = 3;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Update$handlePlayerLifecycle = F3(
	function (oldRoute, newRoute, model) {
		var _v0 = _Utils_Tuple3(oldRoute, newRoute, model.bR);
		_v0$2:
		while (true) {
			if (_v0.a.$ === 6) {
				if (_v0.b.$ === 6) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					if (!_v0.c.$) {
						var p = _v0.c.a;
						return (p.dr || _Utils_eq(p.dw, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							model,
							A2($elm$core$Task$perform, $author$project$Model$PlayerEndTimeReceived, $elm$time$Time$now));
					} else {
						break _v0$2;
					}
				}
			} else {
				break _v0$2;
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Service$MeditationData$idToString = function (_v0) {
	var raw = _v0;
	return raw;
};
var $author$project$Update$initPlayerForRoute = F2(
	function (route, model) {
		if (route.$ === 6) {
			var rawId = route.a;
			var _v1 = $author$project$Service$MeditationData$byIdString(rawId);
			if (!_v1.$) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bR: $elm$core$Maybe$Just(
								{a5: $author$project$Model$AudioLoading, cG: 0, cX: rawId, dm: 0, dr: false, dw: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bR: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Ports$persistEntitlement = _Platform_outgoingPort('persistEntitlement', $elm$core$Basics$identity);
var $author$project$Ports$persistGuide = _Platform_outgoingPort('persistGuide', $elm$core$Basics$identity);
var $author$project$Ports$persistSoundtrack = _Platform_outgoingPort('persistSoundtrack', $elm$core$Basics$identity);
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Service$ProgressService$isLeap = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $author$project$Service$ProgressService$daysInMonth = F2(
	function (year, month) {
		switch (month) {
			case 1:
				return 31;
			case 2:
				return $author$project$Service$ProgressService$isLeap(year) ? 29 : 28;
			case 3:
				return 31;
			case 4:
				return 30;
			case 5:
				return 31;
			case 6:
				return 30;
			case 7:
				return 31;
			case 8:
				return 31;
			case 9:
				return 30;
			case 10:
				return 31;
			case 11:
				return 30;
			case 12:
				return 31;
			default:
				return 0;
		}
	});
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Service$ProgressService$parseDate = function (iso) {
	var _v0 = A2($elm$core$String$split, '-', iso);
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
		var y = _v0.a;
		var _v1 = _v0.b;
		var m = _v1.a;
		var _v2 = _v1.b;
		var d = _v2.a;
		return A4(
			$elm$core$Maybe$map3,
			F3(
				function (year, month, day) {
					return {R: day, L: month, P: year};
				}),
			$elm$core$String$toInt(y),
			$elm$core$String$toInt(m),
			$elm$core$String$toInt(d));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Service$ProgressService$isPreviousDay = F2(
	function (today, yesterday) {
		var _v0 = _Utils_Tuple2(
			$author$project$Service$ProgressService$parseDate(today),
			$author$project$Service$ProgressService$parseDate(yesterday));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var t = _v0.a.a;
			var y = _v0.b.a;
			return (_Utils_eq(t.P, y.P) && (_Utils_eq(t.L, y.L) && _Utils_eq(t.R, y.R - 1))) || ((_Utils_eq(t.P, y.P) && (_Utils_eq(t.L, y.L - 1) && ((y.R === 1) && _Utils_eq(
				t.R,
				A2($author$project$Service$ProgressService$daysInMonth, y.P, y.L) - 1)))) || (_Utils_eq(t.P, y.P - 1) && ((t.L === 12) && ((y.L === 1) && ((y.R === 1) && (t.R === 30))))));
		} else {
			return false;
		}
	});
var $author$project$Service$ProgressService$consecutiveRuns = function (dates) {
	if (!dates.b) {
		return _List_Nil;
	} else {
		var head = dates.a;
		var step = F2(
			function (today, _v6) {
				var prev = _v6.a;
				var acc = _v6.b;
				var _v3 = _Utils_Tuple2(prev, acc);
				if (_v3.a.$ === 1) {
					var _v4 = _v3.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(today),
						_List_fromArray(
							[1]));
				} else {
					if (_v3.b.b) {
						var yesterday = _v3.a.a;
						var _v5 = _v3.b;
						var runHead = _v5.a;
						var rest = _v5.b;
						return A2($author$project$Service$ProgressService$isPreviousDay, today, yesterday) ? _Utils_Tuple2(
							$elm$core$Maybe$Just(today),
							A2($elm$core$List$cons, runHead + 1, rest)) : _Utils_Tuple2(
							$elm$core$Maybe$Just(today),
							A2(
								$elm$core$List$cons,
								1,
								A2($elm$core$List$cons, runHead, rest)));
					} else {
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(today),
							_List_fromArray(
								[1]));
					}
				}
			});
		var _v1 = A3(
			$elm$core$List$foldl,
			step,
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			dates);
		var runs = _v1.b;
		var _v2 = head;
		return runs;
	}
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Service$ProgressService$computeStreaks = function (dates) {
	var runs = $author$project$Service$ProgressService$consecutiveRuns(dates);
	var longest = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$maximum(runs));
	var current = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$List$head(runs));
	return _Utils_Tuple2(current, longest);
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Service$ProgressService$recompute = function (p) {
	var completedSessions = A2(
		$elm$core$List$filter,
		function ($) {
			return $.cz;
		},
		p.b1);
	var sortedDates = $elm$core$List$reverse(
		$elm$core$List$sort(
			$elm$core$Set$toList(
				$elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.dz;
							},
							$elm$core$String$left(10)),
						completedSessions)))));
	var lastDate = $elm$core$List$head(sortedDates);
	var totalSeconds = A3(
		$elm$core$List$foldl,
		F2(
			function (s, acc) {
				return acc + s.cH;
			}),
		0,
		completedSessions);
	var _v0 = $author$project$Service$ProgressService$computeStreaks(sortedDates);
	var streak = _v0.a;
	var longest = _v0.b;
	return _Utils_update(
		p,
		{
			bD: lastDate,
			bE: A2($elm$core$Basics$max, longest, p.bE),
			b6: streak,
			cd: totalSeconds,
			ce: $elm$core$List$length(completedSessions)
		});
};
var $author$project$Model$CelebrationShown = function (a) {
	return {$: 50, a: a};
};
var $author$project$Service$ProgressService$aggregate = F2(
	function (session, p) {
		return $author$project$Service$ProgressService$recompute(
			_Utils_update(
				p,
				{
					b1: A2($elm$core$List$cons, session, p.b1)
				}));
	});
var $author$project$Service$ProgressService$encodeSession = function (s) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'meditationId',
				$elm$json$Json$Encode$string(s.cX)),
				_Utils_Tuple2(
				'meditationName',
				$elm$json$Json$Encode$string(s.cY)),
				_Utils_Tuple2(
				'startTime',
				$elm$json$Json$Encode$string(s.dz)),
				_Utils_Tuple2(
				'endTime',
				$elm$json$Json$Encode$string(s.cI)),
				_Utils_Tuple2(
				'durationSeconds',
				$elm$json$Json$Encode$int(s.cH)),
				_Utils_Tuple2(
				'completed',
				$elm$json$Json$Encode$bool(s.cz))
			]));
};
var $author$project$Service$ProgressService$completionRatio = 0.8;
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$Service$ProgressService$isCompletion = function (_v0) {
	var played = _v0.dk;
	var duration = _v0.cG;
	return (duration > 0) && (_Utils_cmp(played / duration, $author$project$Service$ProgressService$completionRatio) > -1);
};
var $author$project$Ports$persistSession = _Platform_outgoingPort('persistSession', $elm$core$Basics$identity);
var $author$project$Service$ProgressService$monthNum = function (m) {
	switch (m) {
		case 0:
			return '01';
		case 1:
			return '02';
		case 2:
			return '03';
		case 3:
			return '04';
		case 4:
			return '05';
		case 5:
			return '06';
		case 6:
			return '07';
		case 7:
			return '08';
		case 8:
			return '09';
		case 9:
			return '10';
		case 10:
			return '11';
		default:
			return '12';
	}
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.aY, posixMinutes) < 0) {
					return posixMinutes + era.bM;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		R: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		L: month,
		P: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).R;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).L;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).P;
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Service$ProgressService$isoDate = function (t) {
	var year = $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, $elm$time$Time$utc, t));
	var second = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toSecond, $elm$time$Time$utc, t)));
	var month = $author$project$Service$ProgressService$monthNum(
		A2($elm$time$Time$toMonth, $elm$time$Time$utc, t));
	var minute = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toMinute, $elm$time$Time$utc, t)));
	var hour = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toHour, $elm$time$Time$utc, t)));
	var day = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$time$Time$toDay, $elm$time$Time$utc, t)));
	return year + ('-' + (month + ('-' + (day + ('T' + (hour + (':' + (minute + (':' + (second + 'Z'))))))))));
};
var $author$project$Service$ProgressService$recordCompletion = function (args) {
	return {
		cz: args.cz,
		cH: args.cH,
		cI: $author$project$Service$ProgressService$isoDate(args.cI),
		cX: args.cX,
		cY: args.cY,
		dz: $author$project$Service$ProgressService$isoDate(args.dz)
	};
};
var $elm$core$Basics$round = _Basics_round;
var $author$project$Update$recordSessionIfNeeded = F2(
	function (endTime, model) {
		var _v0 = model.bR;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var p = _v0.a;
			if (p.dr) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			} else {
				var _v1 = _Utils_Tuple2(
					p.dw,
					$author$project$Service$MeditationData$byIdString(p.cX));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var start = _v1.a.a;
					var m = _v1.b.a;
					var wasCompletion = $author$project$Service$ProgressService$isCompletion(
						{cG: p.cG, dk: p.dm});
					var durationSec = $elm$core$Basics$round(p.dm);
					var session = $author$project$Service$ProgressService$recordCompletion(
						{cz: wasCompletion, cH: durationSec, cI: endTime, cX: p.cX, cY: m.bG, dz: start});
					var newProgress = A2($author$project$Service$ProgressService$aggregate, session, model.dn);
					var celebrationCmd = wasCompletion ? A2(
						$elm$core$Task$perform,
						$author$project$Model$CelebrationShown,
						$elm$core$Task$succeed(
							{cn: m.be, cY: m.bG, c1: newProgress.b6})) : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bR: $elm$core$Maybe$Just(
									_Utils_update(
										p,
										{a5: $author$project$Model$AudioPaused, dr: true})),
								dn: newProgress
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$persistSession(
									$author$project$Service$ProgressService$encodeSession(session)),
									celebrationCmd
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			}
		}
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Ports$clerkCmd = _Platform_outgoingPort('clerkCmd', $elm$core$Basics$identity);
var $author$project$Service$ClerkService$resetConfirm = function (_v0) {
	var code = _v0.bd;
	var newPassword = _v0.bI;
	return $author$project$Ports$clerkCmd(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string('resetConfirm')),
					_Utils_Tuple2(
					'payload',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$elm$json$Json$Encode$string(code)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(newPassword))
							])))
				])));
};
var $author$project$Service$ClerkService$resetStart = function (_v0) {
	var email = _v0.aa;
	return $author$project$Ports$clerkCmd(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string('resetStart')),
					_Utils_Tuple2(
					'payload',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'identifier',
								$elm$json$Json$Encode$string(email))
							])))
				])));
};
var $author$project$Update$sessionsEquivalent = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		_v0$3:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (_v0.b.$ === 2) {
						var u1 = _v0.a.a;
						var u2 = _v0.b.a;
						return _Utils_eq(u1.dI, u2.dI);
					} else {
						break _v0$3;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$3;
					}
				default:
					if (!_v0.b.$) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return true;
					} else {
						break _v0$3;
					}
			}
		}
		return false;
	});
var $author$project$Ports$setAccentColor = _Platform_outgoingPort('setAccentColor', $elm$json$Json$Encode$string);
var $author$project$Update$setLoginEmail = F2(
	function (s, f) {
		return _Utils_update(
			f,
			{aa: s, N: $author$project$Model$FormReady});
	});
var $author$project$Update$setLoginPassword = F2(
	function (s, f) {
		return _Utils_update(
			f,
			{ay: s, N: $author$project$Model$FormReady});
	});
var $author$project$Update$setResetField = F2(
	function (updater, f) {
		var next = updater(f);
		return _Utils_update(
			next,
			{N: $author$project$Model$FormReady});
	});
var $author$project$Update$setSignupField = F2(
	function (updater, f) {
		var next = updater(f);
		return _Utils_update(
			next,
			{N: $author$project$Model$FormReady});
	});
var $author$project$Service$ClerkService$signIn = function (_v0) {
	var email = _v0.aa;
	var password = _v0.ay;
	return $author$project$Ports$clerkCmd(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string('signIn')),
					_Utils_Tuple2(
					'payload',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'identifier',
								$elm$json$Json$Encode$string(email)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(password))
							])))
				])));
};
var $author$project$Service$ClerkService$signOut = $author$project$Ports$clerkCmd(
	$elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'kind',
				$elm$json$Json$Encode$string('signOut')),
				_Utils_Tuple2('payload', $elm$json$Json$Encode$null)
			])));
var $author$project$Service$ClerkService$signUp = function (_v0) {
	var firstName = _v0.br;
	var email = _v0.aa;
	var password = _v0.ay;
	return $author$project$Ports$clerkCmd(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string('signUp')),
					_Utils_Tuple2(
					'payload',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'firstName',
								$elm$json$Json$Encode$string(firstName)),
								_Utils_Tuple2(
								'emailAddress',
								$elm$json$Json$Encode$string(email)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(password))
							])))
				])));
};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Util$Juice$PluckTap = 0;
var $author$project$Util$Juice$tapFeedback = $elm$core$Platform$Cmd$batch(
	_List_fromArray(
		[
			$author$project$Util$Juice$haptic(0),
			$author$project$Util$Juice$pluck(0)
		]));
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.bV;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.bs,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.bW,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.bS,
					_Utils_ap(http, url.bx)),
				url.bO)));
};
var $author$project$Service$ClerkService$verifyEmail = function (_v0) {
	var code = _v0.bd;
	return $author$project$Ports$clerkCmd(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'kind',
					$elm$json$Json$Encode$string('verifyEmail')),
					_Utils_Tuple2(
					'payload',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$elm$json$Json$Encode$string(code))
							])))
				])));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Update$withPlayerStatus = F2(
	function (status, model) {
		var _v0 = model.bR;
		if (!_v0.$) {
			var p = _v0.a;
			return _Utils_update(
				model,
				{
					bR: $elm$core$Maybe$Just(
						_Utils_update(
							p,
							{a5: status}))
				});
		} else {
			return model;
		}
	});
var $author$project$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.bA,
							$elm$url$Url$toString(url)));
				} else {
					var href = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(href));
				}
			case 1:
				var url = msg.a;
				var newRoute = $author$project$Routing$fromUrl(url);
				var receiveFrom = function () {
					var _v10 = _Utils_Tuple2(model.aU, newRoute);
					if ((_v10.a.$ === 6) && (_v10.b.$ === 5)) {
						var rawId = _v10.a.a;
						var _v11 = _v10.b;
						return $author$project$Service$MeditationData$idFromString(rawId);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var clearReceive = function () {
					if (!receiveFrom.$) {
						return A2(
							$elm$core$Task$perform,
							function (_v9) {
								return $author$project$Model$JustFromCleared;
							},
							$elm$core$Process$sleep(700));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v2 = A3($author$project$Update$handlePlayerLifecycle, model.aU, newRoute, model);
				var withPlayerCleanup = _v2.a;
				var cleanupCmd = _v2.b;
				var _v3 = A2($author$project$Update$initPlayerForRoute, newRoute, withPlayerCleanup);
				var withPlayerInit = _v3.a;
				var initCmd = _v3.b;
				var _v4 = function () {
					if (newRoute.$ === 6) {
						var rawId = newRoute.a;
						var _v6 = $author$project$Service$MeditationData$idFromString(rawId);
						if (!_v6.$) {
							var id = _v6.a;
							return A2($author$project$Service$Entitlement$canPlay, model.bo, id) ? _Utils_Tuple2(withPlayerInit, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
								_Utils_update(
									withPlayerInit,
									{
										aH: $author$project$Service$Entitlement$NotStarted,
										bP: $elm$core$Maybe$Just(id)
									}),
								A2(
									$elm$browser$Browser$Navigation$replaceUrl,
									model.bA,
									$author$project$Routing$toString($author$project$Routing$Compass)));
						} else {
							return _Utils_Tuple2(withPlayerInit, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(withPlayerInit, $elm$core$Platform$Cmd$none);
					}
				}();
				var gated = _v4.a;
				var gateCmd = _v4.b;
				var authedModel = _Utils_update(
					gated,
					{aw: receiveFrom, aU: newRoute, cg: url});
				var _v7 = A2(
					$author$project$Update$enforceAuthGuard,
					model.aV,
					_Utils_update(
						authedModel,
						{aU: newRoute}));
				var finalModel = _v7.a;
				var finalGuardCmd = _v7.b;
				return _Utils_Tuple2(
					finalModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cleanupCmd, initCmd, gateCmd, clearReceive, finalGuardCmd])));
			case 2:
				var value = msg.a;
				var newSession = function () {
					var _v13 = A2($elm$json$Json$Decode$decodeValue, $author$project$Service$ClerkService$decodeSnapshot, value);
					if (!_v13.$) {
						var snapshot = _v13.a;
						var _v14 = snapshot.dH;
						if (!_v14.$) {
							var u = _v14.a;
							return $author$project$Model$SessionLoggedIn(u);
						} else {
							return $author$project$Model$SessionLoggedOut;
						}
					} else {
						return $author$project$Model$SessionLoggedOut;
					}
				}();
				if (A2($author$project$Update$sessionsEquivalent, model.aV, newSession)) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var _v12 = A2($author$project$Update$enforceAuthGuard, newSession, model);
					var withGuard = _v12.a;
					var guardCmd = _v12.b;
					return _Utils_Tuple2(
						_Utils_update(
							withGuard,
							{aV: newSession}),
						guardCmd);
				}
			case 3:
				var value = msg.a;
				var _v15 = A2($elm$json$Json$Decode$decodeValue, $author$project$Service$ClerkService$decodeEvent, value);
				if (!_v15.$) {
					switch (_v15.a.$) {
						case 0:
							var _v16 = _v15.a;
							var f = model.dx;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										dx: _Utils_update(
											f,
											{aC: 1, N: $author$project$Model$FormReady})
									}),
								$elm$core$Platform$Cmd$none);
						case 1:
							var _v17 = _v15.a;
							var f = model.dx;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										dx: _Utils_update(
											f,
											{N: $author$project$Model$FormReady})
									}),
								$elm$core$Platform$Cmd$none);
						case 2:
							var _v18 = _v15.a;
							var rf = model.ds;
							var status = (rf.aC === 2) ? $author$project$Model$FormError('A fresh code is on its way — check your email.') : $author$project$Model$FormReady;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ds: _Utils_update(
											rf,
											{aC: 2, N: status})
									}),
								$elm$core$Platform$Cmd$none);
						case 3:
							var _v19 = _v15.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ds: $author$project$Model$emptyResetForm}),
								$elm$core$Platform$Cmd$none);
						default:
							var err = _v15.a.a;
							var _v20 = err.cy;
							switch (_v20) {
								case 'signIn':
									var lf = model.cW;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												cW: _Utils_update(
													lf,
													{
														N: $author$project$Model$FormError(err.cZ)
													})
											}),
										$elm$core$Platform$Cmd$none);
								case 'signUp':
									var sf = model.dx;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												dx: _Utils_update(
													sf,
													{
														N: $author$project$Model$FormError(err.cZ)
													})
											}),
										$elm$core$Platform$Cmd$none);
								case 'verifyEmail':
									var sf = model.dx;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												dx: _Utils_update(
													sf,
													{
														N: $author$project$Model$FormError(err.cZ)
													})
											}),
										$elm$core$Platform$Cmd$none);
								case 'resetStart':
									var rf = model.ds;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												ds: _Utils_update(
													rf,
													{
														N: $author$project$Model$FormError(err.cZ)
													})
											}),
										$elm$core$Platform$Cmd$none);
								case 'resetConfirm':
									var rf = model.ds;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												ds: _Utils_update(
													rf,
													{
														N: $author$project$Model$FormError(err.cZ)
													})
											}),
										$elm$core$Platform$Cmd$none);
								default:
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cW: A2($author$project$Update$setLoginEmail, s, model.cW)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cW: A2($author$project$Update$setLoginPassword, s, model.cW)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var f = model.cW;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cW: _Utils_update(
								f,
								{N: $author$project$Model$FormSubmitting})
						}),
					$author$project$Service$ClerkService$signIn(
						{aa: f.aa, ay: f.ay}));
			case 7:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dx: A2(
								$author$project$Update$setSignupField,
								function (f) {
									return _Utils_update(
										f,
										{br: s});
								},
								model.dx)
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dx: A2(
								$author$project$Update$setSignupField,
								function (f) {
									return _Utils_update(
										f,
										{aa: s});
								},
								model.dx)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dx: A2(
								$author$project$Update$setSignupField,
								function (f) {
									return _Utils_update(
										f,
										{ay: s});
								},
								model.dx)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var f = model.dx;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dx: _Utils_update(
								f,
								{N: $author$project$Model$FormSubmitting})
						}),
					$author$project$Service$ClerkService$signUp(
						{aa: f.aa, br: f.br, ay: f.ay}));
			case 11:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dx: A2(
								$author$project$Update$setSignupField,
								function (f) {
									return _Utils_update(
										f,
										{ch: s});
								},
								model.dx)
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var f = model.dx;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dx: _Utils_update(
								f,
								{N: $author$project$Model$FormSubmitting})
						}),
					$author$project$Service$ClerkService$verifyEmail(
						{bd: f.ch}));
			case 13:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ds: _Utils_update(
								$author$project$Model$emptyResetForm,
								{aa: model.cW.aa, aC: 1})
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ds: $author$project$Model$emptyResetForm}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ds: A2(
								$author$project$Update$setResetField,
								function (f) {
									return _Utils_update(
										f,
										{aa: s});
								},
								model.ds)
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ds: A2(
								$author$project$Update$setResetField,
								function (f) {
									return _Utils_update(
										f,
										{bd: s});
								},
								model.ds)
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var s = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ds: A2(
								$author$project$Update$setResetField,
								function (f) {
									return _Utils_update(
										f,
										{bI: s});
								},
								model.ds)
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var f = model.ds;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ds: _Utils_update(
								f,
								{N: $author$project$Model$FormSubmitting})
						}),
					$author$project$Service$ClerkService$resetStart(
						{aa: f.aa}));
			case 19:
				var f = model.ds;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ds: _Utils_update(
								f,
								{N: $author$project$Model$FormSubmitting})
						}),
					$author$project$Service$ClerkService$resetConfirm(
						{bd: f.bd, bI: f.bI}));
			case 20:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dn: $author$project$Model$defaultProgress, aV: $author$project$Model$SessionLoggedOut}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Service$ClerkService$signOut,
								A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.bA,
								$author$project$Routing$toString($author$project$Routing$Landing))
							])));
			case 21:
				var ob = model.dh;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dh: _Utils_update(
								ob,
								{b3: ob.b3 + 1})
						}),
					$elm$core$Platform$Cmd$none);
			case 22:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dh: {b3: 0}
						}),
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						model.bA,
						$author$project$Routing$toString($author$project$Routing$Compass)));
			case 23:
				var g = model.aO;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aO: _Utils_update(
								g,
								{
									b5: A2($elm$core$Basics$min, $author$project$Model$guideStepCount - 1, g.b5 + 1)
								})
						}),
					$author$project$Util$Juice$tapFeedback);
			case 24:
				var g = model.aO;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aO: _Utils_update(
								g,
								{N: 2})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$persistGuide(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'seen',
											$elm$json$Json$Encode$bool(true))
										]))),
								$author$project$Util$Juice$completionFeedback
							])));
			case 25:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aO: {N: 1, b5: 0}
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$persistGuide(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'seen',
											$elm$json$Json$Encode$bool(false))
										]))),
								A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.bA,
								$author$project$Routing$toString($author$project$Routing$Compass))
							])));
			case 26:
				var value = msg.a;
				var seen = A2(
					$elm$core$Result$withDefault,
					false,
					A2(
						$elm$json$Json$Decode$decodeValue,
						A2($elm$json$Json$Decode$field, 'seen', $elm$json$Json$Decode$bool),
						value));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aO: {
								N: seen ? 2 : 1,
								b5: 0
							}
						}),
					$elm$core$Platform$Cmd$none);
			case 27:
				var deltaMs = msg.a;
				if (model.bf.a6) {
					var delta = (deltaMs / 60000) * 360;
					var cs = model.bf;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bf: _Utils_update(
									cs,
									{bZ: cs.bZ + delta})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 28:
				var cs = model.bf;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bf: _Utils_update(
								cs,
								{a6: false})
						}),
					$elm$core$Platform$Cmd$none);
			case 29:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 30:
				var cs = model.bf;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bf: _Utils_update(
								cs,
								{a6: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 31:
				var id = msg.a;
				if (A2($author$project$Service$Entitlement$canPlay, model.bo, id)) {
					var delayedMsg = F2(
						function (ms, msg_) {
							return A2(
								$elm$core$Task$perform,
								function (_v21) {
									return msg_;
								},
								$elm$core$Process$sleep(ms));
						});
					var accentCmd = A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.be;
								},
								$author$project$Ports$setAccentColor),
							$author$project$Service$MeditationData$byId(id)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aD: $elm$core$Maybe$Just(id)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Util$Juice$haptic(1),
									$author$project$Util$Juice$pluck(1),
									accentCmd,
									A2(delayedMsg, 1200, $author$project$Model$ChargeMidPulse),
									A2(delayedMsg, 2000, $author$project$Model$ChargeMidPulse),
									A2(delayedMsg, 2700, $author$project$Model$ChargeMidPulse),
									A2(delayedMsg, 3200, $author$project$Model$ChargeMidPulse),
									A2(delayedMsg, 3500, $author$project$Model$ChargeMidPulse),
									A2(delayedMsg, 3700, $author$project$Model$ChargeMidPulse),
									A2(delayedMsg, 3850, $author$project$Model$ChargeFinalPulse),
									A2(
									delayedMsg,
									4000,
									$author$project$Model$MeditationPressConfirmed(id))
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aH: $author$project$Service$Entitlement$NotStarted,
								bP: $elm$core$Maybe$Just(id)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Util$Juice$haptic(1),
									$author$project$Util$Juice$pluck(1)
								])));
				}
			case 32:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aD: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Util$Juice$completionFeedback,
								A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.bA,
								$author$project$Routing$toString(
									$author$project$Routing$Player(
										$author$project$Service$MeditationData$idToString(id))))
							])));
			case 33:
				return _Utils_Tuple2(
					model,
					$author$project$Util$Juice$haptic(0));
			case 34:
				return _Utils_Tuple2(model, $author$project$Util$Juice$completionFeedback);
			case 35:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 36:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aw: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 52:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: $author$project$Service$Entitlement$NotStarted,
							bP: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none);
			case 53:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aH: $author$project$Service$Entitlement$NotStarted, bP: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 54:
				var tier = msg.a;
				var _v22 = model.aH;
				if (_v22.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aH: $author$project$Service$Entitlement$Processing(tier)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Util$Juice$tapFeedback,
									$author$project$Ports$checkoutCmd(
									A2($author$project$Update$encodeCheckout, tier, model))
								])));
				}
			case 55:
				var value = msg.a;
				if (model.am.aI !== 'stripe') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aH: $author$project$Service$Entitlement$NotStarted}),
						$elm$core$Platform$Cmd$none);
				} else {
					var _v23 = A2($elm$json$Json$Decode$decodeValue, $author$project$Update$decodeBridgeTier, value);
					if (!_v23.$) {
						var tier = _v23.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$perform,
								$author$project$Model$CheckoutCompleted(tier),
								$elm$time$Time$now));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 56:
				var tier = msg.a;
				var now = msg.b;
				var newEntitlement = $author$project$Service$Entitlement$Premium(
					{
						b2: $elm$time$Time$posixToMillis(now),
						cb: tier
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: $author$project$Service$Entitlement$Succeeded(tier),
							bo: newEntitlement,
							bP: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Util$Juice$completionFeedback,
								$author$project$Ports$persistEntitlement(
								$author$project$Service$Entitlement$encode(newEntitlement))
							])));
			case 49:
				var value = msg.a;
				var _v24 = A2($elm$json$Json$Decode$decodeValue, $author$project$Service$Entitlement$decode, value);
				if (!_v24.$) {
					var ent = _v24.a;
					return ((model.am.aI !== 'stripe') && $author$project$Service$Entitlement$isPremium(ent)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{bo: $author$project$Service$Entitlement$Free}),
						$author$project$Ports$persistEntitlement(
							$author$project$Service$Entitlement$encode($author$project$Service$Entitlement$Free))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{bo: ent}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 57:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aH: $author$project$Service$Entitlement$NotStarted, bo: $author$project$Service$Entitlement$Free}),
					$author$project$Ports$persistEntitlement(
						$author$project$Service$Entitlement$encode($author$project$Service$Entitlement$Free)));
			case 58:
				var value = msg.a;
				var _v25 = A2($elm$json$Json$Decode$decodeValue, $author$project$Service$Referral$decode, value);
				if (!_v25.$) {
					var ref = _v25.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								$7: $elm$core$Maybe$Just(ref)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 37:
				var _v26 = model.bR;
				if (!_v26.$) {
					var p = _v26.a;
					var _v27 = function () {
						var _v28 = p.a5;
						if (_v28.$ === 2) {
							return _Utils_Tuple2($author$project$Model$AudioPaused, $elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								$author$project$Model$AudioPlaying,
								_Utils_eq(p.dw, $elm$core$Maybe$Nothing) ? A2($elm$core$Task$perform, $author$project$Model$PlayerStartTimeReceived, $elm$time$Time$now) : $elm$core$Platform$Cmd$none);
						}
					}();
					var newStatus = _v27.a;
					var sessionCmd = _v27.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bR: $elm$core$Maybe$Just(
									_Utils_update(
										p,
										{a5: newStatus}))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[$author$project$Util$Juice$tapFeedback, sessionCmd])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 38:
				var t = msg.a;
				var _v29 = model.bR;
				if (!_v29.$) {
					var p = _v29.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bR: $elm$core$Maybe$Just(
									_Utils_update(
										p,
										{dm: t}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 39:
				var d = msg.a;
				var _v30 = model.bR;
				if (!_v30.$) {
					var p = _v30.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bR: $elm$core$Maybe$Just(
									_Utils_update(
										p,
										{
											a5: _Utils_eq(p.a5, $author$project$Model$AudioLoading) ? $author$project$Model$AudioPaused : p.a5,
											cG: d
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 40:
				return _Utils_Tuple2(
					A2($author$project$Update$withPlayerStatus, $author$project$Model$AudioPaused, model),
					A2($elm$core$Task$perform, $author$project$Model$PlayerEndTimeReceived, $elm$time$Time$now));
			case 41:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Update$withPlayerStatus,
						$author$project$Model$AudioErrored(code),
						model),
					$elm$core$Platform$Cmd$none);
			case 42:
				return _Utils_Tuple2(
					A2($author$project$Update$withPlayerStatus, $author$project$Model$AudioPlaying, model),
					$elm$core$Platform$Cmd$none);
			case 43:
				return _Utils_Tuple2(
					A2($author$project$Update$withPlayerStatus, $author$project$Model$AudioPaused, model),
					$elm$core$Platform$Cmd$none);
			case 44:
				var id = msg.a.cP;
				var position = msg.a.dm;
				var onPlayerRoute = function () {
					var _v33 = model.aU;
					if (_v33.$ === 6) {
						return true;
					} else {
						return false;
					}
				}();
				var _v31 = id;
				var _v32 = _Utils_Tuple2(model.bR, onPlayerRoute);
				if ((!_v32.a.$) && _v32.b) {
					var p = _v32.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bR: $elm$core$Maybe$Just(
									_Utils_update(
										p,
										{dm: position}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 45:
				var t = msg.a;
				var _v34 = model.bR;
				if (!_v34.$) {
					var p = _v34.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bR: $elm$core$Maybe$Just(
									_Utils_update(
										p,
										{
											dw: $elm$core$Maybe$Just(t)
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 46:
				var t = msg.a;
				return A2($author$project$Update$recordSessionIfNeeded, t, model);
			case 47:
				var _v35 = model.bR;
				if (!_v35.$) {
					var p = _v35.a;
					return (p.dr || _Utils_eq(p.dw, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						model,
						A2($elm$core$Task$perform, $author$project$Model$PlayerEndTimeReceived, $elm$time$Time$now));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 48:
				var value = msg.a;
				var sessions = $author$project$Service$ProgressService$decodeSessionList(value);
				var progress = $author$project$Service$ProgressService$recompute(
					_Utils_update(
						$author$project$Model$defaultProgress,
						{bq: model.dn.bq, b1: sessions}));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dn: progress}),
					$elm$core$Platform$Cmd$none);
			case 50:
				var payload = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a8: $elm$core$Maybe$Just(payload)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Util$Juice$completionFeedback,
								A2(
								$elm$core$Task$perform,
								function (_v36) {
									return $author$project$Model$CelebrationDismissed;
								},
								$elm$core$Process$sleep(2400))
							])));
			case 51:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a8: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 59:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 60:
				var enabled = msg.a;
				var st = model.ap;
				var newSt = _Utils_update(
					st,
					{bm: enabled});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ap: newSt}),
					$author$project$Ports$persistSoundtrack(
						$author$project$Update$encodeSoundtrack(newSt)));
			case 61:
				var v = msg.a;
				var st = model.ap;
				var newSt = _Utils_update(
					st,
					{
						cj: $author$project$Update$clamp01(v)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ap: newSt}),
					$author$project$Ports$persistSoundtrack(
						$author$project$Update$encodeSoundtrack(newSt)));
			case 62:
				var v = msg.a;
				var st = model.ap;
				var newSt = _Utils_update(
					st,
					{
						bF: $author$project$Update$clamp01(v)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ap: newSt}),
					$author$project$Ports$persistSoundtrack(
						$author$project$Update$encodeSoundtrack(newSt)));
			default:
				var value = msg.a;
				var _v37 = A2($elm$json$Json$Decode$decodeValue, $author$project$Update$decodeSoundtrack, value);
				if (!_v37.$) {
					var st = _v37.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ap: st}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Main$isDeepListening = function (model) {
	var _v0 = model.bR;
	if (!_v0.$) {
		var p = _v0.a;
		return _Utils_eq(p.a5, $author$project$Model$AudioPlaying);
	} else {
		return false;
	}
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Model$PaywallOpened = function (a) {
	return {$: 52, a: a};
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$View$Player$lockedActions = function (m) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col items-stretch sm:items-center gap-3 w-full max-w-xs')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tap juice-tap juice-magnet juice-halo gold-leaf shimmer-button w-full px-8 py-4 rounded-full font-semibold text-sm tracking-[0.22em] uppercase'),
						$elm$html$Html$Events$onClick(
						$author$project$Model$PaywallOpened(m.cP))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Unlock to listen')
					])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/app'),
						$elm$html$Html$Attributes$class('tap text-cream/50 hover:text-gold-soft text-xs tracking-[0.25em] uppercase py-2 text-center transition-colors')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Choose another direction')
					]))
			]));
};
var $author$project$Service$MeditationData$chakraToString = function (c) {
	switch (c) {
		case 0:
			return 'Root';
		case 1:
			return 'Sacral';
		case 2:
			return 'Solar Plexus';
		case 3:
			return 'Heart';
		case 4:
			return 'Throat';
		case 5:
			return 'Third Eye';
		case 6:
			return 'Crown';
		default:
			return 'All';
	}
};
var $author$project$Service$MeditationData$elementToString = function (e) {
	switch (e) {
		case 0:
			return 'Water';
		case 1:
			return 'Air';
		case 2:
			return 'Fire';
		case 3:
			return 'Earth';
		default:
			return 'Ether';
	}
};
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$View$Player$lockedIdentity = function (m) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col items-center gap-3 text-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gold-brass/60 text-[10px] tracking-[0.45em] uppercase')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Service$MeditationData$elementToString(m.bl) + (' · ' + ($author$project$Service$MeditationData$chakraToString(m.bb) + ' Chakra')))
					])),
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-display text-gold-soft leading-tight'),
						A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(2rem, 8vw, 3rem)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$em,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('italic-display')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(m.bG)
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/65 text-base italic font-display max-w-xs leading-relaxed')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(m.bi)
					]))
			]));
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$Attributes$opacity = _VirtualDom_attribute('opacity');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$View$Player$lockedMedallion = function (m) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('relative w-64 h-64 sm:w-80 sm:h-80 flex items-center justify-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute inset-0 rounded-full blur-3xl opacity-40'),
						A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle, ' + (m.be + '33 0%, transparent 65%)')),
						A2($elm$html$Html$Attributes$style, 'mix-blend-mode', 'screen')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 320 320'),
						$elm$svg$Svg$Attributes$class('absolute inset-0 w-full h-full')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('lockedRim'),
										$elm$svg$Svg$Attributes$x1('0%'),
										$elm$svg$Svg$Attributes$y1('0%'),
										$elm$svg$Svg$Attributes$x2('100%'),
										$elm$svg$Svg$Attributes$y2('100%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#D4AF37')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#fff8c8')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('160'),
								$elm$svg$Svg$Attributes$cy('160'),
								$elm$svg$Svg$Attributes$r('120'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke('url(#lockedRim)'),
								$elm$svg$Svg$Attributes$strokeWidth('1.2'),
								$elm$svg$Svg$Attributes$strokeDasharray('3 6'),
								$elm$svg$Svg$Attributes$opacity('0.7')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative w-40 h-40 sm:w-48 sm:h-48 rounded-full flex items-center justify-center'),
						A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 30% 25%, ' + (m.be + ('55 0%, ' + (m.be + '22 60%, transparent 100%)')))),
						A2($elm$html$Html$Attributes$style, 'box-shadow', 'inset 0 1px 0 rgba(255,255,255,0.2), 0 0 30px ' + (m.be + '22'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$svg,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$viewBox('0 0 48 48'),
								$elm$svg$Svg$Attributes$class('w-12 h-12 sm:w-14 sm:h-14 text-gold-soft')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M 16 22 V 16 a 8 8 0 0 1 16 0 v 6 M 12 22 h 24 v 18 H 12 z'),
										$elm$svg$Svg$Attributes$fill('none'),
										$elm$svg$Svg$Attributes$stroke('currentColor'),
										$elm$svg$Svg$Attributes$strokeWidth('2'),
										$elm$svg$Svg$Attributes$strokeLinecap('round'),
										$elm$svg$Svg$Attributes$strokeLinejoin('round'),
										$elm$svg$Svg$Attributes$opacity('0.85')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$cx('24'),
										$elm$svg$Svg$Attributes$cy('30'),
										$elm$svg$Svg$Attributes$r('2'),
										$elm$svg$Svg$Attributes$fill('currentColor'),
										$elm$svg$Svg$Attributes$opacity('0.85')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$View$Player$lockedTopBar = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('self-stretch flex items-center justify-between -mx-2')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('/app'),
					$elm$html$Html$Attributes$class('tap juice-tap inline-flex items-center gap-2 px-3 py-2 -my-2 rounded-full text-cream/65 text-xs tracking-[0.25em] uppercase hover:text-gold-soft transition-colors'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Back to compass')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('← Compass')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-rose-300/70 text-[10px] tracking-[0.4em] uppercase pr-2 inline-flex items-center gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-1.5 h-1.5 rounded-full bg-rose-400/80')
						]),
					_List_Nil),
					$elm$html$Html$text('Locked')
				]))
		]));
var $author$project$View$Player$locked = function (maybeMed) {
	if (maybeMed.$ === 1) {
		return {
			cs: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col items-center gap-5 py-20 sm:py-24 text-center px-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-display text-gold-soft italic-display leading-tight'),
									A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(2.25rem, 10vw, 2.5rem)')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Lost the signal')
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/60 text-base')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('We couldn\'t find that meditation.')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/app'),
									$elm$html$Html$Attributes$class('tap mt-2 px-8 py-3.5 rounded-full bg-gold text-ink font-semibold tracking-[0.22em] uppercase text-sm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Back to compass')
								]))
						]))
				]),
			dE: 'Off course'
		};
	} else {
		var m = maybeMed.a;
		return {
			cs: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col items-center gap-8 max-w-md mx-auto pt-2 pb-8 sm:pb-12 px-4 sm:px-6')
						]),
					_List_fromArray(
						[
							$author$project$View$Player$lockedTopBar,
							$author$project$View$Player$lockedMedallion(m),
							$author$project$View$Player$lockedIdentity(m),
							$author$project$View$Player$lockedActions(m)
						]))
				]),
			dE: m.bG + ' — locked'
		};
	}
};
var $author$project$View$About$bodyText = 'text-cream/80 leading-relaxed';
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $author$project$View$About$pullQuote = function (quote) {
	return A2(
		$elm$html$Html$blockquote,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('border-l-2 border-gold/40 pl-5 py-1 my-1')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gold-soft/95 italic-display text-xl sm:text-2xl leading-snug')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(quote)
					]))
			]));
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$View$About$sectionHead = function (heading) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-display text-2xl sm:text-3xl text-gold-soft leading-tight')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(heading)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hair-divider')
					]),
				_List_Nil)
			]));
};
var $author$project$View$About$section = F2(
	function (heading, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-4')
				]),
			A2(
				$elm$core$List$cons,
				$author$project$View$About$sectionHead(heading),
				children));
	});
var $author$project$View$About$apprenticeship = A2(
	$author$project$View$About$section,
	'A long apprenticeship',
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$View$About$bodyText)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('In 1995 I met Rose Marie, an English medium who became my teacher and my lifelong friend. For fifteen years I sat in her classes every Monday night — no weekend crash-courses, no certificates pulled from the ether. Mediumship is a discipline, a mastery of one’s own consciousness. As Rose would say:')
				])),
			$author$project$View$About$pullQuote('There are no short cuts to God, my friends.'),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$View$About$bodyText)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Along the way I studied at the Arthur Findlay College in Stansted, England, and spent years steeped in the work of Edgar Cayce — the Sleeping Prophet — whose words shaped my whole spiritual framework. The craft is learning to get myself out of the way, so that something higher can come through.')
				]))
		]));
var $author$project$View$About$closingNote = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-8 items-center text-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filigree')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-[10px] tracking-[0.45em] uppercase font-medium')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('A note from Lisa')
						]))
				])),
			A2(
			$elm$html$Html$blockquote,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-4 max-w-md')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/90 leading-relaxed italic font-display text-xl sm:text-2xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('“I am just a stepping stone — a lily pad for you to stop and stay a while. I welcome you aboard, Captain. Let the journey begin. You '),
							A2(
							$elm$html$Html$em,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('italic-display text-gold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('are')
								])),
							$elm$html$Html$text(' all the power you need. Your destiny awaits.”')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gold-soft text-sm tracking-[0.4em] uppercase')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('— Lisa Maree')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gold-brass/60 text-xs tracking-[0.5em] uppercase')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('So Hum ✨')
						]))
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('/signup'),
					$elm$html$Html$Attributes$class('tap self-stretch sm:self-auto text-center shimmer-button gold-leaf juice-tap juice-magnet juice-halo px-10 py-4 rounded-full font-semibold tracking-[0.22em] uppercase text-sm mt-2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Begin your journey')
				]))
		]));
var $author$project$View$About$compassWithin = A2(
	$author$project$View$About$section,
	'The compass within',
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$View$About$bodyText)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('I was born in 1967 in Kalgoorlie — the red-dirt goldfields of outback Western Australia. I grew up barefoot and fearless, chasing every race and every ball I could find. And I have always followed my heart, using an internal compass — disguised as feelings and hunches — to guide me through the right and wrong directions of a life.')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$View$About$bodyText)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Then, at twenty-one, a simple conversation about faith lit a spark. It sent me off to seek the truth about all things — and I have been a truth-seeker ever since.')
				]))
		]));
var $author$project$View$About$hero = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-5')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gold-brass/70 text-[11px] tracking-[0.45em] uppercase font-medium')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Who I am · Why this app')
				])),
			A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-display text-gold-soft leading-[1.05]'),
					A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(2.25rem, 9vw, 3.25rem)')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Helloo, my '),
					A2(
					$elm$html$Html$em,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('italic-display text-gold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Lovelies.')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-cream/85 leading-relaxed text-lg italic font-display')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Let me introduce myself. My name is Lisa Maree — and if you have found your way here, it is no accident. Something in you is drawn to the light and promise of Meditation Compass. I am so glad you came.')
				]))
		]));
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$View$About$milestoneWith = F4(
	function (hasLine, year, heading, detail) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative flex gap-5 pb-8 last:pb-0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative flex flex-col items-center shrink-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-1.5 w-2.5 h-2.5 rounded-full bg-gold shadow-[0_0_12px_rgba(255,215,0,0.6)] juice-pulse-soft')
								]),
							_List_Nil),
							hasLine ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute top-4 bottom-0 w-px bg-gradient-to-b from-gold/45 to-transparent')
								]),
							_List_Nil) : $elm$html$Html$text('')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-1 -mt-0.5')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-display text-gold-soft text-xl leading-none tabular-nums')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(year)
								])),
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/90 font-medium leading-snug')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(heading)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/65 text-sm leading-relaxed')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(detail)
								]))
						]))
				]));
	});
var $author$project$View$About$milestone = $author$project$View$About$milestoneWith(true);
var $author$project$View$About$milestoneLast = $author$project$View$About$milestoneWith(false);
var $author$project$View$About$timeline = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-7')
		]),
	_List_fromArray(
		[
			$author$project$View$About$sectionHead('A few stepping stones'),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col')
				]),
			_List_fromArray(
				[
					A3($author$project$View$About$milestone, '1967', 'Born in the goldfields', 'Kalgoorlie, Western Australia — red dirt and a wide-open sky.'),
					A3($author$project$View$About$milestone, '1995', 'Began studying mediumship', 'Fifteen years of weekly classes with the medium Rose Marie.'),
					A3($author$project$View$About$milestone, '2000', 'Edgar Cayce & the A.R.E.', 'Years immersed in spiritual study while living in Virginia Beach, USA.'),
					A3($author$project$View$About$milestone, '2006', 'Arthur Findlay College', 'Intensive mediumship and spiritual healing in Stansted, England.'),
					A3($author$project$View$About$milestoneLast, '2015', 'Meditation Compass is born', 'From a quiet, difficult season abroad came the spark for this app.')
				]))
		]));
var $author$project$View$About$gift = F2(
	function (heading, body) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-1.5 rounded-2xl border border-gold/15 bg-ink-soft/30 p-5 juice-magnet')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-display text-gold-soft text-lg leading-snug')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(heading)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/70 text-sm leading-relaxed')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(body)
						]))
				]));
	});
var $author$project$View$About$whyThisApp = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-6')
		]),
	_List_fromArray(
		[
			$author$project$View$About$sectionHead('Why this app'),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$View$About$bodyText)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Meditation Compass began in 2015. I was gravely ill and a long way from home, and in that enforced stillness I finally landed in the place I needed to be — to receive it. This app is the result: a practical, modern way to prepare the body, heart, mind and spirit, and to find your own way back to calm.')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$View$About$bodyText)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('I made it for busy people — to quiet the noise, to build a peaceful haven from within, and to remind you of something you already know: you are the master of your own mind, and '),
					A2(
					$elm$html$Html$em,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('italic-display text-gold-soft')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('you are all the power you need.')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2')
				]),
			_List_fromArray(
				[
					A2($author$project$View$About$gift, 'Calm, on demand', 'Relaxation on every level — spirit, body, mind and soul. Anytime, anywhere.'),
					A2($author$project$View$About$gift, 'A clearer mind', 'Take back control of your thoughts, and lead from your own inner knowing.'),
					A2($author$project$View$About$gift, 'Affirmations woven in', 'Positive, mind-affirming words threaded gently through every meditation.'),
					A2($author$project$View$About$gift, 'Room to grow', 'Inspiration, creativity, and a quiet path to becoming the best of you.')
				]))
		]));
var $author$project$View$About$view = {
	cs: _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('constellation-quiet')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative flex flex-col gap-14 sm:gap-20 py-8 sm:py-14 max-w-prose mx-auto px-2 juice-stagger')
						]),
					_List_fromArray(
						[$author$project$View$About$hero, $author$project$View$About$compassWithin, $author$project$View$About$apprenticeship, $author$project$View$About$timeline, $author$project$View$About$whyThisApp, $author$project$View$About$closingNote]))
				]))
		]),
	dE: 'About Lisa'
};
var $author$project$View$Astrolabe$Interactive = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$MeditationPressStart = function (a) {
	return {$: 31, a: a};
};
var $author$project$View$Compass$chargeOverlay = function (m) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute inset-0 z-30 flex items-center justify-center pointer-events-none px-6')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('compass-charge-shake')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('compass-charge-chroma')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('compass-charge-name flex flex-col items-center text-center gap-3')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-cream/55 text-[10px] tracking-[0.5em] uppercase'),
												A2($elm$html$Html$Attributes$style, 'color', m.be)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Beginning')
											])),
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-display italic-display text-gold leading-none'),
												A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(3rem, 12vw, 6rem)'),
												A2($elm$html$Html$Attributes$style, 'text-shadow', '0 0 40px ' + (m.be + ('cc, 0 0 80px ' + (m.be + '55'))))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(m.bG)
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-cream/80 italic font-display text-base sm:text-lg max-w-md')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(m.bi)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$View$Compass$compassBreath = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-1.5')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gold-brass/70 text-[10px] tracking-[0.4em] uppercase')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Before you begin')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-display italic-display text-gold-soft text-lg leading-tight')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Three slow breaths.')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-cream/55 text-[11px] leading-relaxed')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('In through the nose, out through the mouth.')
				]))
		]));
var $author$project$View$Compass$compassFooter = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-1.5 items-end')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gold-brass/70 text-[10px] tracking-[0.4em] uppercase')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Last session')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-display text-gold-soft text-2xl 2xl:text-3xl')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('—')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-cream/55 text-[11px] leading-relaxed')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Your next meditation begins your streak.')
				]))
		]));
var $author$project$View$Compass$compassPrompt = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-3')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-display italic-display text-gold-soft text-xl 2xl:text-2xl leading-[1.3]')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Choose by feeling, not by category.')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('compass-prompt-body')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Twenty-four directions. Each one is an intention. The compass remembers.')
				]))
		]));
var $author$project$View$Compass$compassSideMark = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center gap-3 text-gold-brass/70 text-[10px] tracking-[0.45em] uppercase font-medium')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-8 h-px bg-gold-brass/40')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]))
			]));
};
var $author$project$View$Compass$compassSignal = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-3 items-end')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gold-soft text-lg tracking-widest leading-none mb-1')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('✦')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-display italic-display text-gold-soft text-xl 2xl:text-2xl leading-[1.3] text-right')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Begin with '),
					A2(
					$elm$html$Html$em,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Peace.')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('compass-prompt-body text-right')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Gold biases toward what your week needs. Trust the pull.')
				]))
		]));
var $author$project$View$Compass$overlineCenter = F2(
	function (title, subtitle) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center gap-2 text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-center gap-3 text-[10px] uppercase tracking-[0.4em] font-medium')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('compass-overline-crest')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('✦')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-6 h-px bg-gradient-to-r from-transparent via-gold-brass/60 to-transparent')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('overline-gold-leaf')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-6 h-px bg-gradient-to-l from-transparent via-gold-brass/60 to-transparent')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('compass-overline-crest')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('✦')
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/55 italic font-display text-sm tracking-wide')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(subtitle)
						]))
				]));
	});
var $elm$core$Basics$cos = _Basics_cos;
var $elm$svg$Svg$Attributes$dominantBaseline = _VirtualDom_attribute('dominant-baseline');
var $elm$svg$Svg$Attributes$fontFamily = _VirtualDom_attribute('font-family');
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $elm$svg$Svg$Attributes$fontStyle = _VirtualDom_attribute('font-style');
var $elm$svg$Svg$Attributes$fontWeight = _VirtualDom_attribute('font-weight');
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$svg$Svg$Attributes$letterSpacing = _VirtualDom_attribute('letter-spacing');
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$sin = _Basics_sin;
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$View$Astrolabe$cardinal = F2(
	function (angle, label) {
		var rad = ((angle - 90) * $elm$core$Basics$pi) / 180;
		var r = 378;
		var x = 400 + (r * $elm$core$Basics$cos(rad));
		var y = 400 + (r * $elm$core$Basics$sin(rad));
		return A2(
			$elm$svg$Svg$text_,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromFloat(x)),
					$elm$svg$Svg$Attributes$y(
					$elm$core$String$fromFloat(y)),
					$elm$svg$Svg$Attributes$fontSize('32'),
					$elm$svg$Svg$Attributes$fontWeight('600'),
					$elm$svg$Svg$Attributes$fill('url(#rimGold)'),
					$elm$svg$Svg$Attributes$textAnchor('middle'),
					$elm$svg$Svg$Attributes$dominantBaseline('central'),
					$elm$svg$Svg$Attributes$opacity('0.95'),
					$elm$svg$Svg$Attributes$fontFamily('Cormorant Garamond, serif'),
					$elm$svg$Svg$Attributes$fontStyle('italic'),
					$elm$svg$Svg$Attributes$letterSpacing('0.04em'),
					$elm$svg$Svg$Attributes$class('astrolabe-cardinal-letter')
				]),
			_List_fromArray(
				[
					$elm$svg$Svg$text(label)
				]));
	});
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $author$project$View$Astrolabe$innerRimTicks = F3(
	function (n, r0, r1) {
		return A2(
			$elm$core$List$map,
			function (i) {
				var angle = i * (360 / n);
				var rad = ((angle - 90) * $elm$core$Basics$pi) / 180;
				var x0 = 400 + (r0 * $elm$core$Basics$cos(rad));
				var x1 = 400 + (r1 * $elm$core$Basics$cos(rad));
				var y0 = 400 + (r0 * $elm$core$Basics$sin(rad));
				var y1 = 400 + (r1 * $elm$core$Basics$sin(rad));
				return A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1(
							$elm$core$String$fromFloat(x0)),
							$elm$svg$Svg$Attributes$y1(
							$elm$core$String$fromFloat(y0)),
							$elm$svg$Svg$Attributes$x2(
							$elm$core$String$fromFloat(x1)),
							$elm$svg$Svg$Attributes$y2(
							$elm$core$String$fromFloat(y1)),
							$elm$svg$Svg$Attributes$stroke('#D4AF37'),
							$elm$svg$Svg$Attributes$strokeWidth('0.6')
						]),
					_List_Nil);
			},
			A2($elm$core$List$range, 0, n - 1));
	});
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polygon = $elm$svg$Svg$trustedNode('polygon');
var $author$project$View$Astrolabe$compassRoseCenter = A2(
	$elm$svg$Svg$g,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('compass-rose-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('400'),
					$elm$svg$Svg$Attributes$cy('400'),
					$elm$svg$Svg$Attributes$r('80'),
					$elm$svg$Svg$Attributes$fill('#02000a')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('400'),
					$elm$svg$Svg$Attributes$cy('400'),
					$elm$svg$Svg$Attributes$r('78'),
					$elm$svg$Svg$Attributes$fill('url(#discDepth)')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('400'),
					$elm$svg$Svg$Attributes$cy('400'),
					$elm$svg$Svg$Attributes$r('80'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('url(#rimGold)'),
					$elm$svg$Svg$Attributes$strokeWidth('2.5')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('400'),
					$elm$svg$Svg$Attributes$cy('400'),
					$elm$svg$Svg$Attributes$r('78'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('#000'),
					$elm$svg$Svg$Attributes$strokeWidth('1'),
					$elm$svg$Svg$Attributes$opacity('0.6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('400'),
					$elm$svg$Svg$Attributes$cy('400'),
					$elm$svg$Svg$Attributes$r('65'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('#D4AF37'),
					$elm$svg$Svg$Attributes$strokeWidth('0.8'),
					$elm$svg$Svg$Attributes$opacity('0.55')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$opacity('0.4')
				]),
			A3($author$project$View$Astrolabe$innerRimTicks, 16, 72, 76)),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$opacity('0.98')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,330 412,400 400,470 388,400'),
							$elm$svg$Svg$Attributes$fill('url(#brassRose)')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('330,400 400,388 470,400 400,412'),
							$elm$svg$Svg$Attributes$fill('#D4AF37'),
							$elm$svg$Svg$Attributes$opacity('0.88')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,330 405,400 400,395'),
							$elm$svg$Svg$Attributes$fill('#fff8c8'),
							$elm$svg$Svg$Attributes$opacity('0.75')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('362,362 400,395 405,400'),
							$elm$svg$Svg$Attributes$fill('#fff8c8'),
							$elm$svg$Svg$Attributes$opacity('0.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('438,362 405,400 400,395'),
							$elm$svg$Svg$Attributes$fill('#fff8c8'),
							$elm$svg$Svg$Attributes$opacity('0.3')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,470 395,400 400,405'),
							$elm$svg$Svg$Attributes$fill('#000'),
							$elm$svg$Svg$Attributes$opacity('0.4')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('438,438 400,405 395,400'),
							$elm$svg$Svg$Attributes$fill('#000'),
							$elm$svg$Svg$Attributes$opacity('0.3')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('400'),
					$elm$svg$Svg$Attributes$cy('400'),
					$elm$svg$Svg$Attributes$r('16'),
					$elm$svg$Svg$Attributes$fill('url(#jewelHalo)')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('400'),
					$elm$svg$Svg$Attributes$cy('400'),
					$elm$svg$Svg$Attributes$r('8.5'),
					$elm$svg$Svg$Attributes$fill('#02000a')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('400'),
					$elm$svg$Svg$Attributes$cy('400'),
					$elm$svg$Svg$Attributes$r('7'),
					$elm$svg$Svg$Attributes$fill('url(#jewelFacet)')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('395.5,395.5 400,392 400,400'),
					$elm$svg$Svg$Attributes$fill('#fff8c8'),
					$elm$svg$Svg$Attributes$opacity('0.95')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('400,408 404.5,404.5 400,400'),
					$elm$svg$Svg$Attributes$fill('#8a6f26'),
					$elm$svg$Svg$Attributes$opacity('0.5')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('397.5'),
					$elm$svg$Svg$Attributes$cy('397.5'),
					$elm$svg$Svg$Attributes$r('1.4'),
					$elm$svg$Svg$Attributes$fill('#fff'),
					$elm$svg$Svg$Attributes$opacity('0.95')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('compass-needle compass-needle--mana')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,260 390,400 410,400'),
							$elm$svg$Svg$Attributes$fill('url(#manaNorth)'),
							$elm$svg$Svg$Attributes$opacity('0.35'),
							$elm$svg$Svg$Attributes$class('compass-needle__aura-n')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,540 390,400 410,400'),
							$elm$svg$Svg$Attributes$fill('url(#manaSouth)'),
							$elm$svg$Svg$Attributes$opacity('0.25'),
							$elm$svg$Svg$Attributes$class('compass-needle__aura-s')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,270 395,400 405,400'),
							$elm$svg$Svg$Attributes$fill('url(#manaNorth)'),
							$elm$svg$Svg$Attributes$class('compass-needle__blade-n')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,270 399.7,400 400.3,400'),
							$elm$svg$Svg$Attributes$fill('#ffffff'),
							$elm$svg$Svg$Attributes$opacity('0.95'),
							$elm$svg$Svg$Attributes$class('compass-needle__spine-n')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,270 400,400 405,400'),
							$elm$svg$Svg$Attributes$fill('#000'),
							$elm$svg$Svg$Attributes$opacity('0.25')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,530 395,400 405,400'),
							$elm$svg$Svg$Attributes$fill('url(#manaSouth)'),
							$elm$svg$Svg$Attributes$class('compass-needle__blade-s')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$points('400,530 400,400 402,400'),
							$elm$svg$Svg$Attributes$fill('#5a4218'),
							$elm$svg$Svg$Attributes$opacity('0.6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1('400'),
							$elm$svg$Svg$Attributes$y1('270'),
							$elm$svg$Svg$Attributes$x2('400'),
							$elm$svg$Svg$Attributes$y2('530'),
							$elm$svg$Svg$Attributes$stroke('#fff8c8'),
							$elm$svg$Svg$Attributes$strokeWidth('0.8'),
							$elm$svg$Svg$Attributes$opacity('0.85'),
							$elm$svg$Svg$Attributes$class('compass-needle__energy-core')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('400'),
							$elm$svg$Svg$Attributes$cy('400'),
							$elm$svg$Svg$Attributes$r('11'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$stroke('url(#rimGold)'),
							$elm$svg$Svg$Attributes$strokeWidth('0.6'),
							$elm$svg$Svg$Attributes$opacity('0.7')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('400'),
							$elm$svg$Svg$Attributes$cy('400'),
							$elm$svg$Svg$Attributes$r('9'),
							$elm$svg$Svg$Attributes$fill('url(#brassRose)')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('400'),
							$elm$svg$Svg$Attributes$cy('389'),
							$elm$svg$Svg$Attributes$r('0.8'),
							$elm$svg$Svg$Attributes$fill('#fff8c8')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('411'),
							$elm$svg$Svg$Attributes$cy('400'),
							$elm$svg$Svg$Attributes$r('0.8'),
							$elm$svg$Svg$Attributes$fill('#fff8c8')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('400'),
							$elm$svg$Svg$Attributes$cy('411'),
							$elm$svg$Svg$Attributes$r('0.8'),
							$elm$svg$Svg$Attributes$fill('#fff8c8')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('389'),
							$elm$svg$Svg$Attributes$cy('400'),
							$elm$svg$Svg$Attributes$r('0.8'),
							$elm$svg$Svg$Attributes$fill('#fff8c8')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('407.8'),
							$elm$svg$Svg$Attributes$cy('392.2'),
							$elm$svg$Svg$Attributes$r('0.6'),
							$elm$svg$Svg$Attributes$fill('#D4AF37')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('407.8'),
							$elm$svg$Svg$Attributes$cy('407.8'),
							$elm$svg$Svg$Attributes$r('0.6'),
							$elm$svg$Svg$Attributes$fill('#D4AF37')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('392.2'),
							$elm$svg$Svg$Attributes$cy('407.8'),
							$elm$svg$Svg$Attributes$r('0.6'),
							$elm$svg$Svg$Attributes$fill('#D4AF37')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('392.2'),
							$elm$svg$Svg$Attributes$cy('392.2'),
							$elm$svg$Svg$Attributes$r('0.6'),
							$elm$svg$Svg$Attributes$fill('#D4AF37')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('400'),
							$elm$svg$Svg$Attributes$cy('400'),
							$elm$svg$Svg$Attributes$r('5.5'),
							$elm$svg$Svg$Attributes$fill('#02000a')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('400'),
							$elm$svg$Svg$Attributes$cy('400'),
							$elm$svg$Svg$Attributes$r('3'),
							$elm$svg$Svg$Attributes$fill('url(#manaNorth)'),
							$elm$svg$Svg$Attributes$class('compass-needle__pivot-core')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('399'),
							$elm$svg$Svg$Attributes$cy('399'),
							$elm$svg$Svg$Attributes$r('0.8'),
							$elm$svg$Svg$Attributes$fill('#fff'),
							$elm$svg$Svg$Attributes$opacity('0.95')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 322,400 A 78,78 0 0 1 478,400 L 478,398 A 78,78 0 0 0 322,398 Z'),
					$elm$svg$Svg$Attributes$fill('url(#domeReflection)'),
					$elm$svg$Svg$Attributes$opacity('0.55')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 340,373 Q 400,335 460,373'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('url(#domeHighlight)'),
					$elm$svg$Svg$Attributes$strokeWidth('1.5'),
					$elm$svg$Svg$Attributes$opacity('0.5'),
					$elm$svg$Svg$Attributes$strokeLinecap('round')
				]),
			_List_Nil)
		]));
var $author$project$View$Astrolabe$constellationLines = function () {
	var line = function (angle) {
		var rad = ((angle - 90) * $elm$core$Basics$pi) / 180;
		var r = 295;
		var x1 = 400 + (r * $elm$core$Basics$cos(rad));
		var x2 = 400 - (r * $elm$core$Basics$cos(rad));
		var y1 = 400 + (r * $elm$core$Basics$sin(rad));
		var y2 = 400 - (r * $elm$core$Basics$sin(rad));
		return A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1(
					$elm$core$String$fromFloat(x1)),
					$elm$svg$Svg$Attributes$y1(
					$elm$core$String$fromFloat(y1)),
					$elm$svg$Svg$Attributes$x2(
					$elm$core$String$fromFloat(x2)),
					$elm$svg$Svg$Attributes$y2(
					$elm$core$String$fromFloat(y2)),
					$elm$svg$Svg$Attributes$stroke('#FFD700'),
					$elm$svg$Svg$Attributes$strokeWidth('0.4')
				]),
			_List_Nil);
	};
	return A2(
		$elm$core$List$map,
		line,
		_List_fromArray(
			[0, 30, 60, 90, 120, 150]));
}();
var $author$project$View$Astrolabe$engravedNumerals = function () {
	var positions = _List_fromArray(
		[
			_Utils_Tuple2(30, 'I'),
			_Utils_Tuple2(60, 'II'),
			_Utils_Tuple2(120, 'IV'),
			_Utils_Tuple2(150, 'V'),
			_Utils_Tuple2(210, 'VII'),
			_Utils_Tuple2(240, 'VIII'),
			_Utils_Tuple2(300, 'X'),
			_Utils_Tuple2(330, 'XI')
		]);
	var engrave = function (_v0) {
		var angle = _v0.a;
		var numeral = _v0.b;
		var rad = ((angle - 90) * $elm$core$Basics$pi) / 180;
		var r = 310;
		var x = 400 + (r * $elm$core$Basics$cos(rad));
		var y = 400 + (r * $elm$core$Basics$sin(rad));
		return A2(
			$elm$svg$Svg$text_,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromFloat(x)),
					$elm$svg$Svg$Attributes$y(
					$elm$core$String$fromFloat(y)),
					$elm$svg$Svg$Attributes$fontSize('11'),
					$elm$svg$Svg$Attributes$fontWeight('500'),
					$elm$svg$Svg$Attributes$fill('#D4AF37'),
					$elm$svg$Svg$Attributes$textAnchor('middle'),
					$elm$svg$Svg$Attributes$dominantBaseline('central'),
					$elm$svg$Svg$Attributes$opacity('0.55'),
					$elm$svg$Svg$Attributes$fontFamily('Cormorant Garamond, serif'),
					$elm$svg$Svg$Attributes$fontStyle('italic'),
					$elm$svg$Svg$Attributes$letterSpacing('0.05em')
				]),
			_List_fromArray(
				[
					$elm$svg$Svg$text(numeral)
				]));
	};
	return A2($elm$core$List$map, engrave, positions);
}();
var $author$project$View$Astrolabe$flowerOfLife = function () {
	var r = 70;
	var positions = _List_fromArray(
		[
			_Utils_Tuple2(0, 0),
			_Utils_Tuple2(r, 0),
			_Utils_Tuple2(-r, 0),
			_Utils_Tuple2(r * 0.5, r * 0.866),
			_Utils_Tuple2((-r) * 0.5, r * 0.866),
			_Utils_Tuple2(r * 0.5, (-r) * 0.866),
			_Utils_Tuple2((-r) * 0.5, (-r) * 0.866)
		]);
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var dx = _v0.a;
			var dy = _v0.b;
			return A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx(
						$elm$core$String$fromFloat(400 + dx)),
						$elm$svg$Svg$Attributes$cy(
						$elm$core$String$fromFloat(400 + dy)),
						$elm$svg$Svg$Attributes$r(
						$elm$core$String$fromFloat(r)),
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$stroke('#FFD700'),
						$elm$svg$Svg$Attributes$strokeWidth('0.7')
					]),
				_List_Nil);
		},
		positions);
}();
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$View$Astrolabe$meditationDot = F3(
	function (mode, idx, m) {
		var rad = ((m.a3 - 90) * $elm$core$Basics$pi) / 180;
		var r = 295;
		var x = 400 + (r * $elm$core$Basics$cos(rad));
		var y = 400 + (r * $elm$core$Basics$sin(rad));
		var pulseDelay = $elm$core$String$fromFloat(idx * 0.29) + 's';
		var dotStyle = 'cursor: pointer; color: ' + (m.be + ('; --pulse-delay: ' + pulseDelay));
		var events = function () {
			if (!mode.$) {
				return _List_Nil;
			} else {
				var cfg = mode.a;
				var isTapping = _Utils_eq(
					cfg.aD,
					$elm$core$Maybe$Just(m.cP));
				var isJustFrom = _Utils_eq(
					cfg.aw,
					$elm$core$Maybe$Just(m.cP));
				var justFromAttrs = isJustFrom ? _List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-just-from',
						$author$project$Service$MeditationData$idToString(m.cP))
					]) : _List_Nil;
				var dotClass = 'astrolabe-dot' + (isTapping ? ' astrolabe-dot--charging' : '');
				var keyDecoder = A2(
					$elm$json$Json$Decode$andThen,
					function (k) {
						return ((k === 'Enter') || (k === ' ')) ? $elm$json$Json$Decode$succeed(
							_Utils_Tuple2(
								cfg.bN(m.cP),
								true)) : $elm$json$Json$Decode$fail('ignore');
					},
					A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
				return _Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Events$stopPropagationOn,
							'click',
							$elm$json$Json$Decode$succeed(
								_Utils_Tuple2(
									cfg.bN(m.cP),
									true))),
							A2($elm$html$Html$Events$stopPropagationOn, 'keydown', keyDecoder),
							A2($elm$html$Html$Attributes$attribute, 'tabindex', '0'),
							A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
							A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Begin ' + m.bG),
							$elm$svg$Svg$Attributes$style(dotStyle),
							$elm$svg$Svg$Attributes$class(dotClass)
						]),
					justFromAttrs);
			}
		}();
		var _v0 = m.bz ? _Utils_Tuple3('1', '0.4', '0.14') : _Utils_Tuple3('0.45', '0.18', '0.07');
		var dotOpacity = _v0.a;
		var midHaloOpacity = _v0.b;
		var outerHaloOpacity = _v0.c;
		return A2(
			$elm$svg$Svg$g,
			events,
			_List_fromArray(
				[
					function () {
					if (!mode.$) {
						return $elm$svg$Svg$text('');
					} else {
						return A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx(
									$elm$core$String$fromFloat(x)),
									$elm$svg$Svg$Attributes$cy(
									$elm$core$String$fromFloat(y)),
									$elm$svg$Svg$Attributes$r('38'),
									$elm$svg$Svg$Attributes$class('astrolabe-hit')
								]),
							_List_Nil);
					}
				}(),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y)),
							$elm$svg$Svg$Attributes$r('30'),
							$elm$svg$Svg$Attributes$fill(m.be),
							$elm$svg$Svg$Attributes$fillOpacity(outerHaloOpacity),
							$elm$svg$Svg$Attributes$class('dot-halo')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y)),
							$elm$svg$Svg$Attributes$r('16'),
							$elm$svg$Svg$Attributes$fill(m.be),
							$elm$svg$Svg$Attributes$fillOpacity(midHaloOpacity),
							$elm$svg$Svg$Attributes$class('dot-halo')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y)),
							$elm$svg$Svg$Attributes$r(
							m.bz ? '10' : '7'),
							$elm$svg$Svg$Attributes$fill('#02000a'),
							$elm$svg$Svg$Attributes$opacity(dotOpacity)
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y)),
							$elm$svg$Svg$Attributes$r(
							m.bz ? '9' : '6'),
							$elm$svg$Svg$Attributes$fill(m.be),
							$elm$svg$Svg$Attributes$opacity(dotOpacity)
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y)),
							$elm$svg$Svg$Attributes$r(
							m.bz ? '9' : '6'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$stroke('#D4AF37'),
							$elm$svg$Svg$Attributes$strokeWidth('0.7'),
							$elm$svg$Svg$Attributes$opacity(
							m.bz ? '0.85' : '0.45')
						]),
					_List_Nil),
					m.bz ? A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x - 2.2)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y - 2.2)),
							$elm$svg$Svg$Attributes$r('2.6'),
							$elm$svg$Svg$Attributes$fill('#fff'),
							$elm$svg$Svg$Attributes$opacity('0.85')
						]),
					_List_Nil) : $elm$svg$Svg$text(''),
					m.bz ? A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x - 2.8)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y - 2.8)),
							$elm$svg$Svg$Attributes$r('0.9'),
							$elm$svg$Svg$Attributes$fill('#fff'),
							$elm$svg$Svg$Attributes$opacity('1')
						]),
					_List_Nil) : $elm$svg$Svg$text(''),
					m.bz ? A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x + 2.4)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y + 2.4)),
							$elm$svg$Svg$Attributes$r('2.2'),
							$elm$svg$Svg$Attributes$fill('#000'),
							$elm$svg$Svg$Attributes$opacity('0.30')
						]),
					_List_Nil) : $elm$svg$Svg$text('')
				]));
	});
var $elm$svg$Svg$radialGradient = $elm$svg$Svg$trustedNode('radialGradient');
var $elm$svg$Svg$Attributes$stopOpacity = _VirtualDom_attribute('stop-opacity');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $author$project$View$Astrolabe$tickMark = function (i) {
	var isMajor = !A2($elm$core$Basics$modBy, 6, i);
	var angle = i * 5;
	var _v0 = isMajor ? _Utils_Tuple3('60', '0.85', '1.5') : _Utils_Tuple3('70', '0.3', '1');
	var y2 = _v0.a;
	var opacity = _v0.b;
	var width = _v0.c;
	return A2(
		$elm$svg$Svg$line,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x1('400'),
				$elm$svg$Svg$Attributes$y1('60'),
				$elm$svg$Svg$Attributes$x2('400'),
				$elm$svg$Svg$Attributes$y2(y2),
				$elm$svg$Svg$Attributes$stroke('#D4AF37'),
				$elm$svg$Svg$Attributes$strokeWidth(width),
				$elm$svg$Svg$Attributes$opacity(opacity),
				$elm$svg$Svg$Attributes$transform(
				'rotate(' + ($elm$core$String$fromFloat(angle) + ' 400 400)'))
			]),
		_List_Nil);
};
var $author$project$View$Astrolabe$view = function (mode) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('relative w-full aspect-square mx-auto')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 800 800'),
						$elm$svg$Svg$Attributes$class('w-full h-full'),
						A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', 'An astrolabe showing 24 meditations arranged by intention')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$radialGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('centerBloom')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700'),
												$elm$svg$Svg$Attributes$stopOpacity('0.32')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('55%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700'),
												$elm$svg$Svg$Attributes$stopOpacity('0.08')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700'),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$radialGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('depthWell')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#1a0f30'),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('60%'),
												$elm$svg$Svg$Attributes$stopColor('#1a0f30'),
												$elm$svg$Svg$Attributes$stopOpacity('0.25')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#05010c'),
												$elm$svg$Svg$Attributes$stopOpacity('0.55')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('rimGold'),
										$elm$svg$Svg$Attributes$x1('0%'),
										$elm$svg$Svg$Attributes$y1('0%'),
										$elm$svg$Svg$Attributes$x2('100%'),
										$elm$svg$Svg$Attributes$y2('100%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('30%'),
												$elm$svg$Svg$Attributes$stopColor('#fff8c8')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('70%'),
												$elm$svg$Svg$Attributes$stopColor('#D4AF37')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$radialGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('brassRose'),
										$elm$svg$Svg$Attributes$cx('30%'),
										$elm$svg$Svg$Attributes$cy('30%'),
										$elm$svg$Svg$Attributes$r('75%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#fff8c8')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('30%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('65%'),
												$elm$svg$Svg$Attributes$stopColor('#D4AF37')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#8a6f26')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$radialGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('discDepth'),
										$elm$svg$Svg$Attributes$cx('50%'),
										$elm$svg$Svg$Attributes$cy('50%'),
										$elm$svg$Svg$Attributes$r('50%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#1a0f30'),
												$elm$svg$Svg$Attributes$stopOpacity('0.5')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('60%'),
												$elm$svg$Svg$Attributes$stopColor('#02000a'),
												$elm$svg$Svg$Attributes$stopOpacity('0.7')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#02000a'),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('domeReflection'),
										$elm$svg$Svg$Attributes$x1('0%'),
										$elm$svg$Svg$Attributes$y1('0%'),
										$elm$svg$Svg$Attributes$x2('0%'),
										$elm$svg$Svg$Attributes$y2('100%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#fff8c8'),
												$elm$svg$Svg$Attributes$stopOpacity('0.45')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#fff'),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('domeHighlight'),
										$elm$svg$Svg$Attributes$x1('0%'),
										$elm$svg$Svg$Attributes$y1('0%'),
										$elm$svg$Svg$Attributes$x2('100%'),
										$elm$svg$Svg$Attributes$y2('0%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#fff'),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('50%'),
												$elm$svg$Svg$Attributes$stopColor('#fff'),
												$elm$svg$Svg$Attributes$stopOpacity('0.85')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#fff'),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$radialGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('jewelHalo'),
										$elm$svg$Svg$Attributes$cx('50%'),
										$elm$svg$Svg$Attributes$cy('50%'),
										$elm$svg$Svg$Attributes$r('50%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700'),
												$elm$svg$Svg$Attributes$stopOpacity('0.4')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('70%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700'),
												$elm$svg$Svg$Attributes$stopOpacity('0.1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700'),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$radialGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('jewelFacet'),
										$elm$svg$Svg$Attributes$cx('30%'),
										$elm$svg$Svg$Attributes$cy('30%'),
										$elm$svg$Svg$Attributes$r('75%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#fff8c8')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('40%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('75%'),
												$elm$svg$Svg$Attributes$stopColor('#D4AF37')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#8a6f26')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('manaNorth'),
										$elm$svg$Svg$Attributes$x1('50%'),
										$elm$svg$Svg$Attributes$y1('0%'),
										$elm$svg$Svg$Attributes$x2('50%'),
										$elm$svg$Svg$Attributes$y2('100%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#ffffff'),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('8%'),
												$elm$svg$Svg$Attributes$stopColor('#fff8c8'),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('35%'),
												$elm$svg$Svg$Attributes$stopColor('#FFD700'),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('70%'),
												$elm$svg$Svg$Attributes$stopColor('#D4AF37'),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#8a6f26'),
												$elm$svg$Svg$Attributes$stopOpacity('0.95')
											]),
										_List_Nil)
									])),
								A2(
								$elm$svg$Svg$linearGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('manaSouth'),
										$elm$svg$Svg$Attributes$x1('50%'),
										$elm$svg$Svg$Attributes$y1('0%'),
										$elm$svg$Svg$Attributes$x2('50%'),
										$elm$svg$Svg$Attributes$y2('100%')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#8a6f26'),
												$elm$svg$Svg$Attributes$stopOpacity('0.95')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('40%'),
												$elm$svg$Svg$Attributes$stopColor('#2a1a4a'),
												$elm$svg$Svg$Attributes$stopOpacity('0.95')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#0a0419'),
												$elm$svg$Svg$Attributes$stopOpacity('1')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('380'),
								$elm$svg$Svg$Attributes$fill('url(#depthWell)')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('380'),
								$elm$svg$Svg$Attributes$fill('url(#centerBloom)'),
								$elm$svg$Svg$Attributes$class('astrolabe-bloom')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('astrolabe-flower')
							]),
						$author$project$View$Astrolabe$flowerOfLife),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('350'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke('url(#rimGold)'),
								$elm$svg$Svg$Attributes$strokeWidth('1.5'),
								$elm$svg$Svg$Attributes$class('compass-pulse compass-glow astrolabe-rim')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('330'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke('url(#rimGold)'),
								$elm$svg$Svg$Attributes$strokeWidth('2.5'),
								$elm$svg$Svg$Attributes$class('astrolabe-rim-outer')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('323'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke('#D4AF37'),
								$elm$svg$Svg$Attributes$strokeWidth('0.6'),
								$elm$svg$Svg$Attributes$opacity('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('348'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke('#D4AF37'),
								$elm$svg$Svg$Attributes$strokeWidth('0.4'),
								$elm$svg$Svg$Attributes$opacity('0.35')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('astrolabe-leylines')
							]),
						$author$project$View$Astrolabe$constellationLines),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('240'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke('#D4AF37'),
								$elm$svg$Svg$Attributes$strokeWidth('0.8'),
								$elm$svg$Svg$Attributes$opacity('0.4'),
								$elm$svg$Svg$Attributes$class('astrolabe-ring-drums')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('150'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke('#D4AF37'),
								$elm$svg$Svg$Attributes$strokeWidth('0.6'),
								$elm$svg$Svg$Attributes$opacity('0.3'),
								$elm$svg$Svg$Attributes$class('astrolabe-ring-guitar')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('110'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke('#D4AF37'),
								$elm$svg$Svg$Attributes$strokeWidth('0.5'),
								$elm$svg$Svg$Attributes$opacity('0.28'),
								$elm$svg$Svg$Attributes$class('astrolabe-ring-bass')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('400'),
								$elm$svg$Svg$Attributes$cy('400'),
								$elm$svg$Svg$Attributes$r('200'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke('#D4AF37'),
								$elm$svg$Svg$Attributes$strokeWidth('0.5'),
								$elm$svg$Svg$Attributes$opacity('0.30'),
								$elm$svg$Svg$Attributes$class('astrolabe-ring-synth')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('astrolabe-ticks')
							]),
						A2(
							$elm$core$List$map,
							$author$project$View$Astrolabe$tickMark,
							A2($elm$core$List$range, 0, 71))),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('astrolabe-numerals')
							]),
						$author$project$View$Astrolabe$engravedNumerals),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('astrolabe-cardinals')
							]),
						_List_fromArray(
							[
								A2($author$project$View$Astrolabe$cardinal, 0, 'N'),
								A2($author$project$View$Astrolabe$cardinal, 90, 'E'),
								A2($author$project$View$Astrolabe$cardinal, 180, 'S'),
								A2($author$project$View$Astrolabe$cardinal, 270, 'W')
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('compass-ring')
							]),
						A2(
							$elm$core$List$indexedMap,
							$author$project$View$Astrolabe$meditationDot(mode),
							$author$project$Service$MeditationData$all)),
						$author$project$View$Astrolabe$compassRoseCenter
					]))
			]));
};
var $author$project$Model$GuideAdvanced = {$: 23};
var $author$project$Model$GuideFinished = {$: 24};
var $author$project$View$Guide$actions = function (isLast) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-between gap-4')
			]),
		_List_fromArray(
			[
				isLast ? A2($elm$html$Html$span, _List_Nil, _List_Nil) : A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tap juice-tap text-cream/45 hover:text-gold-soft text-[11px] tracking-[0.28em] uppercase px-2 py-3 -mx-2 transition-colors'),
						$elm$html$Html$Events$onClick($author$project$Model$GuideFinished)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Skip')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tap juice-tap juice-magnet juice-halo gold-leaf shimmer-button px-8 py-3.5 rounded-full font-semibold text-xs tracking-[0.25em] uppercase'),
						$elm$html$Html$Events$onClick(
						isLast ? $author$project$Model$GuideFinished : $author$project$Model$GuideAdvanced)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						isLast ? 'Begin' : 'Next')
					]))
			]));
};
var $author$project$View$Guide$glyphCharge = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('guide-charge relative w-[76px] h-[76px] flex items-center justify-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('guide-charge__ring'),
					A2($elm$html$Html$Attributes$style, '--ring-delay', '0s')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('guide-charge__ring'),
					A2($elm$html$Html$Attributes$style, '--ring-delay', '1.33s')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('guide-charge__ring'),
					A2($elm$html$Html$Attributes$style, '--ring-delay', '2.66s')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('guide-charge__core')
				]),
			_List_Nil)
		]));
var $author$project$View$Guide$glyphBox = function (children) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 100 100'),
				$elm$svg$Svg$Attributes$class('w-[76px] h-[76px]'),
				A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
			]),
		children);
};
var $author$project$View$Guide$glyphOpenAndLocked = $author$project$View$Guide$glyphBox(
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$radialGradient,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('guideOpenDot')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$offset('0%'),
									$elm$svg$Svg$Attributes$stopColor('#FFF8C8')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$offset('100%'),
									$elm$svg$Svg$Attributes$stopColor('#D4AF37')
								]),
							_List_Nil)
						]))
				])),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('32'),
					$elm$svg$Svg$Attributes$cy('50'),
					$elm$svg$Svg$Attributes$r('20'),
					$elm$svg$Svg$Attributes$fill('#FFD700'),
					$elm$svg$Svg$Attributes$opacity('0.14')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('32'),
					$elm$svg$Svg$Attributes$cy('50'),
					$elm$svg$Svg$Attributes$r('10'),
					$elm$svg$Svg$Attributes$fill('url(#guideOpenDot)')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('70'),
					$elm$svg$Svg$Attributes$cy('50'),
					$elm$svg$Svg$Attributes$r('10'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('#C7A466'),
					$elm$svg$Svg$Attributes$strokeWidth('1.4'),
					$elm$svg$Svg$Attributes$strokeDasharray('3 4'),
					$elm$svg$Svg$Attributes$opacity('0.65')
				]),
			_List_Nil)
		]));
var $author$project$View$Guide$glyphWheel = function () {
	var tick = function (i) {
		var isCardinal = !A2($elm$core$Basics$modBy, 6, i);
		var len = isCardinal ? 10 : 5;
		return A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('50'),
					$elm$svg$Svg$Attributes$y1('12'),
					$elm$svg$Svg$Attributes$x2('50'),
					$elm$svg$Svg$Attributes$y2(
					$elm$core$String$fromFloat(12 + len)),
					$elm$svg$Svg$Attributes$stroke('#D4AF37'),
					$elm$svg$Svg$Attributes$strokeWidth(
					isCardinal ? '1.6' : '1'),
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$opacity(
					isCardinal ? '0.95' : '0.5'),
					$elm$svg$Svg$Attributes$transform(
					'rotate(' + ($elm$core$String$fromFloat(i * 15) + ' 50 50)'))
				]),
			_List_Nil);
	};
	return $author$project$View$Guide$glyphBox(
		_Utils_ap(
			A2(
				$elm$core$List$map,
				tick,
				A2($elm$core$List$range, 0, 23)),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('50'),
							$elm$svg$Svg$Attributes$cy('50'),
							$elm$svg$Svg$Attributes$r('38'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$stroke('#D4AF37'),
							$elm$svg$Svg$Attributes$strokeWidth('0.8'),
							$elm$svg$Svg$Attributes$opacity('0.4')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('50'),
							$elm$svg$Svg$Attributes$cy('50'),
							$elm$svg$Svg$Attributes$r('3'),
							$elm$svg$Svg$Attributes$fill('#FFD700'),
							$elm$svg$Svg$Attributes$opacity('0.9')
						]),
					_List_Nil)
				])));
}();
var $author$project$View$Guide$overline = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-center gap-3 text-[10px] uppercase tracking-[0.4em] font-medium')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('compass-overline-crest')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('✦')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-5 h-px bg-gradient-to-r from-transparent via-gold-brass/60 to-transparent')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('overline-gold-leaf')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-5 h-px bg-gradient-to-l from-transparent via-gold-brass/60 to-transparent')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('compass-overline-crest')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('✦')
					]))
			]));
};
var $author$project$View$Guide$beat = function (step) {
	var _v0 = function () {
		switch (step) {
			case 0:
				return _Utils_Tuple2('The Compass', $author$project$View$Guide$glyphWheel);
			case 1:
				return _Utils_Tuple2('Setting course', $author$project$View$Guide$glyphCharge);
			default:
				return _Utils_Tuple2('Your library', $author$project$View$Guide$glyphOpenAndLocked);
		}
	}();
	var overlineText = _v0.a;
	var glyph = _v0.b;
	var _v2 = function () {
		switch (step) {
			case 0:
				return _Utils_Tuple2('Twenty-four directions', 'One for every way you might arrive. Choose by feeling, not by category — the compass will meet you where you are.');
			case 1:
				return _Utils_Tuple2('Tap, then breathe', 'Tap a direction and stay with it. The compass takes four seconds to set course. Let that be your first breath in.');
			default:
				return _Utils_Tuple2('Gold is already yours', 'The lit directions are open to you now. The rest unlock together, whenever you\'re ready for them.');
		}
	}();
	var headline = _v2.a;
	var body = _v2.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('guide-beat flex flex-col items-center gap-4')
			]),
		_List_fromArray(
			[
				$author$project$View$Guide$overline(overlineText),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('guide-glyph')
					]),
				_List_fromArray(
					[glyph])),
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-display italic-display text-gold-soft leading-[1.1]'),
						A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(1.5rem, 6.5vw, 1.875rem)')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(headline)
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/70 text-sm sm:text-[0.95rem] leading-relaxed max-w-[22rem]')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(body)
					]))
			]));
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$View$Guide$pips = function (step) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-center gap-2'),
				A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
			]),
		A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'guide-pip' + (_Utils_eq(i, step) ? ' guide-pip--on' : ''))
						]),
					_List_Nil);
			},
			A2($elm$core$List$range, 0, $author$project$Model$guideStepCount - 1)));
};
var $author$project$View$Guide$viewOpen = function (rawStep) {
	var step = A3($elm$core$Basics$clamp, 0, $author$project$Model$guideStepCount - 1, rawStep);
	var isLast = _Utils_cmp(step, $author$project$Model$guideStepCount - 1) > -1;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('guide-veil fixed inset-0 z-40 flex flex-col items-center justify-end sm:justify-center px-4 pb-6 sm:pb-0 safe-pb'),
				A2($elm$html$Html$Attributes$attribute, 'role', 'dialog'),
				A2($elm$html$Html$Attributes$attribute, 'aria-modal', 'true'),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'How to read the compass')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('guide-veil__scrim absolute inset-0')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('editorial-stage guide-card relative w-full max-w-md flex flex-col gap-5 px-6 py-7 sm:px-8 sm:py-8')
					]),
				_List_fromArray(
					[
						A3(
						$elm$html$Html$Keyed$node,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col items-center gap-4 text-center')
							]),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'beat-' + $elm$core$String$fromInt(step),
								$author$project$View$Guide$beat(step))
							])),
						$author$project$View$Guide$pips(step),
						$author$project$View$Guide$actions(isLast)
					]))
			]));
};
var $author$project$View$Guide$view = function (guide) {
	var _v0 = guide.N;
	switch (_v0) {
		case 1:
			return $author$project$View$Guide$viewOpen(guide.b5);
		case 0:
			return $elm$html$Html$text('');
		default:
			return $elm$html$Html$text('');
	}
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Service$MeditationData$trimBase = function (baseUrl) {
	return A2($elm$core$String$endsWith, '/', baseUrl) ? A2($elm$core$String$dropRight, 1, baseUrl) : baseUrl;
};
var $author$project$Service$MeditationData$welcomeSampleUrl = function (baseUrl) {
	return $author$project$Service$MeditationData$trimBase(baseUrl) + '/samples/lisa-welcome.mp3';
};
var $author$project$View$Compass$welcomeClip = F2(
	function (caption, audioBaseUrl) {
		return A3(
			$elm$html$Html$node,
			'voice-clip',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'src',
					$author$project$Service$MeditationData$welcomeSampleUrl(audioBaseUrl)),
					A2($elm$html$Html$Attributes$attribute, 'caption', caption),
					A2($elm$html$Html$Attributes$attribute, 'probe', '')
				]),
			_List_Nil);
	});
var $author$project$View$Compass$view = F4(
	function (_v0, _v1, _v2, transitionState) {
		var focalMed = A2($elm$core$Maybe$andThen, $author$project$Service$MeditationData$byId, transitionState.aD);
		var chargingClass = function () {
			var _v7 = transitionState.aD;
			if (!_v7.$) {
				return ' compass--charging';
			} else {
				return '';
			}
		}();
		return {
			cs: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('juice-page-enter relative w-full' + chargingClass),
							A2($elm$html$Html$Attributes$style, 'height', 'calc(100dvh - var(--tab-bar-h) - var(--safe-bottom))')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('constellation')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute inset-0 flex items-center justify-center pointer-events-none px-2 sm:px-6')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('juice-dial-arrive editorial-stage editorial-stage--xl editorial-stage--flush relative pointer-events-auto aspect-square'),
											A2($elm$html$Html$Attributes$style, 'width', 'min(98vw, 72vh)'),
											A2($elm$html$Html$Attributes$style, 'max-width', '880px'),
											A2($elm$html$Html$Attributes$style, 'margin', '0')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('aurora-glow')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('compass-sun-rays')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('relative w-full h-full')
												]),
											_List_fromArray(
												[
													$author$project$View$Astrolabe$view(
													$author$project$View$Astrolabe$Interactive(
														{aw: transitionState.aw, bN: $author$project$Model$MeditationPressStart, aD: transitionState.aD}))
												]))
										]))
								])),
							function () {
							if (!focalMed.$) {
								var m = focalMed.a;
								return $author$project$View$Compass$chargeOverlay(m);
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							function () {
							var _v4 = transitionState.aD;
							if (!_v4.$) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('compass-charge-strobe')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('compass-charge-bloom')
												]),
											_List_Nil)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('lg:hidden relative z-10 pt-3 sm:pt-6 text-center pointer-events-none')
								]),
							_List_fromArray(
								[
									A2($author$project$View$Compass$overlineCenter, 'Choose your direction', 'Tap any meditation to begin')
								])),
							function () {
							var _v5 = transitionState.ck;
							if (!_v5.$) {
								var base = _v5.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('lg:hidden relative z-10 pt-2 flex justify-center')
										]),
									_List_fromArray(
										[
											A2($author$project$View$Compass$welcomeClip, 'Hear Lisa\'s welcome', base)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hidden xl:flex absolute left-6 2xl:left-12 top-1/2 -translate-y-1/2 flex-col gap-10 max-w-[16rem] z-10')
								]),
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$View$Compass$compassSideMark('The Compass'),
										$author$project$View$Compass$compassPrompt,
										$author$project$View$Compass$compassBreath
									]),
								function () {
									var _v6 = transitionState.ck;
									if (!_v6.$) {
										var base = _v6.a;
										return _List_fromArray(
											[
												A2($author$project$View$Compass$welcomeClip, 'Hear Lisa', base)
											]);
									} else {
										return _List_Nil;
									}
								}())),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hidden xl:flex absolute right-6 2xl:right-12 top-1/2 -translate-y-1/2 flex-col gap-10 max-w-[16rem] z-10 items-end text-right')
								]),
							_List_fromArray(
								[
									$author$project$View$Compass$compassSideMark('Tonight'),
									$author$project$View$Compass$compassSignal,
									$author$project$View$Compass$compassFooter
								]))
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2($elm$core$Maybe$map, $author$project$View$Guide$view, transitionState.aO))
				]),
			dE: 'Compass'
		};
	});
var $author$project$Model$ResetCodeChanged = function (a) {
	return {$: 16, a: a};
};
var $author$project$Model$ResetConfirmSubmit = {$: 19};
var $author$project$Model$ResetEmailSubmit = {$: 18};
var $author$project$Model$ResetNewPasswordChanged = function (a) {
	return {$: 17, a: a};
};
var $author$project$Model$ResetDismissed = {$: 14};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$View$Login$backToSignIn = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('tap self-center px-3 py-2 text-xs text-cream/45 hover:text-gold-soft transition-colors tracking-[0.18em] uppercase'),
			$elm$html$Html$Attributes$type_('button'),
			$elm$html$Html$Events$onClick($author$project$Model$ResetDismissed)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('← Back to sign in')
		]));
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$View$Login$overline = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-center gap-3 text-gold-brass/70 text-[10px] uppercase tracking-[0.4em] font-medium')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$View$Login$statusBlock = function (status) {
	switch (status.$) {
		case 2:
			var msg = status.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-start gap-3 px-4 py-3 rounded-2xl border border-gold-brass/30 bg-ink-soft/40 juice-fade-in')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gold-soft text-lg leading-none mt-px shrink-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('✦')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/85 text-sm leading-relaxed text-left')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(msg)
							]))
					]));
		case 1:
			return $elm$html$Html$text('');
		default:
			return $elm$html$Html$text('');
	}
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$View$Login$resetCodeView = function (resetState) {
	return {
		cs: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('editorial-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('constellation-quiet')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('editorial-stage flex flex-col gap-6 sm:gap-7')
							]),
						_List_fromArray(
							[
								$author$project$View$Login$overline('Check your email'),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center px-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-display text-gold-soft leading-[1.05]'),
												A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(1.875rem, 6vw, 2.75rem)')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('The code is'),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												A2(
												$elm$html$Html$em,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('italic-display text-gold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('on its way.')
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-3 text-cream/65 text-sm leading-relaxed break-words')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('We sent a six-digit code to '),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-gold-soft')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(resetState.aa)
													])),
												$elm$html$Html$text('. Enter it with your new password.')
											]))
									])),
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-3'),
										$elm$html$Html$Events$onSubmit($author$project$Model$ResetConfirmSubmit)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full px-5 py-5 rounded-2xl bg-ink-soft/60 border border-gold-brass/25 text-cream placeholder:text-cream/25 focus:outline-none focus:border-gold/70 focus:bg-ink-soft/80 transition-colors text-3xl text-center tracking-[0.45em] font-mono'),
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$name('code'),
												A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'one-time-code'),
												A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
												A2($elm$html$Html$Attributes$attribute, 'pattern', '[0-9]{6}'),
												$elm$html$Html$Attributes$maxlength(6),
												$elm$html$Html$Attributes$placeholder('000000'),
												$elm$html$Html$Attributes$value(resetState.bd),
												$elm$html$Html$Events$onInput($author$project$Model$ResetCodeChanged),
												$elm$html$Html$Attributes$required(true)
											]),
										_List_Nil),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('w-full px-5 py-4 rounded-2xl bg-ink-soft/60 border border-gold-brass/25 text-cream placeholder:text-cream/35 focus:outline-none focus:border-gold/70 focus:bg-ink-soft/80 transition-colors text-base'),
												$elm$html$Html$Attributes$type_('password'),
												$elm$html$Html$Attributes$name('new-password'),
												A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'new-password'),
												A2($elm$html$Html$Attributes$attribute, 'minlength', '8'),
												$elm$html$Html$Attributes$placeholder('New password (8+ characters)'),
												$elm$html$Html$Attributes$value(resetState.bI),
												$elm$html$Html$Events$onInput($author$project$Model$ResetNewPasswordChanged),
												$elm$html$Html$Attributes$required(true)
											]),
										_List_Nil),
										$author$project$View$Login$statusBlock(resetState.N),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tap gold-leaf shimmer-button juice-tap juice-magnet juice-halo mt-2 px-6 py-4 rounded-full font-semibold text-sm tracking-[0.22em] uppercase disabled:opacity-50'),
												$elm$html$Html$Attributes$type_('submit'),
												$elm$html$Html$Attributes$disabled(
												_Utils_eq(resetState.N, $author$project$Model$FormSubmitting) || (($elm$core$String$length(resetState.bd) < 6) || ($elm$core$String$length(resetState.bI) < 8)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												_Utils_eq(resetState.N, $author$project$Model$FormSubmitting) ? 'Setting your password…' : 'Set new password')
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tap self-center mt-1 px-3 py-2 text-xs text-cream/45 hover:text-gold-soft transition-colors tracking-[0.18em] uppercase'),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Events$onClick($author$project$Model$ResetEmailSubmit)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Send a fresh code')
											])),
										$author$project$View$Login$backToSignIn
									]))
							]))
					]))
			]),
		dE: 'Reset password'
	};
};
var $author$project$Model$ResetEmailChanged = function (a) {
	return {$: 15, a: a};
};
var $author$project$View$Login$field = F6(
	function (fieldName, fieldType, autocomplete, labelText, value_, onChange) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full px-5 py-4 rounded-2xl bg-ink-soft/60 border border-gold-brass/25 text-cream placeholder:text-cream/35 focus:outline-none focus:border-gold/70 focus:bg-ink-soft/80 transition-colors text-base'),
					$elm$html$Html$Attributes$type_(fieldType),
					$elm$html$Html$Attributes$name(fieldName),
					A2($elm$html$Html$Attributes$attribute, 'autocomplete', autocomplete),
					$elm$html$Html$Attributes$placeholder(labelText),
					$elm$html$Html$Attributes$value(value_),
					$elm$html$Html$Events$onInput(onChange),
					$elm$html$Html$Attributes$required(true)
				]),
			_List_Nil);
	});
var $author$project$View$Login$resetEmailView = function (resetState) {
	return {
		cs: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('editorial-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('constellation-quiet')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('editorial-stage flex flex-col gap-6 sm:gap-7')
							]),
						_List_fromArray(
							[
								$author$project$View$Login$overline('Reset password'),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center px-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-display text-gold-soft leading-[1.05]'),
												A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(1.875rem, 6vw, 2.75rem)')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Lost the map?'),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												A2(
												$elm$html$Html$em,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('italic-display text-gold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('We\'ll redraw it.')
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-3 text-cream/60 text-sm leading-relaxed')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Tell us your email and we\'ll send a six-digit code to set a fresh password.')
											]))
									])),
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-3'),
										$elm$html$Html$Events$onSubmit($author$project$Model$ResetEmailSubmit)
									]),
								_List_fromArray(
									[
										A6($author$project$View$Login$field, 'email', 'email', 'email', 'Email', resetState.aa, $author$project$Model$ResetEmailChanged),
										$author$project$View$Login$statusBlock(resetState.N),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tap gold-leaf shimmer-button juice-tap juice-magnet juice-halo mt-2 px-6 py-4 rounded-full font-semibold text-sm tracking-[0.22em] uppercase disabled:opacity-50'),
												$elm$html$Html$Attributes$type_('submit'),
												$elm$html$Html$Attributes$disabled(
												_Utils_eq(resetState.N, $author$project$Model$FormSubmitting))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												_Utils_eq(resetState.N, $author$project$Model$FormSubmitting) ? 'Sending the code…' : 'Email me a code')
											])),
										$author$project$View$Login$backToSignIn
									]))
							]))
					]))
			]),
		dE: 'Reset password'
	};
};
var $author$project$Model$LoginEmailChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$LoginPasswordChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$LoginSubmit = {$: 6};
var $author$project$Model$ResetOpened = {$: 13};
var $author$project$View$Login$signInView = function (formState) {
	return {
		cs: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('editorial-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('constellation-quiet')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('editorial-stage flex flex-col gap-6 sm:gap-7')
							]),
						_List_fromArray(
							[
								$author$project$View$Login$overline('Sign in'),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center px-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-display text-gold-soft leading-[1.05]'),
												A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(1.875rem, 6vw, 2.75rem)')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Welcome back,'),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												A2(
												$elm$html$Html$em,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('italic-display text-gold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Captain.')
													]))
											]))
									])),
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-3'),
										$elm$html$Html$Events$onSubmit($author$project$Model$LoginSubmit)
									]),
								_List_fromArray(
									[
										A6($author$project$View$Login$field, 'email', 'email', 'current email', 'Email', formState.aa, $author$project$Model$LoginEmailChanged),
										A6($author$project$View$Login$field, 'password', 'password', 'current-password', 'Password', formState.ay, $author$project$Model$LoginPasswordChanged),
										$author$project$View$Login$statusBlock(formState.N),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tap gold-leaf shimmer-button juice-tap juice-magnet juice-halo mt-2 px-6 py-4 rounded-full font-semibold text-sm tracking-[0.22em] uppercase disabled:opacity-50'),
												$elm$html$Html$Attributes$type_('submit'),
												$elm$html$Html$Attributes$disabled(
												_Utils_eq(formState.N, $author$project$Model$FormSubmitting))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												_Utils_eq(formState.N, $author$project$Model$FormSubmitting) ? 'Signing in…' : 'Resume the journey')
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tap self-center mt-1 px-3 py-2 text-xs text-cream/45 hover:text-gold-soft transition-colors tracking-[0.18em] uppercase'),
												$elm$html$Html$Attributes$type_('button'),
												$elm$html$Html$Events$onClick($author$project$Model$ResetOpened)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Forgot password?')
											]))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center text-xs text-cream/45 tracking-[0.25em] uppercase')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New here? '),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('/signup'),
												$elm$html$Html$Attributes$class('tap inline-flex px-2 text-gold-soft hover:text-gold transition-colors')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create an account')
											]))
									]))
							]))
					]))
			]),
		dE: 'Sign in'
	};
};
var $author$project$View$Login$view = F2(
	function (formState, resetState) {
		var _v0 = resetState.aC;
		switch (_v0) {
			case 0:
				return $author$project$View$Login$signInView(formState);
			case 1:
				return $author$project$View$Login$resetEmailView(resetState);
			default:
				return $author$project$View$Login$resetCodeView(resetState);
		}
	});
var $author$project$View$NotFound$brokenCompass = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('relative w-32 h-32 sm:w-40 sm:h-40')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 200 200'),
					$elm$svg$Svg$Attributes$class('w-full h-full'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'A spinning compass')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$defs,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$radialGradient,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('lostBloom')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$stop,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$offset('0%'),
											$elm$svg$Svg$Attributes$stopColor('#FFD700'),
											$elm$svg$Svg$Attributes$stopOpacity('0.35')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$stop,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$offset('100%'),
											$elm$svg$Svg$Attributes$stopColor('#FFD700'),
											$elm$svg$Svg$Attributes$stopOpacity('0')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('100'),
							$elm$svg$Svg$Attributes$cy('100'),
							$elm$svg$Svg$Attributes$r('95'),
							$elm$svg$Svg$Attributes$fill('url(#lostBloom)')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('100'),
							$elm$svg$Svg$Attributes$cy('100'),
							$elm$svg$Svg$Attributes$r('85'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$stroke('#D4AF37'),
							$elm$svg$Svg$Attributes$strokeWidth('1'),
							$elm$svg$Svg$Attributes$opacity('0.6')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('100'),
							$elm$svg$Svg$Attributes$cy('100'),
							$elm$svg$Svg$Attributes$r('70'),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$stroke('#D4AF37'),
							$elm$svg$Svg$Attributes$strokeWidth('0.5'),
							$elm$svg$Svg$Attributes$opacity('0.4')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$g,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (i) {
							var a = i * 45;
							return A2(
								$elm$svg$Svg$line,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x1('100'),
										$elm$svg$Svg$Attributes$y1('30'),
										$elm$svg$Svg$Attributes$x2('100'),
										$elm$svg$Svg$Attributes$y2('42'),
										$elm$svg$Svg$Attributes$stroke('#FFD700'),
										$elm$svg$Svg$Attributes$strokeWidth('1'),
										$elm$svg$Svg$Attributes$opacity('0.6'),
										$elm$svg$Svg$Attributes$transform(
										'rotate(' + ($elm$core$String$fromFloat(a) + ' 100 100)'))
									]),
								_List_Nil);
						},
						A2($elm$core$List$range, 0, 7))),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('compass-rose-spin')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$polygon,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$points('100,55 108,100 100,145 92,100'),
									$elm$svg$Svg$Attributes$fill('#FFD700'),
									$elm$svg$Svg$Attributes$opacity('0.85')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('100'),
									$elm$svg$Svg$Attributes$cy('100'),
									$elm$svg$Svg$Attributes$r('5'),
									$elm$svg$Svg$Attributes$fill('#02000a')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('100'),
									$elm$svg$Svg$Attributes$cy('100'),
									$elm$svg$Svg$Attributes$r('2'),
									$elm$svg$Svg$Attributes$fill('#FFD700')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$View$NotFound$overline = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex items-center justify-center gap-3 text-gold-brass/70 text-[10px] uppercase tracking-[0.4em] font-medium')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('404 · Lost at sea')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
				]),
			_List_Nil)
		]));
var $author$project$View$NotFound$view = {
	cs: _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('editorial-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('constellation-quiet')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('editorial-stage flex flex-col items-center text-center gap-7 sm:gap-8')
						]),
					_List_fromArray(
						[
							$author$project$View$NotFound$overline,
							$author$project$View$NotFound$brokenCompass,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col gap-3')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-display text-gold-soft leading-[0.95]'),
											A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(2.25rem, 7vw, 3.5rem)')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('You\'ve drifted '),
											A2(
											$elm$html$Html$em,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('italic-display text-gold')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('off course.')
												]))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-cream/70 text-base sm:text-lg italic font-display max-w-md mx-auto leading-relaxed')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('This star isn\'t on the chart. The compass can carry you back.')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col items-stretch sm:items-center gap-3 w-full max-w-xs')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/'),
											$elm$html$Html$Attributes$class('tap gold-leaf shimmer-button juice-tap juice-magnet juice-halo w-full px-10 py-4 rounded-full font-semibold text-sm tracking-[0.22em] uppercase text-center')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Return to the compass')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/about'),
											$elm$html$Html$Attributes$class('tap text-cream/55 text-xs tracking-[0.25em] uppercase hover:text-gold-soft transition-colors py-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('About this journey')
										]))
								]))
						]))
				]))
		]),
	dE: 'Off course'
};
var $author$project$Model$OnboardingFinish = {$: 22};
var $author$project$Model$OnboardingNextSlide = {$: 21};
var $author$project$View$Onboarding$ArtCompass = 0;
var $author$project$View$Onboarding$ArtFreeFive = 2;
var $author$project$View$Onboarding$ArtVoice = 1;
var $author$project$View$Onboarding$allSlides = _List_fromArray(
	[
		{Z: 0, cs: 'Each meditation is an intention — Love, Peace, Healing, Purpose. Choose by feeling, not by category.', ac: 'The Compass', ae: 'directions.', af: 'Twenty-four '},
		{Z: 1, cs: 'Twenty-four meditations, recorded by Lisa for one purpose: yours. Use her voice, your breath, and a quiet moment.', ac: 'Your guide', ae: 'Lisa Maree.', af: 'Voiced by '},
		{Z: 2, cs: 'Twenty-four meditations, voiced by Lisa. Sign in once and the compass remembers your streak, your favourites, your last meditation.', ac: 'Begin without friction', ae: 'No timer.', af: 'No card. '}
	]);
var $author$project$View$Onboarding$dots = F2(
	function (active, total) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex gap-2 mt-2')
				]),
			A2(
				$elm$core$List$map,
				function (i) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								_Utils_eq(i, active) ? 'w-8 h-1.5 rounded-full bg-gold transition-all' : 'w-1.5 h-1.5 rounded-full bg-cream/25 transition-all')
							]),
						_List_Nil);
				},
				A2($elm$core$List$range, 0, total - 1)));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$View$Onboarding$overline = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-center gap-3 text-gold-brass/70 text-[10px] uppercase tracking-[0.4em] font-medium')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Onboarding$placeholderSlide = {Z: 0, cs: '', ac: 'Welcome', ae: '', af: 'Welcome'};
var $author$project$View$Astrolabe$miniCardinal = F2(
	function (angle, label) {
		var rad = ((angle - 90) * $elm$core$Basics$pi) / 180;
		var x = 100 + (80 * $elm$core$Basics$cos(rad));
		var y = 100 + (80 * $elm$core$Basics$sin(rad));
		return A2(
			$elm$svg$Svg$text_,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x(
					$elm$core$String$fromFloat(x)),
					$elm$svg$Svg$Attributes$y(
					$elm$core$String$fromFloat(y)),
					$elm$svg$Svg$Attributes$fontSize('8.5'),
					$elm$svg$Svg$Attributes$fontWeight('500'),
					$elm$svg$Svg$Attributes$fill('#FFD700'),
					$elm$svg$Svg$Attributes$textAnchor('middle'),
					$elm$svg$Svg$Attributes$dominantBaseline('central'),
					$elm$svg$Svg$Attributes$opacity('0.85'),
					$elm$svg$Svg$Attributes$fontFamily('Cormorant Garamond, serif'),
					$elm$svg$Svg$Attributes$fontStyle('italic')
				]),
			_List_fromArray(
				[
					$elm$svg$Svg$text(label)
				]));
	});
var $author$project$View$Astrolabe$miniDot = F2(
	function (idx, m) {
		var rad = ((m.a3 - 90) * $elm$core$Basics$pi) / 180;
		var r = 66;
		var x = 100 + (r * $elm$core$Basics$cos(rad));
		var y = 100 + (r * $elm$core$Basics$sin(rad));
		var outerHalo = m.bz ? '0.12' : '0.06';
		var dotStyle = 'color: ' + (m.be + ('; --pulse-delay: ' + ($elm$core$String$fromFloat(idx * 0.29) + 's')));
		var _v0 = m.bz ? _Utils_Tuple3('3.6', '1', '0.4') : _Utils_Tuple3('2.3', '0.45', '0.16');
		var dotR = _v0.a;
		var dotOpacity = _v0.b;
		var midHalo = _v0.c;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('astrolabe-mini-dot'),
					$elm$svg$Svg$Attributes$style(dotStyle)
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y)),
							$elm$svg$Svg$Attributes$r('12'),
							$elm$svg$Svg$Attributes$fill(m.be),
							$elm$svg$Svg$Attributes$opacity(outerHalo)
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y)),
							$elm$svg$Svg$Attributes$r('6.5'),
							$elm$svg$Svg$Attributes$fill(m.be),
							$elm$svg$Svg$Attributes$opacity(midHalo)
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y)),
							$elm$svg$Svg$Attributes$r(dotR),
							$elm$svg$Svg$Attributes$fill(m.be),
							$elm$svg$Svg$Attributes$opacity(dotOpacity)
						]),
					_List_Nil),
					m.bz ? A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x - 0.8)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y - 0.8)),
							$elm$svg$Svg$Attributes$r('1.2'),
							$elm$svg$Svg$Attributes$fill('#fff'),
							$elm$svg$Svg$Attributes$opacity('0.75')
						]),
					_List_Nil) : $elm$svg$Svg$text('')
				]));
	});
var $author$project$View$Astrolabe$miniRose = A2(
	$elm$svg$Svg$g,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('16'),
					$elm$svg$Svg$Attributes$fill('#02000a')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('16'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('url(#miniRim)'),
					$elm$svg$Svg$Attributes$strokeWidth('1.4')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('12.5'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('#D4AF37'),
					$elm$svg$Svg$Attributes$strokeWidth('0.5'),
					$elm$svg$Svg$Attributes$opacity('0.6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('100,85 102.4,100 100,115 97.6,100'),
					$elm$svg$Svg$Attributes$fill('url(#miniRim)')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('85,100 100,97.6 115,100 100,102.4'),
					$elm$svg$Svg$Attributes$fill('#D4AF37'),
					$elm$svg$Svg$Attributes$opacity('0.85')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('90.5,90.5 100,99 109.5,109.5 101,100'),
					$elm$svg$Svg$Attributes$fill('#fff8c8'),
					$elm$svg$Svg$Attributes$opacity('0.5')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('109.5,90.5 101,100 90.5,109.5 100,99'),
					$elm$svg$Svg$Attributes$fill('#fff8c8'),
					$elm$svg$Svg$Attributes$opacity('0.5')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('2.8'),
					$elm$svg$Svg$Attributes$fill('#FFD700'),
					$elm$svg$Svg$Attributes$opacity('0.15')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('1.6'),
					$elm$svg$Svg$Attributes$fill('#02000a')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('1'),
					$elm$svg$Svg$Attributes$fill('#FFD700'),
					$elm$svg$Svg$Attributes$opacity('0.95')
				]),
			_List_Nil)
		]));
var $author$project$View$Astrolabe$miniTick = function (i) {
	var isMajor = !A2($elm$core$Basics$modBy, 6, i);
	var angle = i * 15;
	var _v0 = isMajor ? _Utils_Tuple3('19', '1', '0.8') : _Utils_Tuple3('16', '0.7', '0.35');
	var y2 = _v0.a;
	var width = _v0.b;
	var opacity = _v0.c;
	return A2(
		$elm$svg$Svg$line,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x1('100'),
				$elm$svg$Svg$Attributes$y1('10'),
				$elm$svg$Svg$Attributes$x2('100'),
				$elm$svg$Svg$Attributes$y2(y2),
				$elm$svg$Svg$Attributes$stroke('#D4AF37'),
				$elm$svg$Svg$Attributes$strokeWidth(width),
				$elm$svg$Svg$Attributes$opacity(opacity),
				$elm$svg$Svg$Attributes$transform(
				'rotate(' + ($elm$core$String$fromFloat(angle) + ' 100 100)'))
			]),
		_List_Nil);
};
var $author$project$View$Astrolabe$mini = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 200 200'),
			$elm$svg$Svg$Attributes$class('w-full h-full'),
			A2($elm$html$Html$Attributes$attribute, 'role', 'img'),
			A2($elm$html$Html$Attributes$attribute, 'aria-label', 'A miniature astrolabe showing 24 meditations as compass bearings')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$radialGradient,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('miniBloom')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$offset('0%'),
									$elm$svg$Svg$Attributes$stopColor('#FFD700'),
									$elm$svg$Svg$Attributes$stopOpacity('0.28')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$offset('60%'),
									$elm$svg$Svg$Attributes$stopColor('#FFD700'),
									$elm$svg$Svg$Attributes$stopOpacity('0.06')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$offset('100%'),
									$elm$svg$Svg$Attributes$stopColor('#FFD700'),
									$elm$svg$Svg$Attributes$stopOpacity('0')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$linearGradient,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id('miniRim'),
							$elm$svg$Svg$Attributes$x1('0%'),
							$elm$svg$Svg$Attributes$y1('0%'),
							$elm$svg$Svg$Attributes$x2('100%'),
							$elm$svg$Svg$Attributes$y2('100%')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$offset('0%'),
									$elm$svg$Svg$Attributes$stopColor('#FFD700')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$offset('30%'),
									$elm$svg$Svg$Attributes$stopColor('#fff8c8')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$offset('70%'),
									$elm$svg$Svg$Attributes$stopColor('#D4AF37')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$stop,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$offset('100%'),
									$elm$svg$Svg$Attributes$stopColor('#FFD700')
								]),
							_List_Nil)
						]))
				])),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('96'),
					$elm$svg$Svg$Attributes$fill('url(#miniBloom)')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('90'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('url(#miniRim)'),
					$elm$svg$Svg$Attributes$strokeWidth('1.4'),
					$elm$svg$Svg$Attributes$class('compass-pulse compass-glow')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('84'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('#D4AF37'),
					$elm$svg$Svg$Attributes$strokeWidth('1.6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('100'),
					$elm$svg$Svg$Attributes$cy('100'),
					$elm$svg$Svg$Attributes$r('80'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$stroke('#D4AF37'),
					$elm$svg$Svg$Attributes$strokeWidth('0.4'),
					$elm$svg$Svg$Attributes$opacity('0.4')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$View$Astrolabe$miniTick,
				A2($elm$core$List$range, 0, 23))),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$View$Astrolabe$miniCardinal, 0, 'N'),
					A2($author$project$View$Astrolabe$miniCardinal, 90, 'E'),
					A2($author$project$View$Astrolabe$miniCardinal, 180, 'S'),
					A2($author$project$View$Astrolabe$miniCardinal, 270, 'W')
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('compass-ring')
				]),
			A2($elm$core$List$indexedMap, $author$project$View$Astrolabe$miniDot, $author$project$Service$MeditationData$all)),
			$author$project$View$Astrolabe$miniRose
		]));
var $author$project$View$Onboarding$artSvg = function (art) {
	switch (art) {
		case 0:
			return $author$project$View$Astrolabe$mini;
		case 1:
			return A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 200 200'),
						$elm$svg$Svg$Attributes$class('w-full h-full')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$radialGradient,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$id('vbloom')
									]),
								_List_fromArray(
									[
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('0%'),
												$elm$svg$Svg$Attributes$stopColor('#fda4af'),
												$elm$svg$Svg$Attributes$stopOpacity('0.35')
											]),
										_List_Nil),
										A2(
										$elm$svg$Svg$stop,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$offset('100%'),
												$elm$svg$Svg$Attributes$stopColor('#fda4af'),
												$elm$svg$Svg$Attributes$stopOpacity('0')
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('100'),
								$elm$svg$Svg$Attributes$cy('100'),
								$elm$svg$Svg$Attributes$r('95'),
								$elm$svg$Svg$Attributes$fill('url(#vbloom)')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('compass-pulse')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M 30 100 Q 40 70 60 100 T 100 100 T 140 100 T 170 100'),
										$elm$svg$Svg$Attributes$fill('none'),
										$elm$svg$Svg$Attributes$stroke('#FFD700'),
										$elm$svg$Svg$Attributes$strokeWidth('1.5'),
										$elm$svg$Svg$Attributes$opacity('0.65')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M 30 110 Q 40 90 60 110 T 100 110 T 140 110 T 170 110'),
										$elm$svg$Svg$Attributes$fill('none'),
										$elm$svg$Svg$Attributes$stroke('#D4AF37'),
										$elm$svg$Svg$Attributes$strokeWidth('1'),
										$elm$svg$Svg$Attributes$opacity('0.5')
									]),
								_List_Nil),
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M 30 90 Q 40 110 60 90 T 100 90 T 140 90 T 170 90'),
										$elm$svg$Svg$Attributes$fill('none'),
										$elm$svg$Svg$Attributes$stroke('#D4AF37'),
										$elm$svg$Svg$Attributes$strokeWidth('1'),
										$elm$svg$Svg$Attributes$opacity('0.5')
									]),
								_List_Nil)
							]))
					]));
		default:
			return A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 200 200'),
						$elm$svg$Svg$Attributes$class('w-full h-full')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$g,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, color) {
									var angle = (i * 72) - 90;
									var rad = (angle * $elm$core$Basics$pi) / 180;
									var x = 100 + (60 * $elm$core$Basics$cos(rad));
									var y = 100 + (60 * $elm$core$Basics$sin(rad));
									return A2(
										$elm$svg$Svg$g,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$circle,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$cx(
														$elm$core$String$fromFloat(x)),
														$elm$svg$Svg$Attributes$cy(
														$elm$core$String$fromFloat(y)),
														$elm$svg$Svg$Attributes$r('18'),
														$elm$svg$Svg$Attributes$fill(color),
														$elm$svg$Svg$Attributes$opacity('0.18')
													]),
												_List_Nil),
												A2(
												$elm$svg$Svg$circle,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$cx(
														$elm$core$String$fromFloat(x)),
														$elm$svg$Svg$Attributes$cy(
														$elm$core$String$fromFloat(y)),
														$elm$svg$Svg$Attributes$r('10'),
														$elm$svg$Svg$Attributes$fill(color)
													]),
												_List_Nil)
											]));
								}),
							_List_fromArray(
								['#FB7185', '#60A5FA', '#4ADE80', '#86EFAC', '#FCD34D']))),
						A2(
						$elm$svg$Svg$text_,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x('100'),
								$elm$svg$Svg$Attributes$y('108'),
								$elm$svg$Svg$Attributes$fontSize('44'),
								$elm$svg$Svg$Attributes$fontStyle('italic'),
								$elm$svg$Svg$Attributes$fontFamily('Cormorant Garamond, serif'),
								$elm$svg$Svg$Attributes$fill('#FFD700'),
								$elm$svg$Svg$Attributes$textAnchor('middle')
							]),
						_List_fromArray(
							[
								$elm$svg$Svg$text('5')
							]))
					]));
	}
};
var $author$project$View$Onboarding$slideArtwork = function (s) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-40 h-40 sm:w-48 sm:h-48')
			]),
		_List_fromArray(
			[
				$author$project$View$Onboarding$artSvg(s.Z)
			]));
};
var $author$project$View$Onboarding$view = function (state) {
	var slides = $author$project$View$Onboarding$allSlides;
	var isLast = _Utils_cmp(
		state.b3,
		$elm$core$List$length(slides) - 1) > -1;
	var current = A2(
		$elm$core$Maybe$withDefault,
		$author$project$View$Onboarding$placeholderSlide,
		$elm$core$List$head(
			A2($elm$core$List$drop, state.b3, slides)));
	return {
		cs: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('editorial-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('constellation-quiet')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('editorial-stage juice-spring-in flex flex-col items-center text-center gap-7 sm:gap-8')
							]),
						_List_fromArray(
							[
								$author$project$View$Onboarding$overline(
								current.ac + (' · Step ' + ($elm$core$String$fromInt(state.b3 + 1) + (' of ' + $elm$core$String$fromInt(
									$elm$core$List$length(slides)))))),
								$author$project$View$Onboarding$slideArtwork(current),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-3')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-display text-gold-soft leading-tight'),
												A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(1.875rem, 6vw, 2.5rem)')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(current.af),
												A2(
												$elm$html$Html$em,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('italic-display text-gold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(current.ae)
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-cream/75 leading-relaxed text-base font-light')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(current.cs)
											]))
									])),
								A2(
								$author$project$View$Onboarding$dots,
								state.b3,
								$elm$core$List$length(slides)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col items-stretch sm:items-center gap-3 w-full max-w-xs')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tap gold-leaf shimmer-button juice-tap juice-magnet juice-halo w-full px-10 py-4 rounded-full font-semibold text-sm tracking-[0.22em] uppercase'),
												$elm$html$Html$Events$onClick(
												isLast ? $author$project$Model$OnboardingFinish : $author$project$Model$OnboardingNextSlide)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												isLast ? 'Take the helm' : 'Next')
											])),
										isLast ? $elm$html$Html$text('') : A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('tap text-cream/40 text-xs tracking-[0.25em] uppercase hover:text-gold-soft transition-colors py-2'),
												$elm$html$Html$Events$onClick($author$project$Model$OnboardingFinish)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Skip introduction')
											]))
									]))
							]))
					]))
			]),
		dE: 'Welcome'
	};
};
var $author$project$View$PaywallLab$footer = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col items-center gap-2 pt-6 pb-4 border-t border-gold-brass/15')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-cream/35 text-[10px] tracking-[0.3em] uppercase text-center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Mock checkout · no real charges')
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('/app/settings'),
					$elm$html$Html$Attributes$class('tap text-cream/55 text-xs tracking-[0.25em] uppercase hover:text-gold-soft transition-colors mt-1 px-3 py-2 rounded-full')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('← Back to settings')
				]))
		]));
var $author$project$View$PaywallLab$header = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col items-center text-center gap-3')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-gold-brass/70 text-[10px] tracking-[0.5em] uppercase font-semibold')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Strategy lab · all variants')
				])),
			A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-display text-gold-soft'),
					A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(2.25rem, 9vw, 3rem)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$em,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('italic-display text-gold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Paywall surfaces')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-cream/55 text-sm max-w-md italic font-display')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Four monetization paths, all stubbed against the same checkout port. Pick one — flipping is a view-only change.')
				]))
		]));
var $author$project$View$PaywallLab$section = F3(
	function (title, sub, variant) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-4')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-1')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-display text-2xl text-gold-soft')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/55 text-sm leading-relaxed max-w-2xl')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sub)
								]))
						])),
					variant
				]));
	});
var $author$project$Model$CheckoutRequested = function (a) {
	return {$: 54, a: a};
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$View$Paywall$ctaPill = F4(
	function (label, classes, isProcessing, processingLabel) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('mt-2 px-4 py-2.5 rounded-full text-center text-xs tracking-[0.2em] uppercase font-semibold transition-all', true),
							_Utils_Tuple2(classes, !isProcessing),
							_Utils_Tuple2('bg-gold-soft/30 text-gold animate-pulse', isProcessing)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					isProcessing ? processingLabel : label)
				]));
	});
var $author$project$View$Paywall$isOtherProcessing = F2(
	function (phase, tier) {
		if (phase.$ === 1) {
			var t = phase.a;
			return !_Utils_eq(t, tier);
		} else {
			return false;
		}
	});
var $author$project$View$Paywall$annualCard = function (phase) {
	var isProcessing = function () {
		if ((phase.$ === 1) && (phase.a === 1)) {
			var _v1 = phase.a;
			return true;
		} else {
			return false;
		}
	}();
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('tap juice-tap juice-magnet relative flex flex-col gap-3 px-6 py-7 rounded-2xl border border-gold-brass/30 text-left transition-all', true),
						_Utils_Tuple2(
						'opacity-50 pointer-events-none',
						A2($author$project$View$Paywall$isOtherProcessing, phase, 1))
					])),
				A2($elm$html$Html$Attributes$style, 'background', 'linear-gradient(180deg, rgba(26,15,48,0.4) 0%, rgba(5,2,17,0.5) 100%)'),
				$elm$html$Html$Events$onClick(
				$author$project$Model$CheckoutRequested(1))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-display text-xl text-gold-soft tracking-wide')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Annual')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-baseline gap-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-display text-5xl text-gold-soft')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('$79')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/45 text-xs tracking-wide')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('/yr · ~$6.58/mo')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/65 text-sm leading-relaxed')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('All 24 meditations · cancel anytime · soft on the wallet.')
					])),
				A4($author$project$View$Paywall$ctaPill, 'Subscribe yearly', 'border border-gold-brass/40 text-gold-soft', isProcessing, 'Redirecting…')
			]));
};
var $author$project$View$Paywall$cohortCard = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('relative flex flex-col gap-3 px-6 py-7 rounded-2xl border border-purple-300/40 text-left'),
			A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 70% 0%, rgba(167,139,250,0.18) 0%, transparent 60%), linear-gradient(180deg, rgba(26,15,48,0.5) 0%, rgba(5,2,17,0.6) 100%)')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute -top-2.5 left-5 px-2.5 py-0.5 rounded-full bg-purple-300/30 text-purple-100 text-[9px] font-bold tracking-[0.2em] uppercase border border-purple-300/40')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('8 weeks · live · twice a year')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-display text-xl text-gold-soft tracking-wide')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Compass Course')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-baseline gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-display text-5xl text-gold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('$497')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/45 text-xs tracking-wide')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('per cohort · 100 seats')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-cream/65 text-sm leading-relaxed')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Eight weeks of live teaching with Lisa · a navigator\'s manual · a small private circle of practitioners. The deepest tier.')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tap juice-tap mt-3 px-4 py-2.5 rounded-full text-center text-xs tracking-[0.2em] uppercase font-semibold border border-purple-300/40 text-purple-100')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Join the next cohort')
				]))
		]));
var $author$project$View$Paywall$inlineHeader = F2(
	function (title, sub) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-display text-2xl sm:text-3xl text-gold-soft')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$em,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('italic-display')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/65 text-sm leading-relaxed max-w-md')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(sub)
						]))
				]));
	});
var $author$project$View$Paywall$panelShell = F2(
	function (accent, children) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative w-full rounded-3xl border border-gold-brass/30 p-6 sm:p-8 flex flex-col gap-6'),
					A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 30% 0%, ' + (accent + '1a 0%, transparent 60%), linear-gradient(180deg, #1a0f30 0%, #02000a 100%)')),
					A2($elm$html$Html$Attributes$style, 'box-shadow', '0 0 60px ' + (accent + '22, inset 0 1px 0 rgba(255,255,255,0.06)'))
				]),
			children);
	});
var $author$project$View$Paywall$variantOverline = function (label) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-gold-brass/70 text-[10px] tracking-[0.45em] uppercase font-semibold')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$View$Paywall$viewCohortLadder = function (phase) {
	return A2(
		$author$project$View$Paywall$panelShell,
		'#A78BFA',
		_List_fromArray(
			[
				$author$project$View$Paywall$variantOverline('Cohort Ladder · subscription + live course'),
				A2($author$project$View$Paywall$inlineHeader, 'Practice. Then deepen.', 'Daily practice in the app. Twice a year, sail with Lisa for an 8-week live cohort — limited seats.'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-2 gap-3')
					]),
				_List_fromArray(
					[
						$author$project$View$Paywall$annualCard(phase),
						$author$project$View$Paywall$cohortCard
					]))
			]));
};
var $author$project$View$Paywall$founderCard = function (phase) {
	var isProcessing = function () {
		if ((phase.$ === 1) && (phase.a === 2)) {
			var _v1 = phase.a;
			return true;
		} else {
			return false;
		}
	}();
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('tap juice-tap juice-magnet juice-halo relative flex flex-col gap-3 px-6 py-7 rounded-2xl border-2 border-gold/80 text-left transition-all', true),
						_Utils_Tuple2(
						'opacity-50 pointer-events-none',
						A2($author$project$View$Paywall$isOtherProcessing, phase, 2))
					])),
				A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 30% 0%, rgba(255,215,0,0.16) 0%, transparent 60%), linear-gradient(180deg, rgba(26,15,48,0.6) 0%, rgba(5,2,17,0.7) 100%)'),
				$elm$html$Html$Events$onClick(
				$author$project$Model$CheckoutRequested(2))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute -top-2.5 left-5 px-2.5 py-0.5 rounded-full bg-gold text-ink text-[9px] font-bold tracking-[0.2em] uppercase')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Founder · forever')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-display text-xl text-gold-soft tracking-wide')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Founder Lifetime')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-baseline gap-2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-display text-5xl text-gold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('$299')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/45 text-xs tracking-wide')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('one time')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/65 text-sm leading-relaxed')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('All 24 meditations forever · early access to new releases · invitation to a private founder cohort with Lisa.')
					])),
				A4($author$project$View$Paywall$ctaPill, 'Become a founder', 'bg-gold text-ink', isProcessing, 'Redirecting…')
			]));
};
var $author$project$View$Paywall$scarcityBar = F2(
	function (taken, cap) {
		var pct = A2($elm$core$Basics$min, 100, ((taken * 100) / cap) | 0);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-1.5 mt-1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('h-1.5 rounded-full bg-ink-soft/60 overflow-hidden')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-full bg-gold'),
									A2(
									$elm$html$Html$Attributes$style,
									'width',
									$elm$core$String$fromInt(pct) + '%')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/45 text-[10px] tracking-[0.3em] uppercase text-center')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(taken) + (' of ' + ($elm$core$String$fromInt(cap) + ' founder seats taken')))
						]))
				]));
	});
var $author$project$View$Paywall$viewFounder = function (phase) {
	return A2(
		$author$project$View$Paywall$panelShell,
		'#86EFAC',
		_List_fromArray(
			[
				$author$project$View$Paywall$variantOverline('Founder · capped at 1,000 seats'),
				A2($author$project$View$Paywall$inlineHeader, 'Sail with the founders', 'A one-time gift to the work — locked in forever, capped at 1,000 lifetime seats. After the cap, this offer closes.'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-2 gap-3')
					]),
				_List_fromArray(
					[
						$author$project$View$Paywall$founderCard(phase),
						$author$project$View$Paywall$annualCard(phase)
					])),
				A2($author$project$View$Paywall$scarcityBar, 312, 1000)
			]));
};
var $author$project$View$Paywall$benefit = F2(
	function (emoji, label) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center gap-1 sm:gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xl sm:text-2xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(emoji)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/65 italic font-display text-[11px] sm:text-sm leading-tight')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$View$Paywall$benefits = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('grid grid-cols-3 gap-2 sm:gap-4 text-center text-cream/70 text-sm')
		]),
	_List_fromArray(
		[
			A2($author$project$View$Paywall$benefit, '🧭', 'All 24 meditations'),
			A2($author$project$View$Paywall$benefit, '🎙️', 'Lisa Maree\'s voice'),
			A2($author$project$View$Paywall$benefit, '⏳', 'Cancel any time')
		]));
var $author$project$Service$Entitlement$tierLabel = function (t) {
	switch (t) {
		case 0:
			return 'Monthly';
		case 1:
			return 'Annual';
		default:
			return 'Lifetime';
	}
};
var $author$project$Service$Entitlement$tierPrice = function (t) {
	switch (t) {
		case 0:
			return {aK: '$9.99', a_: 'per month'};
		case 1:
			return {aK: '$69', a_: 'per year · $5.75/mo'};
		default:
			return {aK: '$249', a_: 'one time, forever'};
	}
};
var $author$project$View$Paywall$tierCard = F3(
	function (phase, tier, featured) {
		var price = $author$project$Service$Entitlement$tierPrice(tier);
		var otherProcessing = A2($author$project$View$Paywall$isOtherProcessing, phase, tier);
		var label = $author$project$Service$Entitlement$tierLabel(tier);
		var isProcessingThis = function () {
			if (phase.$ === 1) {
				var t = phase.a;
				return _Utils_eq(t, tier);
			} else {
				return false;
			}
		}();
		var ctaLabel = function () {
			switch (phase.$) {
				case 1:
					var t = phase.a;
					return _Utils_eq(t, tier) ? 'Redirecting…' : '—';
				case 2:
					return 'Unlocked';
				default:
					if (tier === 2) {
						return 'Buy lifetime';
					} else {
						return 'Subscribe';
					}
			}
		}();
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('tap juice-tap juice-magnet juice-halo group relative flex flex-col gap-3 px-5 py-6 rounded-2xl border text-left transition-all', true),
							_Utils_Tuple2('border-gold/70 bg-gradient-to-b from-gold/10 to-transparent', featured),
							_Utils_Tuple2('border-gold-brass/25 hover:border-gold-brass/50 bg-ink-soft/40', !featured),
							_Utils_Tuple2('opacity-40 pointer-events-none', otherProcessing)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Model$CheckoutRequested(tier)),
					A2($elm$html$Html$Attributes$style, 'transform-origin', 'center')
				]),
			_List_fromArray(
				[
					featured ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute -top-2.5 left-1/2 -translate-x-1/2 px-2.5 py-0.5 rounded-full bg-gold text-ink text-[9px] font-bold tracking-[0.2em] uppercase')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Best Value')
						])) : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-baseline justify-between')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-display text-xl text-gold-soft tracking-wide')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-baseline gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-display text-4xl text-gold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(price.aK)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/55 text-xs tracking-wide')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(price.a_)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('mt-3 px-4 py-2.5 rounded-full text-center text-xs tracking-[0.2em] uppercase font-semibold transition-all', true),
									_Utils_Tuple2('bg-gold text-ink', featured && (!isProcessingThis)),
									_Utils_Tuple2('border border-gold-brass/40 text-gold-soft', (!featured) && (!isProcessingThis)),
									_Utils_Tuple2('bg-gold-soft/30 text-gold animate-pulse', isProcessingThis)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(ctaLabel)
						]))
				]));
	});
var $author$project$View$Paywall$tiers = function (phase) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('grid grid-cols-1 sm:grid-cols-3 gap-3')
			]),
		_List_fromArray(
			[
				A3($author$project$View$Paywall$tierCard, phase, 0, false),
				A3($author$project$View$Paywall$tierCard, phase, 1, true),
				A3($author$project$View$Paywall$tierCard, phase, 2, false)
			]));
};
var $author$project$View$Paywall$viewInline = function (phase) {
	return A2(
		$author$project$View$Paywall$panelShell,
		'#FFD700',
		_List_fromArray(
			[
				$author$project$View$Paywall$variantOverline('Three-Tier Ladder · industry default'),
				A2($author$project$View$Paywall$inlineHeader, 'Choose your path', 'Three meditations free, always. Unlock all 24 — voiced by Lisa.'),
				$author$project$View$Paywall$benefits,
				$author$project$View$Paywall$tiers(phase)
			]));
};
var $author$project$View$Paywall$pwywRow = F5(
	function (phase, tier, label, sub, featured) {
		var isProcessing = function () {
			if (phase.$ === 1) {
				var t = phase.a;
				return _Utils_eq(t, tier);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('tap juice-tap juice-magnet flex items-center justify-between gap-3 px-5 py-4 rounded-2xl border text-left transition-all', true),
							_Utils_Tuple2('border-gold/60 bg-gold/5', featured),
							_Utils_Tuple2('border-gold-brass/25 hover:border-gold-brass/50', !featured),
							_Utils_Tuple2(
							'opacity-50 pointer-events-none',
							A2($author$project$View$Paywall$isOtherProcessing, phase, tier))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Model$CheckoutRequested(tier))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col gap-0.5')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-display text-lg text-gold-soft tracking-wide')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/55 text-xs')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sub)
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('px-3 py-1.5 rounded-full text-[10px] tracking-[0.25em] uppercase font-semibold', true),
									_Utils_Tuple2('bg-gold text-ink', featured && (!isProcessing)),
									_Utils_Tuple2('border border-gold-brass/40 text-gold-soft', (!featured) && (!isProcessing)),
									_Utils_Tuple2('bg-gold-soft/30 text-gold animate-pulse', isProcessing)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							isProcessing ? '…' : 'Choose')
						]))
				]));
	});
var $author$project$View$Paywall$viewPayWhatYouWant = function (phase) {
	return A2(
		$author$project$View$Paywall$panelShell,
		'#FB7185',
		_List_fromArray(
			[
				$author$project$View$Paywall$variantOverline('Pay-what-you-want · floor + uplift'),
				A2($author$project$View$Paywall$inlineHeader, 'Pay what feels right', 'A floor of $5 a month opens the full library. If the practice is changing your life, give more — Bandcamp data says half of you will.'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-3')
					]),
				_List_fromArray(
					[
						A5($author$project$View$Paywall$pwywRow, phase, 0, 'Floor', '$5/mo · everything unlocked', false),
						A5($author$project$View$Paywall$pwywRow, phase, 1, 'Generous', '$10/mo equivalent · supports new releases', true),
						A5($author$project$View$Paywall$pwywRow, phase, 2, 'Patron', '$20/mo equivalent · cohort priority + private notes', false)
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/45 text-[10px] tracking-[0.3em] uppercase text-center pt-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Same access at every level · choose by what feels honest')
					]))
			]));
};
var $author$project$View$PaywallLab$view = function (phase) {
	return {
		cs: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-10 sm:gap-14 pt-2 max-w-3xl mx-auto')
					]),
				_List_fromArray(
					[
						$author$project$View$PaywallLab$header,
						A3(
						$author$project$View$PaywallLab$section,
						'1 · Three-Tier Ladder',
						'Industry default. Optimised for capture rate. The current production paywall.',
						$author$project$View$Paywall$viewInline(phase)),
						A3(
						$author$project$View$PaywallLab$section,
						'2 · Founder · capped',
						'Substack/Roam style scarcity — front-loads cash and locks in evangelists. Cap closes the offer forever.',
						$author$project$View$Paywall$viewFounder(phase)),
						A3(
						$author$project$View$PaywallLab$section,
						'3 · Cohort Ladder',
						'Subscription as funnel; the real margin lives in the live cohort. Highest LTV per single-teacher hour.',
						$author$project$View$Paywall$viewCohortLadder(phase)),
						A3(
						$author$project$View$PaywallLab$section,
						'4 · Pay-What-You-Want',
						'Bandcamp model. Floor + uplift. Brand-aligned with meditation values; lifts ARPU 18-50% above floor.',
						$author$project$View$Paywall$viewPayWhatYouWant(phase)),
						$author$project$View$PaywallLab$footer
					]))
			]),
		dE: 'Paywall Lab'
	};
};
var $author$project$Model$PlayerDurationLoaded = function (a) {
	return {$: 39, a: a};
};
var $author$project$Model$PlayerEnded = {$: 40};
var $author$project$Model$PlayerErrored = function (a) {
	return {$: 41, a: a};
};
var $author$project$Model$PlayerNativePaused = {$: 43};
var $author$project$Model$PlayerNativeStarted = {$: 42};
var $author$project$Service$MeditationData$audioUrl = F2(
	function (baseUrl, m) {
		return $author$project$Service$MeditationData$trimBase(baseUrl) + ('/' + m.aG);
	});
var $author$project$View$Player$breathPanel = function (m) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('relative w-32 h-32 rounded-full juice-breath audio-react-scale-strong audio-react-glow'),
				A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 30% 25%, ' + (m.be + ('cc 0%, ' + (m.be + '55 50%, transparent 75%), radial-gradient(circle at 50% 50%, oklch(86% 0.18 92 / 0.25) 0%, transparent 70%)')))),
				A2($elm$html$Html$Attributes$style, 'box-shadow', '0 0 60px ' + (m.be + '55, inset 0 1px 0 rgba(255,255,255,0.25)')),
				A2($elm$html$Html$Attributes$style, 'color', m.be)
			]),
		_List_Nil);
};
var $author$project$View$Player$lisaNote = function (_v0) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-2 max-w-[14rem]')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-display italic-display text-gold-soft text-lg leading-[1.35] text-right')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('“Welcome aboard, Captain.”')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/55 text-[10px] tracking-[0.3em] uppercase text-right')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('— Lisa Maree')
					]))
			]));
};
var $author$project$Service$AudioService$decodeDurationLoaded = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail', 'duration']),
	$elm$json$Json$Decode$float);
var $author$project$Service$AudioService$decodeError = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail', 'code']),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
				$elm$json$Json$Decode$null('unknown')
			])));
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Service$AudioService$player = function (cfg) {
	return A3(
		$elm$html$Html$node,
		'meditation-audio',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('primary-player'),
				A2(
				$elm$html$Html$Attributes$property,
				'src',
				$elm$json$Json$Encode$string(cfg.dy)),
				A2(
				$elm$html$Html$Attributes$property,
				'mcTitle',
				$elm$json$Json$Encode$string(cfg.dE)),
				A2(
				$elm$html$Html$Attributes$property,
				'playing',
				$elm$json$Json$Encode$bool(cfg.dl)),
				A2(
				$elm$html$Html$Attributes$property,
				'position',
				$elm$json$Json$Encode$float(cfg.dm)),
				A2(
				$elm$html$Html$Attributes$property,
				'volume',
				$elm$json$Json$Encode$float(cfg.cj)),
				A2(
				$elm$html$Html$Events$on,
				'durationloaded',
				A2($elm$json$Json$Decode$map, cfg.da, $author$project$Service$AudioService$decodeDurationLoaded)),
				A2(
				$elm$html$Html$Events$on,
				'ended',
				$elm$json$Json$Decode$succeed(cfg.db)),
				A2(
				$elm$html$Html$Events$on,
				'error',
				A2($elm$json$Json$Decode$map, cfg.dc, $author$project$Service$AudioService$decodeError)),
				A2(
				$elm$html$Html$Events$on,
				'started',
				$elm$json$Json$Decode$succeed(cfg.de)),
				A2(
				$elm$html$Html$Events$on,
				'paused',
				$elm$json$Json$Decode$succeed(cfg.dd))
			]),
		_List_Nil);
};
var $author$project$Model$PlayerSeekRequested = function (a) {
	return {$: 38, a: a};
};
var $author$project$Model$PlayerPlayPause = {$: 37};
var $author$project$View$Player$isAudioBlocked = function (status) {
	if (status.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$Player$nonPlayingGlyph = function (status) {
	switch (status.$) {
		case 1:
			return '…';
		case 4:
			return '↻';
		case 3:
			return '▶';
		case 2:
			return '▶';
		default:
			return '▶';
	}
};
var $author$project$View$Player$bigPlayButton = F2(
	function (m, player) {
		var isPlaying = _Utils_eq(player.a5, $author$project$Model$AudioPlaying);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'relative w-24 h-24 rounded-full flex items-center justify-center text-3xl hover:scale-105 active:scale-95 ' + (isPlaying ? 'audio-react-scale audio-react-glow' : '')),
					A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 30% 30%, ' + (m.be + (' 0%, ' + (m.be + ('cc 60%, ' + (m.be + '88 100%)')))))),
					A2($elm$html$Html$Attributes$style, 'color', 'rgba(2, 0, 10, 0.9)'),
					A2($elm$html$Html$Attributes$style, 'box-shadow', 'inset 0 2px 0 rgba(255,255,255,0.45), inset 0 -2px 4px rgba(0,0,0,0.3), 0 0 40px ' + (m.be + '66, 0 8px 30px rgba(0,0,0,0.4)')),
					A2($elm$html$Html$Attributes$style, 'transition', 'transform 200ms cubic-bezier(.34,1.56,.64,1), box-shadow 400ms ease'),
					$elm$html$Html$Events$onClick($author$project$Model$PlayerPlayPause),
					$elm$html$Html$Attributes$disabled(
					$author$project$View$Player$isAudioBlocked(player.a5)),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-label',
					function () {
						var _v0 = player.a5;
						if (_v0.$ === 2) {
							return 'Pause';
						} else {
							return 'Play';
						}
					}())
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute inset-0 flex items-center justify-center transition-opacity duration-200'),
							A2(
							$elm$html$Html$Attributes$style,
							'opacity',
							_Utils_eq(player.a5, $author$project$Model$AudioPlaying) ? '1' : '0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('translate-y-px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('❚❚')
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute inset-0 flex items-center justify-center transition-opacity duration-200'),
							A2(
							$elm$html$Html$Attributes$style,
							'opacity',
							_Utils_eq(player.a5, $author$project$Model$AudioPlaying) ? '0' : '1')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('translate-y-px translate-x-0.5')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$View$Player$nonPlayingGlyph(player.a5))
								]))
						]))
				]));
	});
var $author$project$View$Player$skipButton = F3(
	function (m, seconds, msg) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('juice-tap juice-ripple w-14 h-14 rounded-full text-[13px] tracking-wider font-mono flex items-center justify-center transition-all'),
					A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 30% 30%, ' + (m.be + ('33 0%, ' + (m.be + '11 100%)')))),
					A2($elm$html$Html$Attributes$style, 'color', 'rgba(245, 236, 214, 0.9)'),
					A2($elm$html$Html$Attributes$style, 'box-shadow', 'inset 0 1px 0 rgba(255,255,255,0.18), inset 0 -1px 0 rgba(0,0,0,0.3), 0 0 0 1px ' + (m.be + ('55, 0 0 14px ' + (m.be + '33')))),
					$elm$html$Html$Events$onClick(msg),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-label',
					(seconds < 0) ? 'Back 15 seconds' : 'Forward 15 seconds')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					(seconds < 0) ? '-15' : '+15')
				]));
	});
var $author$project$View$Player$controls = F2(
	function (m, player) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center justify-center gap-6 sm:gap-8 mt-2 w-full')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$View$Player$skipButton,
					m,
					-15,
					$author$project$Model$PlayerSeekRequested(
						A2($elm$core$Basics$max, 0, player.dm - 15))),
					A2($author$project$View$Player$bigPlayButton, m, player),
					A3(
					$author$project$View$Player$skipButton,
					m,
					15,
					$author$project$Model$PlayerSeekRequested(player.dm + 15))
				]));
	});
var $author$project$View$Player$identityBlock = function (m) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col items-center gap-1.5 sm:gap-2 text-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-gold-brass/60 text-[10px] tracking-[0.45em] uppercase')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Service$MeditationData$elementToString(m.bl) + (' · ' + ($author$project$Service$MeditationData$chakraToString(m.bb) + ' Chakra')))
					])),
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-display text-4xl sm:text-5xl text-gold-soft leading-[1]')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$em,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('italic-display')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(m.bG)
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/65 text-sm sm:text-base italic font-display max-w-md leading-relaxed')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(m.bi)
					]))
			]));
};
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$View$Player$audioBars = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('audio-react-bars absolute inset-0 pointer-events-none')
		]),
	A2(
		$elm$core$List$map,
		function (i) {
			var angle = i * 45;
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'--a',
						$elm$core$String$fromFloat(angle) + 'deg'),
						A2($elm$html$Html$Attributes$style, '--r', '44%')
					]),
				_List_Nil);
		},
		A2($elm$core$List$range, 0, 7)));
var $author$project$View$Player$audioMotes = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('audio-motes absolute inset-0 pointer-events-none')
		]),
	A2(
		$elm$core$List$map,
		function (i) {
			var dur = $elm$core$String$fromFloat(
				5 + A2($elm$core$Basics$modBy, 3, i)) + 's';
			var delay = $elm$core$String$fromFloat(i * 0.4) + 's';
			var angle = i * 30;
			return A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'--a',
						$elm$core$String$fromFloat(angle) + 'deg'),
						A2($elm$html$Html$Attributes$style, '--r', '46%'),
						A2($elm$html$Html$Attributes$style, '--mote-delay', delay),
						A2($elm$html$Html$Attributes$style, '--mote-dur', dur)
					]),
				_List_Nil);
		},
		A2($elm$core$List$range, 0, 11)));
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$View$Player$entranceBurst = function (m) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('juice-burst absolute inset-0 pointer-events-none'),
				A2($elm$html$Html$Attributes$style, '--burst-color', m.be)
			]),
		A2(
			$elm$core$List$repeat,
			12,
			A2($elm$html$Html$i, _List_Nil, _List_Nil)));
};
var $author$project$View$Player$medallion = F2(
	function (m, player) {
		var isPlaying = _Utils_eq(player.a5, $author$project$Model$AudioPlaying);
		var reactiveLayer = function (extra) {
			return isPlaying ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(extra)
					]),
				_List_Nil) : $elm$html$Html$text('');
		};
		var breathing = isPlaying ? 'compass-pulse' : '';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('relative aspect-square flex items-center justify-center'),
					A2($elm$html$Html$Attributes$style, 'width', 'clamp(140px, min(40vw, 36vh), 18rem)')
				]),
			_List_fromArray(
				[
					$author$project$View$Player$entranceBurst(m),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'absolute inset-0 rounded-full blur-3xl ' + (isPlaying ? 'audio-react-aurora' : '')),
							A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 50% 50%, ' + (m.be + ('66 0%, ' + (m.be + '22 45%, transparent 70%), radial-gradient(circle at 50% 50%, oklch(86% 0.18 92 / 0.28) 0%, transparent 60%)')))),
							A2($elm$html$Html$Attributes$style, 'mix-blend-mode', 'screen')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$viewBox('0 0 320 320'),
							$elm$svg$Svg$Attributes$class(
							'absolute inset-0 w-full h-full ' + (breathing + (isPlaying ? ' audio-react-scale' : '')))
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('160'),
									$elm$svg$Svg$Attributes$cy('160'),
									$elm$svg$Svg$Attributes$r('152'),
									$elm$svg$Svg$Attributes$fill('none'),
									$elm$svg$Svg$Attributes$stroke(m.be),
									$elm$svg$Svg$Attributes$strokeWidth('1'),
									$elm$svg$Svg$Attributes$opacity('0.55')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('160'),
									$elm$svg$Svg$Attributes$cy('160'),
									$elm$svg$Svg$Attributes$r('144'),
									$elm$svg$Svg$Attributes$fill('none'),
									$elm$svg$Svg$Attributes$stroke('#D4AF37'),
									$elm$svg$Svg$Attributes$strokeWidth('0.6'),
									$elm$svg$Svg$Attributes$opacity('0.4')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$viewBox('0 0 320 320'),
							$elm$svg$Svg$Attributes$class('absolute inset-0 w-full h-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx('160'),
									$elm$svg$Svg$Attributes$cy('160'),
									$elm$svg$Svg$Attributes$r('120'),
									$elm$svg$Svg$Attributes$fill('none'),
									$elm$svg$Svg$Attributes$stroke('url(#rimGold)'),
									$elm$svg$Svg$Attributes$strokeWidth('1.5'),
									$elm$svg$Svg$Attributes$opacity('0.7')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$defs,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$linearGradient,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id('rimGold'),
											$elm$svg$Svg$Attributes$x1('0%'),
											$elm$svg$Svg$Attributes$y1('0%'),
											$elm$svg$Svg$Attributes$x2('100%'),
											$elm$svg$Svg$Attributes$y2('100%')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$stop,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$offset('0%'),
													$elm$svg$Svg$Attributes$stopColor('#FFD700')
												]),
											_List_Nil),
											A2(
											$elm$svg$Svg$stop,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$offset('50%'),
													$elm$svg$Svg$Attributes$stopColor('#fff8c8')
												]),
											_List_Nil),
											A2(
											$elm$svg$Svg$stop,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$offset('100%'),
													$elm$svg$Svg$Attributes$stopColor('#D4AF37')
												]),
											_List_Nil)
										]))
								]))
						])),
					isPlaying ? $author$project$View$Player$audioBars : $elm$html$Html$text(''),
					isPlaying ? $author$project$View$Player$audioMotes : $elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'relative w-44 h-44 sm:w-52 sm:h-52 rounded-full flex items-center justify-center ' + (isPlaying ? 'audio-react-scale audio-react-glow' : '')),
							A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 30% 25%, ' + (m.be + (' 0%, ' + (m.be + ('88 50%, ' + (m.be + '33 100%)')))))),
							A2($elm$html$Html$Attributes$style, 'box-shadow', 'inset 0 2px 0 rgba(255,255,255,0.4), inset 0 -3px 8px rgba(0,0,0,0.4), 0 0 30px ' + (m.be + '55')),
							A2($elm$html$Html$Attributes$style, 'color', m.be)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('font-display italic-display text-7xl sm:text-8xl'),
									A2($elm$html$Html$Attributes$style, 'color', 'rgba(2, 0, 10, 0.85)'),
									A2($elm$html$Html$Attributes$style, 'text-shadow', '0 2px 0 rgba(255,255,255,0.25), 0 -1px 0 rgba(0,0,0,0.3)')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$String$left, 1, m.bG))
								]))
						])),
					reactiveLayer('')
				]));
	});
var $author$project$View$Player$formatTime = function (seconds) {
	var total = $elm$core$Basics$floor(seconds);
	var s = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$core$Basics$modBy, 60, total)));
	var m = (total / 60) | 0;
	return $elm$core$String$fromInt(m) + (':' + s);
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$View$Player$progressBar = function (player) {
	var hasDuration = player.cG > 0;
	var pct = hasDuration ? A3($elm$core$Basics$clamp, 0, 100, (player.dm / player.cG) * 100) : 0;
	var pctStr = $elm$core$String$fromFloat(pct) + '%';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-2 w-full')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('scrubber'),
						A2($elm$html$Html$Attributes$attribute, 'style', '--progress: ' + pctStr),
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'false')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('scrubber__track')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('scrubber__thread'),
								A2($elm$html$Html$Attributes$style, 'width', pctStr)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('scrubber__shimmer'),
								A2($elm$html$Html$Attributes$style, 'width', pctStr)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('scrubber__ticks')
							]),
						A2(
							$elm$core$List$repeat,
							6,
							A2($elm$html$Html$i, _List_Nil, _List_Nil))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('scrubber__comet'),
								A2($elm$html$Html$Attributes$style, 'left', 'calc(' + (pctStr + ' - 70px)'))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('scrubber__bubble'),
								A2($elm$html$Html$Attributes$style, 'left', pctStr),
								A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$View$Player$formatTime(player.dm))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('scrubber__thumb'),
								A2($elm$html$Html$Attributes$style, 'left', pctStr)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('range'),
								$elm$html$Html$Attributes$min('0'),
								$elm$html$Html$Attributes$max(
								$elm$core$String$fromFloat(
									A2($elm$core$Basics$max, 1, player.cG))),
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromFloat(player.dm)),
								$elm$html$Html$Attributes$step('0.1'),
								$elm$html$Html$Attributes$class('scrubber__input'),
								$elm$html$Html$Attributes$disabled(!hasDuration),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Seek meditation'),
								A2(
								$elm$html$Html$Attributes$attribute,
								'aria-valuetext',
								$author$project$View$Player$formatTime(player.dm) + (' of ' + $author$project$View$Player$formatTime(player.cG))),
								A2(
								$elm$html$Html$Events$on,
								'input',
								A2(
									$elm$json$Json$Decode$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$toFloat,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Maybe$withDefault(0),
											$author$project$Model$PlayerSeekRequested)),
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['target', 'value']),
										$elm$json$Json$Decode$string)))
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex justify-between text-[11px] text-cream/55 font-mono tracking-[0.18em] tabular-nums px-1')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gold-soft/80')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$View$Player$formatTime(player.dm))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/45')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$View$Player$formatTime(player.cG))
							]))
					]))
			]));
};
var $author$project$View$Player$statusLine = function (player) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('min-h-12 flex items-center justify-center transition-opacity duration-500')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = player.a5;
				switch (_v0.$) {
					case 4:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col items-center gap-3 max-w-sm text-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-cream/65 italic font-display text-sm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('The audio is taking a moment. Tap below to try again.')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tap juice-tap juice-magnet juice-halo gold-leaf px-7 py-3 rounded-full font-semibold text-xs tracking-[0.25em] uppercase'),
											$elm$html$Html$Events$onClick($author$project$Model$PlayerPlayPause)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Try again')
										]))
								]));
					case 1:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/45 text-xs tracking-[0.3em] uppercase juice-fade-in')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Loading…')
								]));
					case 2:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/45 italic font-display text-sm tracking-wide pulse-soft juice-fade-in')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Breathe in. Breathe out.')
								]));
					case 3:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/45 italic font-display text-sm tracking-wide juice-fade-in')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Resume when you\'re ready.')
								]));
					default:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/40 text-[11px] tracking-[0.35em] uppercase juice-fade-in')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Tap play to begin')
								]));
				}
			}()
			]));
};
var $author$project$Model$PlayerLeft = {$: 47};
var $author$project$View$Player$topBar = function (status) {
	var _v0 = function () {
		switch (status.$) {
			case 2:
				return _Utils_Tuple3('Now Playing', 'text-gold tracking-[0.4em] juice-pulse-soft', 'bg-gold animate-pulse');
			case 1:
				return _Utils_Tuple3('Loading', 'text-gold-soft/70 tracking-[0.4em]', 'bg-gold-soft/70 animate-pulse');
			case 3:
				return _Utils_Tuple3('Paused', 'text-cream/55 tracking-[0.4em]', 'bg-cream/45');
			case 4:
				return _Utils_Tuple3('Reconnecting', 'text-gold-brass/75 tracking-[0.4em]', 'bg-gold-brass/75 animate-pulse');
			default:
				return _Utils_Tuple3('Ready', 'text-gold-brass/60 tracking-[0.4em]', 'bg-gold-brass/60');
		}
	}();
	var label = _v0.a;
	var labelClass = _v0.b;
	var dotClass = _v0.c;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('self-stretch flex items-center justify-between -mx-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/app'),
						$elm$html$Html$Events$onClick($author$project$Model$PlayerLeft),
						$elm$html$Html$Attributes$class('tap juice-tap juice-magnet inline-flex items-center gap-2 px-3 py-2 -my-2 rounded-full text-cream/65 text-xs tracking-[0.25em] uppercase hover:text-gold-soft transition-colors'),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Back to compass')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('← Compass')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inline-flex items-center gap-2 text-[10px] uppercase pr-2 ' + labelClass),
						A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-1.5 h-1.5 rounded-full ' + dotClass)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))
					]))
			]));
};
var $author$project$View$Player$playerCard = F2(
	function (m, player) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('editorial-stage editorial-stage--xl editorial-stage--player editorial-stage--ignite relative w-full mx-auto juice-stagger'),
					A2($elm$html$Html$Attributes$style, 'max-width', 'clamp(880px, 88vw, 1280px)'),
					A2($elm$html$Html$Attributes$attribute, 'data-player-card', '')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative w-full mb-2 sm:mb-3')
						]),
					_List_fromArray(
						[
							$author$project$View$Player$topBar(player.a5)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col items-center gap-4 sm:gap-5 lg:gap-6 w-full')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative juice-hero-arrive')
								]),
							_List_fromArray(
								[
									A2($author$project$View$Player$medallion, m, player)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative w-full max-w-md')
								]),
							_List_fromArray(
								[
									$author$project$View$Player$identityBlock(m)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative w-full max-w-xl audio-react-glow')
								]),
							_List_fromArray(
								[
									$author$project$View$Player$progressBar(player)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative w-full flex justify-center')
								]),
							_List_fromArray(
								[
									A2($author$project$View$Player$controls, m, player)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative mt-2 sm:mt-3')
						]),
					_List_fromArray(
						[
							$author$project$View$Player$statusLine(player)
						]))
				]));
	});
var $author$project$View$Player$viewportParticles = function (m) {
	var seeds = _List_fromArray(
		[
			{c: 0, d: 14, e: 6, f: -10, g: 4, h: 5, i: 18},
			{c: 1.4, d: 17, e: -4, f: 12, g: 5, h: 12, i: 70},
			{c: 0.6, d: 13, e: 8, f: -7, g: 3, h: 18, i: 32},
			{c: 2.1, d: 19, e: 3, f: -9, g: 4, h: 22, i: 88},
			{c: 0.9, d: 16, e: -3, f: 10, g: 6, h: 8, i: 52},
			{c: 2.8, d: 18, e: 5, f: 8, g: 4, h: 28, i: 12},
			{c: 1.2, d: 15, e: -7, f: -8, g: 5, h: 34, i: 76},
			{c: 0.3, d: 20, e: 4, f: -6, g: 3, h: 16, i: 95},
			{c: 1.7, d: 14, e: -7, f: 9, g: 4, h: 95, i: 22},
			{c: 0.5, d: 17, e: 5, f: -11, g: 5, h: 88, i: 64},
			{c: 2.4, d: 13, e: -8, f: 6, g: 3, h: 82, i: 38},
			{c: 1.0, d: 19, e: -3, f: -7, g: 4, h: 78, i: 86},
			{c: 2.0, d: 16, e: 3, f: 9, g: 6, h: 92, i: 48},
			{c: 0.7, d: 18, e: -5, f: 10, g: 4, h: 72, i: 14},
			{c: 1.5, d: 15, e: 6, f: -9, g: 5, h: 66, i: 72},
			{c: 2.6, d: 20, e: -4, f: -8, g: 3, h: 84, i: 92},
			{c: 0.4, d: 14, e: 3, f: 8, g: 4, h: 38, i: 5},
			{c: 1.8, d: 17, e: -2, f: 7, g: 5, h: 50, i: 8},
			{c: 2.2, d: 13, e: 2, f: 10, g: 3, h: 62, i: 4},
			{c: 0.8, d: 19, e: 4, f: -10, g: 4, h: 44, i: 96},
			{c: 1.6, d: 16, e: -3, f: -8, g: 5, h: 56, i: 92},
			{c: 0.0, d: 22, e: 4, f: -3, g: 3, h: 40, i: 45},
			{c: 1.1, d: 22, e: -4, f: 3, g: 3, h: 60, i: 55},
			{c: 2.3, d: 21, e: 3, f: 2, g: 3, h: 35, i: 65},
			{c: 0.5, d: 21, e: -3, f: -2, g: 3, h: 65, i: 35},
			{c: 1.9, d: 23, e: 2, f: 4, g: 3, h: 48, i: 28},
			{c: 2.7, d: 23, e: -2, f: -4, g: 3, h: 52, i: 78},
			{c: 0.2, d: 20, e: 5, f: 0, g: 3, h: 30, i: 50}
		]);
	var moteFor = function (seed) {
		return A3(
			$elm$html$Html$node,
			'i',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'--pf-x',
					$elm$core$String$fromFloat(seed.h) + '%'),
					A2(
					$elm$html$Html$Attributes$style,
					'--pf-y',
					$elm$core$String$fromFloat(seed.i) + '%'),
					A2(
					$elm$html$Html$Attributes$style,
					'--pf-dx',
					$elm$core$String$fromFloat(seed.e) + 'vw'),
					A2(
					$elm$html$Html$Attributes$style,
					'--pf-dy',
					$elm$core$String$fromFloat(seed.f) + 'vh'),
					A2(
					$elm$html$Html$Attributes$style,
					'--pf-dur',
					$elm$core$String$fromFloat(seed.d) + 's'),
					A2(
					$elm$html$Html$Attributes$style,
					'--pf-delay',
					$elm$core$String$fromFloat(seed.c) + 's'),
					A2(
					$elm$html$Html$Attributes$style,
					'--pf-size',
					$elm$core$String$fromInt(seed.g) + 'px'),
					A2($elm$html$Html$Attributes$style, '--pf-tint', m.be + 'ee')
				]),
			_List_Nil);
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('player-particles hidden lg:block')
			]),
		A2($elm$core$List$map, moteFor, seeds));
};
var $author$project$View$Player$view = F4(
	function (audioBaseUrl, player, maybeMed, meditationVolume) {
		if (maybeMed.$ === 1) {
			return {
				cs: _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex flex-col items-center gap-5 py-20 sm:py-24 text-center px-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('font-display text-gold-soft italic-display leading-tight'),
										A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(2.25rem, 10vw, 2.5rem)')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Lost the signal')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-cream/60 text-base')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('We couldn\'t find that meditation.')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/app'),
										$elm$html$Html$Attributes$class('tap mt-2 px-8 py-3.5 rounded-full bg-gold text-ink font-semibold tracking-[0.22em] uppercase text-sm')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back to compass')
									]))
							]))
					]),
				dE: 'Off course'
			};
		} else {
			var m = maybeMed.a;
			return {
				cs: _List_fromArray(
					[
						$author$project$Service$AudioService$player(
						{
							da: $author$project$Model$PlayerDurationLoaded,
							db: $author$project$Model$PlayerEnded,
							dc: $author$project$Model$PlayerErrored,
							dd: $author$project$Model$PlayerNativePaused,
							de: $author$project$Model$PlayerNativeStarted,
							dl: _Utils_eq(player.a5, $author$project$Model$AudioPlaying),
							dm: player.dm,
							dy: A2($author$project$Service$MeditationData$audioUrl, audioBaseUrl, m),
							dE: m.bG,
							cj: meditationVolume
						}),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('player-arrival-bloom')
							]),
						_List_Nil),
						A3(
						$elm$html$Html$node,
						'meditation-starfield',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fixed inset-0 z-0 pointer-events-none'),
								A2($elm$html$Html$Attributes$style, 'color', m.be)
							]),
						_List_Nil),
						$author$project$View$Player$viewportParticles(m),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('relative w-full max-w-full safe-pt safe-px py-3 sm:py-4 z-10 flex flex-col items-center')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('constellation audio-react-aurora hidden lg:block')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('hidden xl:block absolute left-[5%] 2xl:left-[8%] top-1/2 -translate-y-1/2 z-10 juice-drift-in-left')
									]),
								_List_fromArray(
									[
										$author$project$View$Player$breathPanel(m)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('hidden xl:block absolute right-[5%] 2xl:right-[8%] top-1/2 -translate-y-1/2 z-10 juice-drift-in-right')
									]),
								_List_fromArray(
									[
										$author$project$View$Player$lisaNote(m)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('relative w-full px-4 sm:px-6 flex flex-col items-center')
									]),
								_List_fromArray(
									[
										A2($author$project$View$Player$playerCard, m, player)
									]))
							]))
					]),
				dE: m.bG
			};
		}
	});
var $author$project$View$Progress$overline = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-center gap-3 text-gold-brass/70 text-[10px] uppercase tracking-[0.4em] font-medium')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Progress$header = function (progress) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col items-center text-center gap-3')
			]),
		_List_fromArray(
			[
				$author$project$View$Progress$overline('Your journey'),
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-display text-gold-soft'),
						A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(2.25rem, 10vw, 3rem)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$em,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('italic-display text-gold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Practice')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/55 text-sm max-w-xs leading-relaxed')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						function () {
							var _v0 = progress.bD;
							if (_v0.$ === 1) {
								return 'Your first meditation begins your streak.';
							} else {
								var date = _v0.a;
								return 'Most recent session ' + (date + '.');
							}
						}())
					]))
			]));
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$Progress$formatDuration = function (totalSeconds) {
	var seconds = A2($elm$core$Basics$modBy, 60, totalSeconds);
	var minutes = (totalSeconds / 60) | 0;
	return $elm$core$String$fromInt(minutes) + ('m ' + (A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(seconds)) + 's'));
};
var $author$project$View$Progress$sessionRow = function (s) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('juice-row-magnet flex items-center gap-4 px-4 py-3.5 rounded-xl border border-gold-brass/15 bg-ink-soft/30 cursor-default')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-1.5 h-12 rounded-full'),
						A2(
						$elm$html$Html$Attributes$style,
						'background',
						s.cz ? 'linear-gradient(180deg, #FFD700 0%, #D4AF37 100%)' : 'rgba(212,175,55,0.3)')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-1 min-w-0')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/95 font-medium text-sm truncate')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(s.cY)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/45 text-[11px] mt-0.5 tracking-wide')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$String$left, 10, s.dz) + (' · ' + $author$project$View$Progress$formatDuration(s.cH)))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						s.cz ? 'text-[9px] text-gold tracking-[0.25em] font-semibold uppercase shrink-0 px-2 py-1 rounded-full bg-gold/10 border border-gold/30' : 'text-[9px] text-cream/30 tracking-[0.25em] uppercase shrink-0')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						s.cz ? 'Complete' : 'Partial')
					]))
			]));
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$View$Progress$recentSection = function (sessions) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center gap-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-display text-2xl text-gold-soft')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Recent')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-1 h-px bg-gold-brass/20')
							]),
						_List_Nil)
					])),
				$elm$core$List$isEmpty(sessions) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-4 py-12 rounded-2xl border border-dashed border-gold-brass/20 text-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/40 text-sm italic font-display')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Your sessions will appear here.')
							]))
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('juice-stagger flex flex-col gap-2')
					]),
				A2(
					$elm$core$List$map,
					$author$project$View$Progress$sessionRow,
					A2($elm$core$List$take, 12, sessions)))
			]));
};
var $author$project$View$Progress$statCard = F5(
	function (numeral, label, value, sub, active) {
		var valueClass = active ? 'font-display text-3xl sm:text-4xl text-gold tabular-nums' : 'font-display text-3xl sm:text-4xl text-cream/30 tabular-nums';
		var numericFinal = $elm$core$String$toInt(value);
		var valueEl = function () {
			if (!numericFinal.$) {
				var n = numericFinal.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(valueClass + ' juice-count'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-final',
							$elm$core$String$fromInt(n))
						]),
					_List_Nil);
			} else {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(valueClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('juice-card-lift flex flex-col items-center gap-1.5 px-1.5 sm:px-2 py-5 sm:py-6 rounded-2xl border border-gold-brass/20 bg-ink-soft/40 backdrop-blur'),
					A2(
					$elm$html$Html$Attributes$style,
					'background',
					active ? 'linear-gradient(180deg, rgba(255,215,0,0.06) 0%, rgba(26,15,48,0.4) 100%)' : '')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-display italic text-gold-brass/70 text-xs')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(numeral)
						])),
					valueEl,
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/65 text-xs uppercase tracking-[0.2em]')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/35 text-[10px] uppercase tracking-wider')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(sub)
						]))
				]));
	});
var $author$project$View$Progress$statTriad = function (progress) {
	var emDash = '—';
	var statValue = function (n) {
		return (n > 0) ? $elm$core$String$fromInt(n) : emDash;
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('juice-stagger grid grid-cols-3 gap-2 sm:gap-3')
			]),
		_List_fromArray(
			[
				A5(
				$author$project$View$Progress$statCard,
				'I',
				'Streak',
				statValue(progress.b6),
				'days',
				progress.b6 > 0),
				A5(
				$author$project$View$Progress$statCard,
				'II',
				'Sessions',
				statValue(progress.ce),
				'completed',
				progress.ce > 0),
				A5(
				$author$project$View$Progress$statCard,
				'III',
				'Time',
				statValue((progress.cd / 60) | 0),
				'minutes',
				progress.cd > 0)
			]));
};
var $author$project$View$Progress$view = function (progress) {
	return {
		cs: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('juice-page-enter juice-stagger relative flex flex-col gap-8 sm:gap-10 pt-1 max-w-md mx-auto')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('constellation-quiet')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('relative')
							]),
						_List_fromArray(
							[
								$author$project$View$Progress$header(progress)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('relative')
							]),
						_List_fromArray(
							[
								$author$project$View$Progress$statTriad(progress)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('relative')
							]),
						_List_fromArray(
							[
								$author$project$View$Progress$recentSection(progress.b1)
							]))
					]))
			]),
		dE: 'Progress'
	};
};
var $author$project$Model$SignOutClicked = {$: 20};
var $author$project$View$Settings$dangerZone = function (session) {
	if (session.$ === 2) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tap juice-tap juice-halo mt-2 self-start px-6 py-3.5 rounded-full border border-rose-400/30 text-rose-300 text-sm tracking-[0.2em] uppercase hover:bg-rose-500/10 hover:border-rose-400/50 transition-colors'),
					$elm$html$Html$Events$onClick($author$project$Model$SignOutClicked)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Sign out')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Model$CheckoutDismissReset = {$: 57};
var $author$project$Service$MeditationData$firstPremiumId = '10';
var $author$project$View$Settings$entitlementCard = function (entitlement) {
	var _v0 = function () {
		if (!entitlement.$) {
			return _Utils_Tuple3('Free', 'Three meditations · Love · Peace · Breathe', 'rgba(212,175,55,0.5)');
		} else {
			var tier = entitlement.a.cb;
			return _Utils_Tuple3(
				'Premium · ' + $author$project$Service$Entitlement$tierLabel(tier),
				'All twenty-four meditations unlocked',
				'rgba(255,215,0,0.85)');
		}
	}();
	var label = _v0.a;
	var sub = _v0.b;
	var accent = _v0.c;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-2 sm:gap-3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center gap-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-display text-xl sm:text-2xl text-gold-soft')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Membership')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-1 h-px bg-gold-brass/20')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('juice-card-lift rounded-2xl border border-gold-brass/30 px-5 py-4 sm:px-6 sm:py-5 flex flex-col gap-2'),
						A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 0% 0%, rgba(255,215,0,0.06) 0%, transparent 60%), linear-gradient(180deg, rgba(26,15,48,0.5) 0%, rgba(5,2,17,0.6) 100%)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center gap-3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('w-2 h-2 rounded-full'),
										A2($elm$html$Html$Attributes$style, 'background-color', accent),
										A2($elm$html$Html$Attributes$style, 'box-shadow', '0 0 12px ' + accent)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('font-display text-2xl text-gold-soft')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/55 text-sm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(sub)
							])),
						function () {
						if (!entitlement.$) {
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('tap juice-tap juice-magnet juice-halo gold-leaf mt-3 px-6 py-3.5 rounded-full font-semibold text-center text-sm tracking-[0.2em] uppercase'),
										$elm$html$Html$Events$onClick(
										$author$project$Model$PaywallOpened($author$project$Service$MeditationData$firstPremiumId))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Unlock all meditations')
									]));
						} else {
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('tap juice-tap mt-3 px-5 py-2.5 rounded-full text-xs tracking-[0.25em] uppercase border border-cream/15 text-cream/55 hover:text-rose-300 hover:border-rose-400/40 transition-colors self-start'),
										$elm$html$Html$Events$onClick($author$project$Model$CheckoutDismissReset)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reset demo entitlement')
									]));
						}
					}()
					]))
			]));
};
var $author$project$View$Settings$envFooter = function (env) {
	return (env === 'production') ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col items-center gap-2 mt-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/app/paywall-lab'),
						$elm$html$Html$Attributes$class('text-cream/45 text-[10px] tracking-[0.35em] uppercase hover:text-gold-soft transition-colors')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Paywall lab →')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/25 text-[10px] text-center font-mono tracking-wider')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('env · ' + env)
					]))
			]));
};
var $author$project$Model$GuideReopened = {$: 25};
var $author$project$View$Settings$guideCard = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-2 sm:gap-3')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center gap-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-display text-xl sm:text-2xl text-gold-soft')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Guide')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-1 h-px bg-gold-brass/20')
						]),
					_List_Nil)
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('juice-card-lift rounded-2xl border border-gold-brass/30 px-5 py-4 sm:px-6 sm:py-5'),
					A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 0% 0%, rgba(255,215,0,0.06) 0%, transparent 60%), linear-gradient(180deg, rgba(26,15,48,0.5) 0%, rgba(5,2,17,0.6) 100%)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-between gap-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col gap-0.5')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-display text-gold-soft text-lg')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('How to read the compass')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-cream/55 text-xs')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Three short beats, over the live dial')
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tap juice-tap px-5 py-2.5 rounded-full text-xs tracking-[0.25em] uppercase border border-gold-brass/40 text-gold-soft hover:border-gold-brass/70 hover:bg-gold-brass/10 transition-colors shrink-0'),
									$elm$html$Html$Events$onClick($author$project$Model$GuideReopened)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Replay')
								]))
						]))
				]))
		]));
var $author$project$View$Settings$overline = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-center gap-3 text-gold-brass/70 text-[10px] uppercase tracking-[0.4em] font-medium')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Settings$header = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col items-center text-center gap-2 sm:gap-3')
		]),
	_List_fromArray(
		[
			$author$project$View$Settings$overline('Settings'),
			A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-display text-gold-soft leading-none'),
					A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(1.75rem, 8vw, 2.5rem)')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$em,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('italic-display text-gold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Helm')
						]))
				]))
		]));
var $author$project$View$Settings$legalLink = F2(
	function (path, label) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(path),
					$elm$html$Html$Attributes$class('tap juice-tap flex items-center justify-between px-2 py-4 text-cream/70 hover:text-gold-soft transition-colors border-b border-gold-brass/10 rounded-xl')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gold-brass/50 text-lg')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('→')
						]))
				]));
	});
var $author$project$View$Settings$legalLinks = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col gap-1 text-sm')
		]),
	_List_fromArray(
		[
			A2($author$project$View$Settings$legalLink, '/about', 'About Lisa & the Compass')
		]));
var $author$project$View$Settings$profileCard = function (session) {
	var _v0 = function () {
		if (session.$ === 2) {
			var user = session.a;
			return _Utils_Tuple3(
				'Signed in as',
				A2($elm$core$Maybe$withDefault, user.aa, user.br),
				user.aa);
		} else {
			return _Utils_Tuple3('Status', 'Not signed in', '');
		}
	}();
	var label = _v0.a;
	var name = _v0.b;
	var email = _v0.c;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('juice-card-lift rounded-2xl border border-gold-brass/30 px-5 py-4 sm:px-6 sm:py-6 flex flex-col gap-1.5 sm:gap-3'),
				A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 0% 0%, rgba(255,215,0,0.06) 0%, transparent 60%), linear-gradient(180deg, rgba(26,15,48,0.5) 0%, rgba(5,2,17,0.6) 100%)')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/45 text-[10px] tracking-[0.4em] uppercase')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('font-display text-2xl sm:text-3xl text-gold-soft leading-tight')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				((email !== '') && (!_Utils_eq(email, name))) ? A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-cream/55 text-xs sm:text-sm tracking-wide')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(email)
					])) : $elm$html$Html$text('')
			]));
};
var $author$project$Service$Referral$label = function (r) {
	return 'Referred by ' + $author$project$Service$Referral$code(r);
};
var $author$project$Service$Referral$source = function (_v0) {
	var r = _v0;
	var _v1 = r.aX;
	if (!_v1) {
		return 'url';
	} else {
		return 'storage';
	}
};
var $author$project$View$Settings$referralBadge = function (maybeRef) {
	if (maybeRef.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var ref = maybeRef.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex items-center justify-between gap-3 px-4 py-3 rounded-2xl border border-gold-brass/20 bg-gold/5')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center gap-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gold text-lg')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('★')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-col gap-0.5')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-cream/85 text-sm font-medium')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Service$Referral$label(ref))
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-cream/45 text-[10px] tracking-[0.3em] uppercase')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'source · ' + $author$project$Service$Referral$source(ref))
										]))
								]))
						]))
				]));
	}
};
var $author$project$Model$MeditationVolumeChanged = function (a) {
	return {$: 62, a: a};
};
var $author$project$Model$SoundtrackToggled = function (a) {
	return {$: 60, a: a};
};
var $author$project$Model$SoundtrackVolumeChanged = function (a) {
	return {$: 61, a: a};
};
var $author$project$View$Settings$toggleSwitch = F2(
	function (on, onChange) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tap juice-tap relative w-14 h-8 rounded-full'),
					A2($elm$html$Html$Attributes$style, 'transition', 'background 200ms ease, border-color 200ms ease, box-shadow 200ms ease'),
					A2(
					$elm$html$Html$Attributes$style,
					'border',
					on ? '1px solid oklch(80% 0.16 90 / 0.9)' : '1px solid rgba(199, 164, 102, 0.35)'),
					A2(
					$elm$html$Html$Attributes$style,
					'background',
					on ? 'linear-gradient(180deg, oklch(76% 0.15 88) 0%, oklch(60% 0.13 80) 100%)' : 'rgba(14, 12, 30, 0.65)'),
					A2(
					$elm$html$Html$Attributes$style,
					'box-shadow',
					on ? 'inset 0 1px 3px rgba(0, 0, 0, 0.35), 0 0 10px oklch(86% 0.18 92 / 0.25)' : 'inset 0 1px 3px rgba(0, 0, 0, 0.5)'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'switch'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-checked',
					on ? 'true' : 'false'),
					$elm$html$Html$Events$onClick(
					onChange(!on))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute top-1/2 w-6 h-6 rounded-full'),
							A2($elm$html$Html$Attributes$style, 'transition', 'left 260ms cubic-bezier(0.34, 1.56, 0.64, 1), background 200ms ease, box-shadow 200ms ease, transform 200ms ease'),
							A2(
							$elm$html$Html$Attributes$style,
							'transform',
							on ? 'translateY(-50%)' : 'translateY(-50%) scale(0.85)'),
							A2(
							$elm$html$Html$Attributes$style,
							'background',
							on ? 'linear-gradient(180deg, #fffdf5 0%, #f0e6cd 100%)' : 'rgba(245, 236, 214, 0.55)'),
							A2(
							$elm$html$Html$Attributes$style,
							'box-shadow',
							on ? '0 1px 3px rgba(0, 0, 0, 0.45), inset 0 -1px 2px rgba(160, 128, 60, 0.4)' : '0 1px 2px rgba(0, 0, 0, 0.4)'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							on ? 'calc(100% - 28px)' : '4px')
						]),
					_List_Nil)
				]));
	});
var $author$project$View$Settings$volumeSlider = F3(
	function (label, value, onChange) {
		var pct = value * 100;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col gap-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex items-center justify-between text-xs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-cream/65 tracking-wide')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gold-brass/70 tabular-nums font-mono')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$elm$core$Basics$round(pct)) + '%')
								]))
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('range'),
							$elm$html$Html$Attributes$min('0'),
							$elm$html$Html$Attributes$max('100'),
							$elm$html$Html$Attributes$step('1'),
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromInt(
								$elm$core$Basics$round(pct))),
							A2(
							$elm$html$Html$Attributes$style,
							'--progress',
							$elm$core$String$fromInt(
								$elm$core$Basics$round(pct)) + '%'),
							A2(
							$elm$html$Html$Events$on,
							'input',
							A2(
								$elm$json$Json$Decode$andThen,
								function (v) {
									var _v0 = $elm$core$String$toFloat(v);
									if (!_v0.$) {
										var n = _v0.a;
										return $elm$json$Json$Decode$succeed(
											onChange(n / 100));
									} else {
										return $elm$json$Json$Decode$fail('not a number');
									}
								},
								$elm$html$Html$Events$targetValue))
						]),
					_List_Nil)
				]));
	});
var $author$project$View$Settings$soundtrackCard = function (s) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-2 sm:gap-3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center gap-3')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-display text-xl sm:text-2xl text-gold-soft')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Sound')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex-1 h-px bg-gold-brass/20')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('juice-card-lift rounded-2xl border border-gold-brass/30 px-5 py-4 sm:px-6 sm:py-5 flex flex-col gap-4 sm:gap-5'),
						A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 0% 0%, rgba(255,215,0,0.06) 0%, transparent 60%), linear-gradient(180deg, rgba(26,15,48,0.5) 0%, rgba(5,2,17,0.6) 100%)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center justify-between gap-3')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-col gap-0.5')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-display text-gold-soft text-lg')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Ambient soundtrack')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-cream/55 text-xs')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Brass Astrolabe · 77 BPM')
											]))
									])),
								A2($author$project$View$Settings$toggleSwitch, s.bm, $author$project$Model$SoundtrackToggled)
							])),
						s.bm ? A3($author$project$View$Settings$volumeSlider, 'Soundtrack volume', s.cj, $author$project$Model$SoundtrackVolumeChanged) : $elm$html$Html$text(''),
						A3($author$project$View$Settings$volumeSlider, 'Meditation volume', s.bF, $author$project$Model$MeditationVolumeChanged)
					]))
			]));
};
var $author$project$View$Settings$view = F5(
	function (session, entitlement, referral, soundtrack, links) {
		return {
			cs: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('juice-page-enter juice-stagger relative flex flex-col gap-4 sm:gap-8 pt-1 max-w-md mx-auto')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('constellation-quiet')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[$author$project$View$Settings$header])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[
									$author$project$View$Settings$profileCard(session)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[
									$author$project$View$Settings$soundtrackCard(soundtrack)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[$author$project$View$Settings$guideCard])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[
									$author$project$View$Settings$entitlementCard(entitlement)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[
									$author$project$View$Settings$referralBadge(referral)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[$author$project$View$Settings$legalLinks])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[
									$author$project$View$Settings$dangerZone(session)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative')
								]),
							_List_fromArray(
								[
									$author$project$View$Settings$envFooter(links.aL)
								]))
						]))
				]),
			dE: 'Settings'
		};
	});
var $author$project$Model$SignupCodeChanged = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$SignupCodeSubmit = {$: 12};
var $author$project$View$Signup$statusBlock = function (status) {
	switch (status.$) {
		case 2:
			var msg = status.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-start gap-3 px-4 py-3 rounded-2xl border border-gold-brass/30 bg-ink-soft/40 juice-fade-in')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-gold-soft text-lg leading-none mt-px shrink-0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('✦')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/85 text-sm leading-relaxed text-left')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(msg)
							]))
					]));
		case 1:
			return $elm$html$Html$text('');
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$View$Signup$codeView = function (formState) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-7')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-display text-gold-soft'),
								A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(1.875rem, 8.5vw, 2.5rem)')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Check your '),
								A2(
								$elm$html$Html$em,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('italic-display text-gold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('email.')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/65 text-sm mt-3 break-words')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('We sent a six-digit code to '),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-gold-soft')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(formState.aa)
									])),
								$elm$html$Html$text('.')
							]))
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-3'),
						$elm$html$Html$Events$onSubmit($author$project$Model$SignupCodeSubmit)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('w-full px-5 py-5 rounded-2xl bg-ink-soft/60 border border-gold-brass/25 text-cream placeholder:text-cream/25 focus:outline-none focus:border-gold/70 focus:bg-ink-soft/80 transition-colors text-3xl text-center tracking-[0.45em] font-mono'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$name('code'),
								A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'one-time-code'),
								A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'),
								A2($elm$html$Html$Attributes$attribute, 'pattern', '[0-9]{6}'),
								$elm$html$Html$Attributes$maxlength(6),
								$elm$html$Html$Attributes$placeholder('000000'),
								$elm$html$Html$Attributes$value(formState.ch),
								$elm$html$Html$Events$onInput($author$project$Model$SignupCodeChanged),
								$elm$html$Html$Attributes$required(true)
							]),
						_List_Nil),
						$author$project$View$Signup$statusBlock(formState.N),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tap gold-leaf shimmer-button juice-tap juice-magnet juice-halo mt-2 px-6 py-4 rounded-full font-semibold text-sm tracking-[0.22em] uppercase disabled:opacity-50'),
								$elm$html$Html$Attributes$type_('submit'),
								$elm$html$Html$Attributes$disabled(
								_Utils_eq(formState.N, $author$project$Model$FormSubmitting) || ($elm$core$String$length(formState.ch) < 6))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								_Utils_eq(formState.N, $author$project$Model$FormSubmitting) ? 'Verifying…' : 'Verify and begin')
							]))
					]))
			]));
};
var $author$project$Model$SignupEmailChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$SignupFirstNameChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$SignupPasswordChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$SignupSubmit = {$: 10};
var $author$project$View$Signup$field = F6(
	function (fieldName, fieldType, autocomplete, labelText, value_, onChange) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full px-5 py-4 rounded-2xl bg-ink-soft/60 border border-gold-brass/25 text-cream placeholder:text-cream/35 focus:outline-none focus:border-gold/70 focus:bg-ink-soft/80 transition-colors text-base'),
					$elm$html$Html$Attributes$type_(fieldType),
					$elm$html$Html$Attributes$name(fieldName),
					A2($elm$html$Html$Attributes$attribute, 'autocomplete', autocomplete),
					$elm$html$Html$Attributes$placeholder(labelText),
					$elm$html$Html$Attributes$value(value_),
					$elm$html$Html$Events$onInput(onChange),
					$elm$html$Html$Attributes$required(true)
				]),
			_List_Nil);
	});
var $elm$html$Html$Attributes$minlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'minLength',
		$elm$core$String$fromInt(n));
};
var $author$project$View$Signup$passwordField = F2(
	function (value_, onChange) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full px-5 py-4 rounded-2xl bg-ink-soft/60 border border-gold-brass/25 text-cream placeholder:text-cream/35 focus:outline-none focus:border-gold/70 focus:bg-ink-soft/80 transition-colors text-base'),
					$elm$html$Html$Attributes$type_('password'),
					$elm$html$Html$Attributes$name('new-password'),
					A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'new-password'),
					$elm$html$Html$Attributes$placeholder('Password (8+ characters)'),
					$elm$html$Html$Attributes$value(value_),
					$elm$html$Html$Events$onInput(onChange),
					$elm$html$Html$Attributes$minlength(8),
					$elm$html$Html$Attributes$required(true)
				]),
			_List_Nil);
	});
var $author$project$View$Signup$credentialsView = function (formState) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex flex-col gap-7')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('font-display text-gold-soft'),
								A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(1.875rem, 8.5vw, 2.5rem)')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create your '),
								A2(
								$elm$html$Html$em,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('italic-display text-gold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('path')
									]))
							]))
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-col gap-3'),
						$elm$html$Html$Events$onSubmit($author$project$Model$SignupSubmit)
					]),
				_List_fromArray(
					[
						A6($author$project$View$Signup$field, 'given-name', 'text', 'given-name', 'First name', formState.br, $author$project$Model$SignupFirstNameChanged),
						A6($author$project$View$Signup$field, 'email', 'email', 'email', 'Email', formState.aa, $author$project$Model$SignupEmailChanged),
						A2($author$project$View$Signup$passwordField, formState.ay, $author$project$Model$SignupPasswordChanged),
						$author$project$View$Signup$statusBlock(formState.N),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tap gold-leaf shimmer-button juice-tap juice-magnet juice-halo mt-2 px-6 py-4 rounded-full font-semibold text-sm tracking-[0.22em] uppercase disabled:opacity-50'),
								$elm$html$Html$Attributes$type_('submit'),
								$elm$html$Html$Attributes$disabled(
								_Utils_eq(formState.N, $author$project$Model$FormSubmitting))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								_Utils_eq(formState.N, $author$project$Model$FormSubmitting) ? 'Sending code…' : 'Continue')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-cream/40 text-xs tracking-wide text-center mt-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Twenty-four meditations · No card required')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center text-xs text-cream/45 tracking-[0.25em] uppercase')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Already have an account? '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/login'),
								$elm$html$Html$Attributes$class('tap inline-flex px-2 text-gold-soft hover:text-gold transition-colors')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Sign in')
							]))
					]))
			]));
};
var $author$project$View$Signup$overline = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-center gap-3 text-gold-brass/70 text-[10px] uppercase tracking-[0.4em] font-medium')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-6 h-px bg-gold-brass/40')
					]),
				_List_Nil)
			]));
};
var $author$project$View$Signup$view = function (formState) {
	return {
		cs: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('editorial-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('constellation-quiet')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('editorial-stage flex flex-col gap-6 sm:gap-7')
							]),
						_List_fromArray(
							[
								$author$project$View$Signup$overline(
								function () {
									var _v0 = formState.aC;
									if (!_v0) {
										return 'Begin';
									} else {
										return 'Verify';
									}
								}()),
								function () {
								var _v1 = formState.aC;
								if (!_v1) {
									return $author$project$View$Signup$credentialsView(formState);
								} else {
									return $author$project$View$Signup$codeView(formState);
								}
							}()
							]))
					]))
			]),
		dE: 'Create account'
	};
};
var $author$project$Main$routeContent = function (model) {
	var _v0 = model.aU;
	switch (_v0.$) {
		case 0:
			return A4(
				$author$project$View$Compass$view,
				model.bf,
				$elm$core$Maybe$Nothing,
				model.cf,
				{
					aO: $elm$core$Maybe$Nothing,
					aw: model.aw,
					aD: model.aD,
					ck: $elm$core$Maybe$Just(model.am.au)
				});
		case 1:
			return $author$project$View$About$view;
		case 2:
			return $author$project$View$Onboarding$view(model.dh);
		case 3:
			return A2($author$project$View$Login$view, model.cW, model.ds);
		case 4:
			return $author$project$View$Signup$view(model.dx);
		case 5:
			return A4(
				$author$project$View$Compass$view,
				model.bf,
				$elm$core$Maybe$Nothing,
				model.cf,
				{
					aO: $elm$core$Maybe$Just(model.aO),
					aw: model.aw,
					aD: model.aD,
					ck: $elm$core$Maybe$Nothing
				});
		case 6:
			var rawId = _v0.a;
			var maybeMed = $author$project$Service$MeditationData$byIdString(rawId);
			var allowed = function () {
				var _v2 = _Utils_Tuple2(
					maybeMed,
					$author$project$Service$MeditationData$idFromString(rawId));
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var id = _v2.b.a;
					return A2($author$project$Service$Entitlement$canPlay, model.bo, id);
				} else {
					return false;
				}
			}();
			if (allowed) {
				var _v1 = model.bR;
				if (!_v1.$) {
					var p = _v1.a;
					return A4($author$project$View$Player$view, model.am.au, p, maybeMed, model.ap.bF);
				} else {
					return A4(
						$author$project$View$Player$view,
						model.am.au,
						{a5: $author$project$Model$AudioLoading, cG: 0, cX: rawId, dm: 0, dr: false, dw: $elm$core$Maybe$Nothing},
						maybeMed,
						model.ap.bF);
				}
			} else {
				return $author$project$View$Player$locked(maybeMed);
			}
		case 7:
			return $author$project$View$Progress$view(model.dn);
		case 8:
			return A5(
				$author$project$View$Settings$view,
				model.aV,
				model.bo,
				model.$7,
				model.ap,
				{aL: model.am.aL});
		case 9:
			return $author$project$View$PaywallLab$view(model.aH);
		default:
			return $author$project$View$NotFound$view;
	}
};
var $author$project$View$Layout$auroraRibbons = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A3($elm$html$Html$node, 'bg-ribbons', _List_Nil, _List_Nil),
			A3($elm$html$Html$node, 'bg-nebula', _List_Nil, _List_Nil),
			A3($elm$html$Html$node, 'bg-rings', _List_Nil, _List_Nil),
			A3($elm$html$Html$node, 'bg-constellation', _List_Nil, _List_Nil)
		]));
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$View$Layout$tabLink = F3(
	function (path, label, active) {
		var cls = active ? 'text-gold font-semibold bg-gold/10 ring-1 ring-gold-brass/30 juice-tab-pulse' : 'text-cream/60 hover:text-gold';
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(path),
					$elm$html$Html$Attributes$class(cls + ' tap juice-tap juice-ripple flex-1 px-3 py-3 mx-0.5 rounded-2xl tracking-wide transition-colors text-center min-h-[44px] flex items-center justify-center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$View$Layout$bottomBar = function (route) {
	return $author$project$Routing$isAuthRequired(route) ? A2(
		$elm$html$Html$footer,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fixed bottom-0 inset-x-0 z-30 bg-ink-soft/85 backdrop-blur-md border-t border-gold-brass/20 safe-pb safe-px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$nav,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('max-w-screen-md mx-auto flex justify-around items-stretch px-2 py-1.5 text-xs text-cream/70')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$View$Layout$tabLink,
						'/app',
						'Compass',
						_Utils_eq(route, $author$project$Routing$Compass)),
						A3(
						$author$project$View$Layout$tabLink,
						'/app/progress',
						'Progress',
						_Utils_eq(route, $author$project$Routing$Progress)),
						A3(
						$author$project$View$Layout$tabLink,
						'/app/settings',
						'Settings',
						_Utils_eq(route, $author$project$Routing$Settings))
					]))
			])) : A2(
		$elm$html$Html$footer,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-full px-4 py-6 text-center text-xs text-cream/40 safe-pb safe-px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/about'),
						$elm$html$Html$Attributes$class('tap inline-flex px-3 hover:text-gold mx-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('About')
					]))
			]));
};
var $author$project$View$Layout$brassAstrolabeMount = F2(
	function (s, deepListening) {
		var mutedAttrs = s.bm ? _List_Nil : _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'muted', '')
			]);
		var dormantAttrs = deepListening ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'dormant', '')
			]) : _List_Nil;
		return A3(
			$elm$html$Html$node,
			'brass-astrolabe',
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'track', '132bpm'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'volume',
						$elm$core$String$fromFloat(s.cj)),
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
						A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
						A2($elm$html$Html$Attributes$style, 'width', '0'),
						A2($elm$html$Html$Attributes$style, 'height', '0'),
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden')
					]),
				_Utils_ap(mutedAttrs, dormantAttrs)),
			_List_Nil);
	});
var $author$project$View$Layout$godRays = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('bg-god-rays')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-god-ray'),
					A2($elm$html$Html$Attributes$style, '--angle', '0deg')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-god-ray'),
					A2($elm$html$Html$Attributes$style, '--angle', '45deg')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-god-ray'),
					A2($elm$html$Html$Attributes$style, '--angle', '90deg')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-god-ray'),
					A2($elm$html$Html$Attributes$style, '--angle', '135deg')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-god-ray'),
					A2($elm$html$Html$Attributes$style, '--angle', '180deg')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-god-ray'),
					A2($elm$html$Html$Attributes$style, '--angle', '225deg')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-god-ray'),
					A2($elm$html$Html$Attributes$style, '--angle', '270deg')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-god-ray'),
					A2($elm$html$Html$Attributes$style, '--angle', '315deg')
				]),
			_List_Nil)
		]));
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$View$Layout$routeHasFocalCentre = function (route) {
	switch (route.$) {
		case 5:
			return true;
		case 6:
			return true;
		case 0:
			return true;
		default:
			return false;
	}
};
var $author$project$View$Layout$sealGlyphs = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('hidden md:block')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fixed left-3 lg:left-6 top-1/2 -translate-y-1/2 z-[2] pointer-events-none page-seal-glyph')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('✦')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fixed right-3 lg:right-6 top-1/2 -translate-y-1/2 z-[2] pointer-events-none page-seal-glyph')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('✦')
				]))
		]));
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$View$Layout$navLink = F2(
	function (path, label) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(path),
					$elm$html$Html$Attributes$class('tap px-3 sm:px-4 py-1.5 text-[11px] sm:text-xs tracking-[0.3em] uppercase whitespace-nowrap hover:text-gold-soft transition-colors')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$View$Layout$navSep = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('inline-block w-px h-3 bg-gold-brass/30')
		]),
	_List_Nil);
var $author$project$View$Layout$topBar = F2(
	function (route, _v0) {
		var isApp = $author$project$Routing$isAuthRequired(route);
		return (isApp || (_Utils_eq(route, $author$project$Routing$Landing) || (_Utils_eq(route, $author$project$Routing$Login) || (_Utils_eq(route, $author$project$Routing$Signup) || _Utils_eq(route, $author$project$Routing$About))))) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sticky top-0 z-30 w-full bg-ink/70 backdrop-blur-xl border-b border-gold-brass/15 safe-pt safe-px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-12 xl:px-20 py-3 sm:py-4 flex items-center justify-between gap-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('/'),
									$elm$html$Html$Attributes$class('tap inline-flex items-center gap-2.5 sm:gap-3 group')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-full border border-gold-brass/40 text-gold text-[11px] tracking-[0.2em] group-hover:border-gold/70 group-hover:text-gold-soft transition-colors')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('✦')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-display text-sm sm:text-base lg:text-lg text-gold-soft tracking-[0.2em] uppercase')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Meditation Compass')
										]))
								])),
							A2(
							$elm$html$Html$nav,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex items-center gap-0 text-cream/75')
								]),
							_List_fromArray(
								[
									A2($author$project$View$Layout$navLink, '/about', 'About'),
									$author$project$View$Layout$navSep,
									A2($author$project$View$Layout$navLink, '/login', 'Sign in')
								]))
						]))
				]));
	});
var $author$project$View$Celebration$view = function (_v0) {
	var meditationName = _v0.cY;
	var accentColor = _v0.cn;
	var newStreak = _v0.c1;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('juice-bloom'),
						A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle, ' + (accentColor + '66 0%, transparent 60%)'))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fixed inset-0 z-[101] flex items-center justify-center pointer-events-none')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('relative')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('juice-burst'),
										A2($elm$html$Html$Attributes$style, '--burst-color', accentColor),
										A2($elm$html$Html$Attributes$style, 'width', '300px'),
										A2($elm$html$Html$Attributes$style, 'height', '300px'),
										A2($elm$html$Html$Attributes$style, 'left', '50%'),
										A2($elm$html$Html$Attributes$style, 'top', '50%'),
										A2($elm$html$Html$Attributes$style, 'transform', 'translate(-50%, -50%)')
									]),
								A2(
									$elm$core$List$repeat,
									12,
									A2($elm$html$Html$i, _List_Nil, _List_Nil))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('juice-float relative text-center')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-cream/50 text-[10px] tracking-[0.45em] uppercase mb-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Session complete')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-display italic-display text-5xl text-gold'),
												A2($elm$html$Html$Attributes$style, 'text-shadow', '0 0 40px ' + accentColor)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(meditationName)
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-3 text-gold-soft/85 text-base font-display')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Day '),
												A2(
												$elm$html$Html$em,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('italic-display')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(newStreak))
													])),
												$elm$html$Html$text(' of your streak.')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Model$NoOp = {$: 59};
var $author$project$Model$PaywallDismissed = {$: 53};
var $author$project$View$Paywall$comingSoonBanner = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-gold/15 border border-gold-brass/50 text-gold-soft text-[10px] tracking-[0.3em] uppercase font-semibold')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Coming soon')
		]));
var $author$project$View$Paywall$comingSoonNotice = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('rounded-2xl border border-gold-brass/30 bg-ink-soft/40 px-4 py-4 sm:px-6 sm:py-7 flex flex-col items-center gap-2 sm:gap-3 text-center')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('font-display italic-display text-gold-soft text-lg sm:text-xl leading-tight')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Purchases open soon.')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-cream/65 text-[13px] sm:text-sm leading-relaxed max-w-md')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('The full library will be available the moment Lisa is ready to receive listeners. Until then, the four cardinal meditations are open on the compass.')
				])),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-cream/45 text-[9px] sm:text-[10px] tracking-[0.35em] uppercase mt-1')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('No real charges · No waitlist required')
				]))
		]));
var $author$project$View$Paywall$demoBanner = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-rose-500/15 border border-rose-400/40 text-rose-300 text-[10px] tracking-[0.3em] uppercase font-semibold')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Demo · No real charges')
		]));
var $author$project$View$Paywall$footer = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex flex-col items-center gap-2 mt-2')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-cream/35 text-[10px] tracking-[0.3em] uppercase text-center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Three meditations free, always · Cancel any time')
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tap text-cream/45 text-xs tracking-[0.25em] uppercase hover:text-gold-soft transition-colors mt-1 px-3 py-2 rounded-full'),
					$elm$html$Html$Events$onClick($author$project$Model$PaywallDismissed)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Maybe later')
				]))
		]));
var $author$project$View$Paywall$header = F2(
	function (meditationName, accentColor) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col items-center text-center gap-3')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-3 h-3 rounded-full'),
							A2($elm$html$Html$Attributes$style, 'background-color', accentColor),
							A2($elm$html$Html$Attributes$style, 'box-shadow', '0 0 16px ' + accentColor)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/50 text-[10px] tracking-[0.45em] uppercase')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Unlock the full library')
						])),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-display text-gold-soft text-center leading-tight'),
							A2($elm$html$Html$Attributes$style, 'font-size', 'clamp(1.625rem, 7vw, 2.25rem)')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Continue with '),
							A2(
							$elm$html$Html$em,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('italic-display text-gold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(meditationName)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-cream/65 text-sm leading-relaxed max-w-md')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('All twenty-four meditations, voiced by Lisa. Choose the path that suits you — cancel any time.')
						]))
				]));
	});
var $author$project$View$Paywall$view = F2(
	function (_v0, locked) {
		var checkout = _v0.aH;
		var checkoutMode = _v0.aI;
		var meditation = $author$project$Service$MeditationData$byId(locked);
		var meditationName = A2(
			$elm$core$Maybe$withDefault,
			'this meditation',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.bG;
				},
				meditation));
		var live = checkoutMode === 'stripe';
		var accentColor = A2(
			$elm$core$Maybe$withDefault,
			'#FFD700',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.be;
				},
				meditation));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 bg-ink/85 backdrop-blur-md overflow-y-auto safe-pt safe-pb safe-px'),
					A2($elm$html$Html$Attributes$style, 'overscroll-behavior', 'contain'),
					$elm$html$Html$Events$onClick($author$project$Model$PaywallDismissed)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('juice-spring-in relative w-full max-w-3xl my-3 sm:my-8 rounded-3xl border border-gold-brass/40 p-4 sm:p-10 flex flex-col gap-4 sm:gap-7'),
							A2($elm$html$Html$Attributes$style, 'background', 'radial-gradient(circle at 30% 0%, ' + (accentColor + '1a 0%, transparent 60%), linear-gradient(180deg, #1a0f30 0%, #02000a 100%)')),
							A2($elm$html$Html$Attributes$style, 'box-shadow', '0 0 80px ' + (accentColor + '33, inset 0 1px 0 rgba(255,255,255,0.08)')),
							A2(
							$elm$html$Html$Events$stopPropagationOn,
							'click',
							$elm$json$Json$Decode$succeed(
								_Utils_Tuple2($author$project$Model$NoOp, true)))
						]),
					live ? _List_fromArray(
						[
							$author$project$View$Paywall$demoBanner,
							A2($author$project$View$Paywall$header, meditationName, accentColor),
							$author$project$View$Paywall$benefits,
							$author$project$View$Paywall$tiers(checkout),
							$author$project$View$Paywall$footer
						]) : _List_fromArray(
						[
							$author$project$View$Paywall$comingSoonBanner,
							A2($author$project$View$Paywall$header, meditationName, accentColor),
							$author$project$View$Paywall$benefits,
							$author$project$View$Paywall$comingSoonNotice,
							$author$project$View$Paywall$footer
						]))
				]));
	});
var $author$project$View$Layout$shell = function (_v0) {
	var route = _v0.aU;
	var session = _v0.aV;
	var content = _v0.cA;
	var celebration = _v0.a8;
	var paywallFor = _v0.bP;
	var checkout = _v0.aH;
	var checkoutMode = _v0.aI;
	var soundtrack = _v0.ap;
	var deepListening = _v0.cD;
	var isPlayer = function () {
		if (route.$ === 6) {
			return true;
		} else {
			return false;
		}
	}();
	var isApp = $author$project$Routing$isAuthRequired(route);
	var mainClass = function () {
		switch (route.$) {
			case 5:
				return 'flex-1 w-full pt-0 pb-tabbar';
			case 6:
				return 'flex-1 w-full pt-0 pb-tabbar relative flex items-center justify-center';
			case 0:
				return 'flex-1 w-full pt-0 pb-10 safe-pb relative';
			default:
				return isApp ? 'flex-1 w-full max-w-screen-md mx-auto px-4 sm:px-6 pt-3 pb-tabbar safe-px' : 'flex-1 w-full max-w-screen-md mx-auto px-4 sm:px-6 pt-3 pb-10 safe-px safe-pb';
		}
	}();
	return {
		cs: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('min-h-dvh flex flex-col relative')
					]),
				_List_fromArray(
					[
						isPlayer ? $elm$html$Html$text('') : $author$project$View$Layout$auroraRibbons,
						$author$project$View$Layout$routeHasFocalCentre(route) ? $author$project$View$Layout$godRays : $elm$html$Html$text(''),
						$author$project$View$Layout$sealGlyphs,
						A2($author$project$View$Layout$topBar, route, session),
						A2(
						$elm$html$Html$main_,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(mainClass)
							]),
						content.cs),
						$author$project$View$Layout$bottomBar(route),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2($elm$core$Maybe$map, $author$project$View$Celebration$view, celebration)),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							$author$project$View$Paywall$view(
								{aH: checkout, aI: checkoutMode}),
							paywallFor)),
						A2($author$project$View$Layout$brassAstrolabeMount, soundtrack, deepListening)
					]))
			]),
		dE: content.dE + ' — Meditation Compass'
	};
};
var $author$project$Main$view = function (model) {
	return $author$project$View$Layout$shell(
		{
			a8: model.a8,
			aH: model.aH,
			aI: model.am.aI,
			cA: $author$project$Main$routeContent(model),
			cD: $author$project$Main$isDeepListening(model),
			bP: model.bP,
			aU: model.aU,
			aV: model.aV,
			ap: model.ap
		});
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{cS: $author$project$Model$init, df: $author$project$Model$UrlChanged, dg: $author$project$Model$LinkClicked, dA: $author$project$Main$subscriptions, dG: $author$project$Update$update, dJ: $author$project$Main$view});
/*
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (now) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (env) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (clerkPublishableKey) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (checkoutMode) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (audioBaseUrl) {
											return $elm$json$Json$Decode$succeed(
												{au: audioBaseUrl, aI: checkoutMode, cx: clerkPublishableKey, aL: env, c9: now});
										},
										A2($elm$json$Json$Decode$field, 'audioBaseUrl', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'checkoutMode', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'clerkPublishableKey', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'env', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'now', $elm$json$Json$Decode$int)))(0)}});}(this));
*/
export const Elm = {'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (now) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (env) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (clerkPublishableKey) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (checkoutMode) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (audioBaseUrl) {
											return $elm$json$Json$Decode$succeed(
												{au: audioBaseUrl, aI: checkoutMode, cx: clerkPublishableKey, aL: env, c9: now});
										},
										A2($elm$json$Json$Decode$field, 'audioBaseUrl', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'checkoutMode', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'clerkPublishableKey', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'env', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'now', $elm$json$Json$Decode$int)))(0)}};
  